import type { Dict } from '../types';

export const fa: Dict = {
  'chat.amrCard.switchTitle': 'فراخوانی مدل ناموفق بود — این اجرا متوقف شد',
  'chat.amrCard.switchBody': 'به سرویس رسمی مدل Open Design Cloud سوئیچ کنید — بدون نیاز به تنظیم کلید API. پس از ورود، اعطای دسترسی و شارژ، این اجرا به‌طور خودکار دوباره انجام می‌شود.',
  'chat.amrCard.chipOfficial': 'میزبانی رسمی',
  'chat.amrCard.chipNoKey': 'بدون کلید API',
  'chat.amrCard.chipAutoRetry': 'تلاش مجدد خودکار پس از ورود',
  'chat.amrCard.switchCta': 'سوئیچ به Open Design Cloud و تلاش مجدد',
  'chat.amrError.authMessage': 'حساب Open Design Cloud شما هنوز مجاز نشده است. آن را مجاز کنید تا این اجرا به‌طور خودکار دوباره انجام شود.',
  'chat.amrError.balanceMessage': 'موجودی Open Design Cloud شما تمام شده است. برای ادامه این اجرا شارژ کنید.',
  'chat.amrError.authorizeCta': 'اعطای دسترسی و تلاش مجدد',
  'chat.amrError.rechargeCta': 'شارژ Open Design Cloud',
  'chat.amrBalanceGate.title': 'ارتقا دهید و به خلق ادامه دهید',
  'chat.amrBalanceGate.message': 'اعتبار کافی نیست (باقی‌مانده {balance}). پس از ارتقای طرح یا شارژ، وظیفه بلافاصله شروع می‌شود.',
  'chat.amrBalanceGate.benefitsTitle': 'آنچه Open Design Cloud به شما می‌دهد',
  'chat.amrBalanceGate.benefit1': 'بدون کلید API، مدل‌های فراوان در دسترس',
  'chat.amrBalanceGate.benefit2': 'ایجنت طراحی SOTA داخلی، بدون پیکربندی',
  'chat.amrBalanceGate.benefit3': 'سرویس رسمی و قابل اعتماد',
  'chat.amrBalanceGate.benefit4': 'به‌روزرسانی مداوم: انتشار تک‌کلیکی، چندوجهی، نسخه تیمی و موارد دیگر',
  'chat.amrBalanceGate.laterCta': 'حالا نه',
  'chat.amrBalanceGate.plansCta': 'ارتقای طرح',
  'chat.amrBalanceGate.signedOutTitle': 'برای شروع خلق وارد شوید',
  'chat.amrBalanceGate.signedOutMessage': 'شما از ایجنت Open Design Cloud استفاده می‌کنید — وارد شوید تا این وظیفه بلافاصله شروع شود.',
  'chat.amrBalanceGate.signInCta': 'ورود',
  'chat.amrBalanceGate.watchingWallet': 'به‌محض به‌روزرسانی موجودی، به‌طور خودکار ادامه می‌دهیم.',
  'chat.amrLowBalance.title': 'اعتبار رو به اتمام است',
  'chat.amrLowBalance.message': 'فقط {balance} باقی مانده است — احتمالاً برای اتمام این وظیفه کافی نیست. ابتدا شارژ کنید یا طرح خود را ارتقا دهید.',
  'chat.amrLowBalance.rechargeCta': 'شارژ کنید',
  'chat.amrLowBalance.proceedCta': 'به هر حال شروع کن',
  'chat.amrLowBalance.dontRemind': 'دیگر نپرس',
  'chat.antigravityError.launchTerminalCta': 'ورود از طریق ترمینال',
  'chat.antigravityError.launchSwitchModelCta': 'تغییر مدل در ترمینال',
  'chat.connectionDropped': 'اتصال به سرویس مدل پیش از پایان پاسخ قطع شد — معمولاً به دلیل شبکه یا پراکسی ناپایدار. لطفاً دوباره تلاش کنید.',
  'chat.runError.title.authRequired': 'نیاز به مجوز',
  'chat.runError.title.balance': 'موجودی ناکافی',
  'chat.runError.title.connectionDropped': 'اتصال قطع شد',
  'chat.runError.title.signInRequired': 'نیاز به ورود',
  'chat.runError.title.rateLimited': 'محدودیت مصرف به پایان رسید',
  'chat.runError.title.generic': 'اجرای وظیفه ناموفق بود',
  'chat.runError.signInMessage.amr': 'عامل Open Design Cloud هنوز وارد نشده است — برای استفاده وارد شوید.',
  'chat.runError.signInMessage.other': '{agent} وارد نشده است. وضعیت ورود را به‌صورت محلی بررسی کنید. عامل Open Design Cloud را توصیه می‌کنیم — پایدارتر و مقرون‌به‌صرفه‌تر.',
  'chat.runError.agentFallback': 'عامل',
  'chat.runError.sourceLabel': 'منبع خطا',
  'chat.runError.sourceExpandAria': 'گسترش منبع خطا',
  'chat.runError.sourceCollapseAria': 'جمع‌کردن منبع خطا',
  'chat.runError.title.cliMissing': 'عامل نصب نشده است',
  'chat.runError.title.promptTooLarge': 'ورودی بیش از حد طولانی است',
  'chat.runError.title.modelUnavailable': 'مدل در دسترس نیست',
  'chat.runError.title.upstreamUnavailable': 'سرویس موقتاً در دسترس نیست',
  'chat.runError.title.toolLoop': 'گیرکرده در حلقه',
  'chat.runError.title.outputInvalid': 'خروجی نامعتبر مدل',
  'chat.runError.title.runtimeConfig': 'خطای پیکربندی',
  'chat.runError.cliMissingMessage': 'ابزار خط فرمان {agent} پیدا نشد. آن را نصب کنید و مطمئن شوید در PATH قرار دارد، سپس دوباره تلاش کنید.',
  'chat.runError.promptTooLargeMessage': 'این نوبت از محدودیت زمینه مدل فراتر رفت. پرامپت را کوتاه کنید، پیوست‌ها را کم کنید یا گفت‌وگوی جدیدی شروع کنید و دوباره تلاش کنید.',
  'chat.runError.modelUnavailableMessage': 'مدل انتخاب‌شده در دسترس نیست یا وجود ندارد. در تنظیمات به مدل دیگری تغییر دهید و دوباره تلاش کنید.',
  'chat.runError.rateLimitedMessage': 'به محدودیت استفاده از سرویس مدل رسیده‌اید. کمی صبر کنید و دوباره تلاش کنید، یا به مدل یا سرویس دیگری تغییر دهید.',
  'chat.runError.upstreamUnavailableMessage': 'سرویس مدل موقتاً در دسترس نیست — معمولاً به دلیل بی‌ثباتی سرویس بالادستی یا مشکل شبکه/پروکسی. کمی بعد دوباره تلاش کنید.',
  'chat.runError.toolLoopMessage': '{agent} همان عمل را بدون پیشرفت تکرار کرد و متوقف شد. فایل یا فرمان هدف را بررسی کنید و دوباره تلاش کنید.',
  'chat.runError.outputInvalidMessage': 'مدل خروجی نامعتبری تولید کرد و این نوبت قطع شد. معمولاً تلاش دوباره مشکل را حل می‌کند.',
  'chat.runError.runtimeConfigMessage': 'پیکربندی زمان‌اجرای عامل انتخاب‌شده نامعتبر است، بنابراین اجرا آغاز نشد. به آخرین نسخه به‌روزرسانی کنید یا با پشتیبانی تماس بگیرید.',
  'chat.runError.title.quotaExhausted': "سهمیه تمام شد",
  'chat.runError.quotaExhaustedMessage': "سهمیه یا سقف صورت‌حساب سرویس مدل شما تمام شده است، بنابراین تلاش دوباره کمکی نمی‌کند. نزد ارائه‌دهنده شارژ کنید یا به مدل یا سرویس دیگری تغییر دهید.",
  'chat.runError.workspaceCreditsMessage': "اعتبار فضای کاری شما تمام شده است. اعتبار اضافه کنید (یا از مالک فضای کاری بخواهید شارژ کند)، یا به مدل یا سرویس دیگری تغییر دهید.",
  'common.cancel': 'لغو',
  'chat.selectFromLibrary': 'وارد کردن از کتابخانه',
  'chat.importFigma': 'وارد کردن از Figma',
  'chat.plus.group.files': 'Files',
  'chat.plus.group.code': 'Code',
  'chat.plus.group.designs': 'Designs',
  'chat.plus.group.other': 'Other',
  'chat.plus.attachFiles': 'Attach files',
  'chat.plus.referenceProject': 'Reference another project',
  'chat.plus.linkLocalCode': 'Link local code',
  'chat.plus.uploadFig': 'Upload .fig file',
  'chat.plus.learnHow': 'Learn how',
  'chat.plus.designSystem': 'Design system',
  'chat.plus.skills': 'Skills',
  'chat.plus.noSkills': 'No skills available',
  'chat.plus.connectors': 'Connectors',
  'chat.plus.plugins': 'Plugins',
  'chat.plus.mcp': 'MCP',
  'chat.referenceProject.title': 'Reference another project',
  'chat.referenceProject.search': 'Search projects…',
  'chat.referenceProject.empty': 'No projects match “{query}”',
  'chat.referenceProject.emptyAll': 'No other projects yet',
  'chat.referenceProject.loadFailed': 'Could not load projects. Check that the daemon is running and try again.',
  'chat.referenceProject.confirm': 'Reference project',
  'chat.contextPrompt.referenceProject': 'Use the Open Design project “{name}” as reference context. Its local path is: {path}. Before designing or modifying anything, search and read this directory when useful.',
  'chat.contextPrompt.localCode': 'Use the local code folder “{name}” as code reference. Its absolute path is: {path}. Read relevant files when useful and stay consistent with the existing implementation.',
  'chat.figmaHelp.title': 'How to download a .fig file',
  'chat.figmaHelp.intro': 'From the Figma web or desktop app:',
  'chat.figmaHelp.step1': 'Open the file in Figma.',
  'chat.figmaHelp.step2': 'Go to File → Save local copy... (web: main menu → File).',
  'chat.figmaHelp.step3': 'Figma downloads a .fig file. Drop it onto the composer or upload it.',
  'chat.figmaHelp.note': 'The .fig file is parsed locally and is not uploaded to Figma.',
  'designFiles.library.label': 'وارد کردن از کتابخانه',
  'designFiles.library.title': 'وارد کردن از کتابخانه',
  'libraryPicker.title': 'وارد کردن از کتابخانه',
  'libraryPicker.searchPlaceholder': 'جست‌وجو در کتابخانه…',
  'libraryPicker.empty': 'هنوز موردی در کتابخانه شما نیست',
  'libraryPicker.allKinds': 'همه',
  'libraryPicker.add': 'وارد کردن',
  'libraryPicker.loading': 'در حال بارگذاری…',
  'common.save': 'ذخیره',
  'common.close': 'بستن',
  'common.clear': 'پاک کردن',
  'common.delete': 'حذف',
  'common.rename': 'تغییر نام',
  'common.edit': 'ویرایش',
  'common.preview': 'پیش‌نمایش',
  'common.share': 'اشتراک‌گذاری',
  'common.search': 'جستجو',
  'common.searchEllipsis': 'جستجو…',
  'common.loading': 'در حال بارگذاری…',
  'common.all': 'همه',
  'common.none': 'هیچ',
  'common.default': 'پیش‌فرض',
  'common.installed': 'نصب شده',
  'common.notInstalled': 'نصب نشده',
  'common.active': 'فعال',
  'common.offline': 'آفلاین',
  'common.selected': 'انتخاب شده',
  'common.create': 'ایجاد',
  'common.openPreview': 'باز کردن پیش‌نمایش',
  'common.exitFullscreen': 'خروج از تمام صفحه',
  'common.fullscreen': 'تمام صفحه',
  'common.openInNewTab': 'باز کردن در تب جدید',
  'common.exportPdf': 'صادرکردن به PDF',
  'common.exportZip': 'دانلود به صورت .zip',
  'common.exportHtml': 'صادرکردن به HTML مستقل',
  'common.exportImage': 'صادرکردن به صورت تصویر',
  'common.exportImageFailed': 'عکس‌برداری ناموفق بود. لطفاً دوباره تلاش کنید یا از ابزار عکس‌برداری مرورگر خود استفاده کنید.',
  'common.justNow': 'همین الان',
  'common.minutesAgo': '{n} دقیقه پیش',
  'common.hoursAgo': '{n} ساعت پیش',
  'common.daysAgo': '{n} روز پیش',
  'common.weeksAgo': '{n} هفته پیش',
  'common.now': 'الان',
  'common.minutesShort': '{n}د',
  'common.hoursShort': '{n}س',
  'common.daysShort': '{n}ر',
  'common.untitled': 'بدون عنوان',
  'designBrowser.savePageBrief': 'Save page brief',
  'designBrowser.menu': 'Browser menu',
  'designBrowser.copyScreenshot': 'Copy screenshot',
  'designBrowser.hardReload': 'Hard reload',
  'designBrowser.copyUrl': 'Copy URL',
  'designBrowser.openExternal': 'Open externally',
  'designBrowser.downloadPage': 'Download page',
  'designBrowser.downloadPageBusy': 'Downloading page...',
  'designBrowser.clearHistory': 'Clear history',
  'designBrowser.clearCookies': 'Clear cookies',
  'designBrowser.clearAllData': 'Clear all browser data',
  'designBrowser.status.noUrlToCopy': 'No URL to copy.',
  'designBrowser.status.urlCopied': 'URL copied.',
  'designBrowser.status.openHttpFirst': 'Open an http or https page first.',
  'designBrowser.status.openBeforeScreenshot': 'Open a page before taking a screenshot.',
  'designBrowser.status.screenshotSaved': 'Screenshot saved.',
  'designBrowser.status.screenshotFailed': 'Screenshot failed.',
  'designBrowser.status.openBeforeBrief': 'Open a page before saving a brief.',
  'designBrowser.status.briefSaveFailed': 'Page brief save failed.',
  'designBrowser.status.openBeforeDownload': 'Open a page before saving a snapshot.',
  'designBrowser.status.pageSnapshotStarted': 'Saving page snapshot...',
  'designBrowser.status.pageSnapshotUnsupported': 'This page cannot be archived.',
  'designBrowser.status.pageSnapshotFailed': 'Page snapshot save failed.',
  'designBrowser.status.pageSnapshotSaved': 'Saved page snapshot (HTML + CSS).',
  'designBrowser.status.viewDesignFiles': 'View Design Files',
  'designBrowser.status.downloadAssistHint': 'Step 2: click Download Page here, wait for the saved snapshot success, then return to the left Next Step card and click Continue extraction.',
  'designBrowser.status.desktopDataUnavailable': 'Desktop browser data is unavailable here.',
  'designBrowser.status.browserDataCleared': 'Browser data cleared.',
  'designBrowser.status.browserDataClearFailed': 'Browser data clear failed.',
  'designBrowser.status.historyCleared': 'History cleared.',
  'plugins.availableDetails.provenance': 'منشأ',
  'plugins.availableDetails.provenanceLine': 'از {source} · {trust} · {resolved}',
  'plugins.availableDetails.provenanceLineWithIntegrity': 'از {source} · {trust} · {resolved} · {integrity}',
  'plugins.availableDetails.install': 'نصب',
  'plugins.availableDetails.version': 'نسخه',
  'plugins.availableDetails.pluginVersion': 'نسخه افزونه',
  'plugins.availableDetails.copyInstallCommand': 'کپی دستور نصب',
  'plugins.availableDetails.copied': 'کپی شد',
  'plugins.availableDetails.deprecatedPrefix': 'منسوخ‌شده: {message}',
  'plugins.availableDetails.deprecatedFallback': 'این نسخه منسوخ علامت‌گذاری شده است.',
  'plugins.availableDetails.yanked': 'برداشته‌شده.',
  'plugins.availableDetails.yankedWithReason': 'برداشته‌شده: {reason}',
  'plugins.availableDetails.versionDeprecatedSuffix': ' (منسوخ‌شده)',
  'plugins.availableDetails.versionYankedSuffix': ' (برداشته‌شده)',
  'plugins.availableDetails.ref': 'Ref',
  'plugins.availableDetails.integrity': 'Integrity',
  'plugins.availableDetails.permissions': 'دسترسی‌ها',
  'plugins.availableDetails.capabilitySummary': 'خلاصه قابلیت‌ها',
  'plugins.actions.copyInstallCommand': 'کپی دستور نصب',
  'plugins.actions.copyPluginId': 'کپی شناسهٔ افزونه',
  'plugins.actions.copyReadmeBadge': 'کپی نشان README',
  'plugins.actions.openSourceGithub': 'باز کردن منبع در GitHub',
  'plugins.actions.openSource': 'باز کردن منبع',
  'plugins.actions.openHomepage': 'باز کردن صفحهٔ اصلی',
  'plugins.actions.openMarketplace': 'باز کردن در بازارچه',
  'app.brand': 'Open Design',
  'app.brandPill': 'پیش‌نمایش تحقیقاتی',
  'app.brandSubtitle': 'توسط Nexu Labs',
  'app.welcomeLoading': 'در حال بارگذاری فضای کاری…',
  'settings.welcomeKicker': '',
  'settings.welcomeTitle': 'به Open Design خوش آمدید',
  'settings.welcomeSubtitle': '',
  'settings.onboardingCreateTitle': 'شروع با یک شرح',
  'settings.onboardingCreateBody': 'سایت، اپلیکیشن، ارائه، تصویر یا ویدیویی را که می‌خواهید توصیف کنید. Open Design یک پروژه می‌سازد و کار را قابل ویرایش نگه می‌دارد.',
  'settings.onboardingMemoryTitle': 'ذخیره زمینه کاری',
  'settings.onboardingMemoryBody': 'ترجیحات، اطلاعات پروژه و قواعد تکرارشونده را اضافه کنید تا گفت‌وگوهای آینده زمینه درست را در نظر بگیرند.',
  'settings.onboardingMemoryCalloutTitle': 'در حافظهٔ شما ذخیره شد',
  'settings.onboardingMemoryCalloutBody': 'این پاسخ‌ها نمایهٔ حافظهٔ شما را شکل می‌دهند. Open Design در هر کار از آن استفاده می‌کند و همزمان با کار شما به یادگیری ادامه می‌دهد.',
  'settings.onboardingMemoryBenefitIntent': 'از یک درخواست کوتاه منظور شما را می‌فهمد',
  'settings.onboardingMemoryBenefitFewerQuestions': 'از پرسش‌های تکراری راه‌اندازی صرف‌نظر می‌کند',
  'settings.onboardingMemoryBenefitPersonalized': 'خروجی را متناسب با نقش، مخاطب و سلیقهٔ شما تنظیم می‌کند',
  'settings.onboardingSystemsTitle': 'سیستم طراحی خود را بیاورید',
  'settings.onboardingSystemsBody': 'یک سیستم برند انتخاب یا ایجاد کنید تا کارهای تولیدشده از رنگ‌ها، تایپوگرافی و زبان محصول واقعی پیروی کنند.',
  'settings.onboardingExecutionTitle': 'انتخاب نحوه اجرای تولید',
  'settings.onboardingExecutionBody': 'CLI رسمی با راه‌اندازی تک‌کلیکی و پیش‌فرض‌های آماده استفاده. با یک کلید از میان مدل‌های متعدد با قیمت‌گذاری بهتر انتخاب کنید.',
  'settings.onboardingAmrCloudBenefitOfficial': 'توصیه‌شده رسمی',
  'settings.onboardingAmrCloudBenefitReady': 'بدون نیاز به استقرار',
  'settings.onboardingAmrCloudBenefitModels': 'از Claude Opus 4.8 پشتیبانی می‌کند',
  'settings.onboardingAmrCloudBenefitPricing': 'هارنس SOTA',
  'settings.onboardingAmrCloudUpcomingLabel': 'به‌زودی',
  'settings.onboardingAmrCloudUpcomingImageVideo': 'تصویر و ویدیو',
  'settings.onboardingAmrCloudUpcomingSkills': 'Skills گسترده',
  'settings.onboardingAmrCloudUpcomingRouting': 'مسیریابی هوشمند',
  'settings.onboardingAmrModelSourceLabel': 'Open Design Cloud',
  'settings.onboardingAmrCloudAuthorizeAction': 'مجوزدهی Open Design Cloud',
  'settings.onboardingAmrCloudAuthorizedAction': 'مجوز داده شد',
  'settings.onboardingStepConnect': 'Connect',
  'settings.onboardingStepDesignSystem': 'ساخت سیستم طراحی',
  'settings.onboardingStepProfile': 'About you',
  'settings.onboardingStepNewsletter': 'Stay updated',
  'settings.onboardingNewsletterTitle': 'Stay in the loop',
  'settings.onboardingNewsletterBody': 'Get product updates, new templates, design-system drops, and ambassador work in your inbox. Optional — you can skip this.',
  'settings.onboardingConnectTitle': 'Choose a runtime',
  'settings.onboardingConnectBody': '',
  'settings.onboardingCloudTitle': 'ورود به Open Design',
  'settings.onboardingCloudBody': 'وارد شوید و بی‌درنگ با هوش مصنوعی ابری طراحی را آغاز کنید؛ بدون هیچ پیکربندی پیچیده‌ای.',
  'settings.onboardingCloudSignIn': 'ورود به Open Design',
  'settings.onboardingCloudContinue': 'ادامه (وارد شده‌اید)',
  'settings.onboardingCloudAlternative': 'از یک CLI محلی یا کلید API خودتان استفاده کنید',
  'settings.onboardingCloudRights': 'همهٔ حقوق محفوظ است.',
  'settings.onboardingCloudOr': 'یا',
  'settings.onboardingGateTooltipNoRuntime': 'مراحل بعدی با هوش مصنوعی اجرا می‌شوند — برای ادامه یک روش اجرا انتخاب کنید.',
  'settings.onboardingGateTooltipAmr': 'مراحل بعدی با هوش مصنوعی اجرا می‌شوند — برای ادامه وارد Open Design Cloud شوید.',
  'settings.onboardingGateTooltipLocal': 'مراحل بعدی با هوش مصنوعی اجرا می‌شوند — برای ادامه یک CLI محلی در دسترس انتخاب کنید.',
  'settings.onboardingGateTooltipByok': 'مراحل بعدی با هوش مصنوعی اجرا می‌شوند — برای ادامه کلید مدل خود را افزوده و تست کنید.',
  'settings.onboardingRecommended': 'Recommended',
  'settings.onboardingAmrCloudOfficialBadge': 'رسمی',
  'settings.onboardingLocalTitle': 'Local coding agent',
  'settings.onboardingLocalBody': 'Use an installed CLI such as Claude Code, Codex, Cursor, Gemini, or OpenCode.',
  'settings.onboardingLocalAction': 'Open CLI settings',
  'settings.onboardingCliScanHint': 'This usually takes 5-10 seconds.',
  'settings.onboardingByokTitle': 'Bring your own key',
  'settings.onboardingByokBody': 'Use your own model provider credentials.',
  'settings.onboardingByokAction': 'Open BYOK settings',
  'settings.onboardingDesignTitle': 'Design system',
  'settings.onboardingDesignBody': 'Generate once, reuse everywhere.',
  'settings.onboardingDesignIntroGenerateTitle': 'Generate from existing work',
  'settings.onboardingDesignIntroGenerateBody': 'Upload your design system from GitHub or local code repositories, Figma files, images, and other content assets.',
  'settings.onboardingDesignIntroReuseTitle': 'Reuse in future work',
  'settings.onboardingDesignIntroReuseBody': 'Future prototypes, slides, and other content can reference your existing fonts, spacing, logo style, and color tone.',
  'settings.onboardingDesignIntroSkipTitle': 'Optional for now',
  'settings.onboardingDesignIntroSkipBody': 'Skip this step if you want to start without generating a design system.',
  'settings.onboardingGithubTitle': 'Import from GitHub',
  'settings.onboardingGithubBody': 'Use a frontend repository.',
  'settings.onboardingUploadTitle': 'Upload local files',
  'settings.onboardingUploadBody': 'Add project files, screenshots, CSS, docs, or assets.',
  'settings.onboardingPromptTitle': 'Generate from prompt',
  'settings.onboardingPromptBody': 'Describe the product or brand.',
  'settings.onboardingProfileTitle': 'درباره شما',
  'settings.onboardingProfileBody': 'جزئیات اختیاری برای پیش‌فرض‌های بهتر.',
  'settings.onboardingRoleLabel': 'نقش شما',
  'settings.onboardingOrgSizeLabel': 'اندازه سازمان',
  'settings.onboardingUseCaseLabel': 'مورد استفاده',
  'settings.onboardingSourceLabel': 'از کجا با ما آشنا شدید؟',
  'settings.onboardingSourceX': '🐦 X / Twitter',
  'settings.onboardingSourceGithub': '🐙 GitHub',
  'settings.onboardingSourceYoutube': '▶️ YouTube',
  'settings.onboardingSourceTiktok': '🎵 TikTok',
  'settings.onboardingSourceReddit': '👽 Reddit',
  'settings.onboardingSourceLinkedin': '💼 LinkedIn',
  'settings.onboardingSourceMetaSocial': '📸 Instagram / Threads / Facebook',
  'settings.onboardingSourceSearch': '🔍 جستجو (Google / Bing)',
  'settings.onboardingSourceAiTool': '🤖 ابزار هوش مصنوعی (ChatGPT / Perplexity)',
  'settings.onboardingSourceFriend': '👥 دوست یا همکار',
  'settings.onboardingSourceCommunity': '💬 Discord / انجمن',
  'settings.onboardingSourceEmail': '✉️ ایمیل / خبرنامه',
  'settings.onboardingSourceBlog': '📝 وبلاگ / مقاله',
  'settings.onboardingSourceOther': '✨ سایر',
  'settings.onboardingSourceOtherPlaceholder': 'به ما بگویید کجا (اختیاری)',
  'settings.onboardingSelectPlaceholder': 'یکی را انتخاب کنید',
  'settings.onboardingSelectMultiplePlaceholder': 'یک یا چند مورد را انتخاب کنید',
  'settings.onboardingOrgSolo': 'انفرادی / شخصی (1)',
  'settings.onboardingOrgTeam': 'تیم کوچک (2-10)',
  'settings.onboardingOrgStartup': 'استارتاپ / SMB (11-50)',
  'settings.onboardingOrgGrowth': 'شرکت در حال رشد (51-200)',
  'settings.onboardingOrgMidMarket': 'بازار متوسط (201-1000)',
  'settings.onboardingOrgEnterprise': 'سازمان بزرگ (1000+)',
  'settings.onboardingRolePm': '📋 مدیر محصول',
  'settings.onboardingRoleDesigner': '🎨 طراح',
  'settings.onboardingRoleEngineer': '💻 مهندس',
  'settings.onboardingRoleMarketing': '📣 بازاریابی',
  'settings.onboardingRoleAgency': '📣 آژانس بازاریابی',
  'settings.onboardingRoleGrowth': '📈 رشد',
  'settings.onboardingRoleOps': '⚙️ عملیات',
  'settings.onboardingRoleFounder': '🚀 بنیان‌گذار / مدیر ارشد',
  'settings.onboardingRoleStudent': '🎓 دانشجو / مدرس',
  'settings.onboardingRoleOther': '✨ سایر',
  'settings.onboardingUseProduct': '🎨 طراحی محصول',
  'settings.onboardingUseDesignSystem': '🧩 سیستم طراحی',
  'settings.onboardingUsePrototype': '📱 نمونه اولیه / رابط اپلیکیشن',
  'settings.onboardingUseLanding': '🌐 صفحات فرود',
  'settings.onboardingUseAds': '📣 تبلیغات / محتوای شبکه‌های اجتماعی',
  'settings.onboardingUseDashboard': '📊 داشبوردها / ابزارهای داخلی',
  'settings.onboardingUseDeck': '🖥️ ارائه / اسلاید',
  'settings.onboardingUseMarketing': '📈 بازاریابی / رشد',
  'settings.onboardingUseEngineering': '🤝 تحویل به مهندسی',
  'settings.onboardingUseAgency': '💼 آژانس / کار مشتری',
  'settings.onboardingBack': 'Back',
  'settings.onboardingContinue': 'Continue',
  'settings.onboardingFinish': 'Finish setup',
  'settings.kicker': 'تنظیمات',
  'settings.title': 'حالت اجرا',
  'settings.subtitle': 'بین CLI محلی و BYOK انتخاب کنید.',
  'settings.modeAria': 'حالت اجرا',
  'settings.protocolAria': 'پروتکل API',
  'settings.modeDaemon': 'CLI محلی',
  'settings.modeDaemonHelp': 'اجرا از طریق CLI عامل کد روی دستگاه شما',
  'settings.modeDaemonOffline': 'Daemon در حال اجرا نیست',
  'settings.modeDaemonOfflineMeta': 'daemon آفلاین',
  'settings.modeDaemonInstalledMeta': '{count} نصب شده',
  'settings.modeApi': 'ارائه‌دهنده API',
  'settings.modeApiMeta': 'BYOK',
  'settings.byokNoFileToolsNotice': 'BYOK نمی‌تواند فایل‌های پروژه را بخواند، بنویسد یا ویرایش کند. وقتی به تغییرات کد نیاز دارید از Local CLI استفاده کنید.',
  'settings.codeAgent': 'عامل کد',
  'settings.codeAgentHint': 'با اسکن PATH شما شناسایی شده. CLI مورد نظر برای جریان تولیدات را انتخاب کنید.',
  'settings.rescan': '↻ اسکن مجدد',
  'settings.rescanTitle': 'اسکن مجدد PATH',
  'settings.rescanRunning': 'در حال اسکن...',
  'settings.rescanSuccess': 'اسکن کامل شد. {count} مورد در دسترس است.',
  'settings.designSystemRenameFailed': 'تغییر نام ناموفق بود. daemon را بررسی کنید و دوباره تلاش کنید.',
  'settings.rescanFailed': 'اسکن ناموفق بود. daemon را بررسی کنید و دوباره تلاش کنید.',
  'settings.test': 'آزمایش',
  'settings.testTitle': 'یک پیام کوچک آزمایشی برای راستی‌آزمایی اتصال ارسال کنید',
  'settings.testRunning': 'در حال آزمایش اتصال…',
  'settings.byokReadyToTest': 'آماده برای آزمایش',
  'settings.testCancel': 'انصراف',
  'settings.testRetry': 'تلاش مجدد برای آزمایش',
  'settings.required': 'الزامی',
  'settings.testMissingFields': 'برای آزمایش اتصال، {fields} را پر کنید.',
  'settings.testSuccessApi': 'متصل شد. در {ms} میلی‌ثانیه پاسخ داد — \'{sample}\'',
  'settings.testSuccessCli': '{agentName} در {ms} میلی‌ثانیه پاسخ داد — \'{sample}\'',
  'settings.testAuthFailed': 'احراز هویت ناموفق بود. کلید API را بررسی کنید.',
  'settings.testForbidden': 'دسترسی مجاز نیست. حساب، منطقه یا سازمان را بررسی کنید.',
  'settings.testNotFoundModel': 'مدل \'{model}\' در این نقطه پایانی یافت نشد.',
  'settings.testInvalidModelId': 'شناسه مدل \'{model}\' نامعتبر است. شناسه سفارشی باید با حرف یا عدد شروع شود و فاصله نداشته باشد.',
  'settings.testInvalidBaseUrl': 'Base URL نامعتبر یا غیرقابل دسترسی است.',
  'settings.testRateLimited': 'ارائه‌دهنده برای آزمایش محدودیت اعمال کرد. پیکربندی معتبر به نظر می‌رسد.',
  'settings.testUpstream': 'ارائه‌دهنده وضعیت {status} را برگرداند. لحظه‌ای دیگر دوباره تلاش کنید.',
  'settings.testTimeout': 'آزمایش پس از {ms} میلی‌ثانیه به پایان زمان رسید.',
  'settings.testAgentMissing': '{agentName} نصب نشده یا در PATH نیست.',
  'settings.testAgentSpawn': '{agentName} اجرا نشد: {detail}.',
  'settings.testUnknown': 'آزمایش ناموفق بود: {detail}',
  'settings.agentInstall.install': 'نصب',
  'settings.agentInstall.docs': 'مستندات',
  'settings.agentInstall.pathHint': 'اگر CLI را با npm یا Homebrew نصب کرده‌اید اما هنوز به‌صورت نصب‌نشده نمایش داده می‌شود، مطمئن شوید پوشه bin ابزار در PATHای باشد که daemon اوپن دیزاین به ارث می‌برد (در macOS ممکن است PATH ترمینال و برنامه‌های GUI متفاوت باشد). بخش "Local agent CLI and PATH" در QUICKSTART.md را ببینید.',
  'settings.agentInstall.stepOpenLinks': 'برای عامل موردنظر، لینک نصب یا مستندات را باز کنید.',
  'settings.agentInstall.stepAuth': 'قبل از بازگشت به Open Design، در CLI ارائه‌دهنده احراز هویت کنید (ورود یا افزودن اطلاعات API).',
  'settings.agentInstall.stepRescan': 'در این بخش روی اسکن مجدد کلیک کنید.',
  'settings.agentInstall.stepSelect': 'وقتی عامل به‌صورت نصب‌شده نمایش داده شد، کارت آن را انتخاب کنید.',
  'settings.noAgentsDetected': 'هنوز هیچ عاملی شناسایی نشده. یکی از Claude Code، Codex، OpenCode، Cursor Agent، Qwen یا GitHub Copilot CLI را نصب کنید، سپس روی اسکن مجدد کلیک کنید.',
  'settings.agentInstalledGroup': 'CLIهای شما ({count})',
  'settings.agentInstallGroup': 'آماده نصب ({count})',
  'settings.agentAuthRequired': 'احراز هویت لازم است',
  'settings.agentAuthUnknown': 'وضعیت احراز هویت نامشخص است',
  'settings.amrCloud': 'Open Design Cloud',
  'settings.amrAuthorize': 'اعطای مجوز',
  'settings.amrBenefitOfficial': 'رسمی',
  'settings.amrBenefitLowerPrice': 'هزینه کمتر',
  'settings.amrBenefitManyModels': 'مدل‌های متعدد',
  'settings.amrPromoBonus': 'پاداش محدود: +۱۰۰٪',
  'settings.amrSignInToContinue': 'برای ادامه وارد شوید',
  'settings.amrSignIn': 'ورود',
  'settings.amrSignedIn': 'وارد شده',
  'settings.amrWalletBalance': 'Wallet balance',
  'settings.amrWalletUnavailable': 'Balance temporarily unavailable',
  'settings.amrWalletUpdatedAt': 'Updated {time}',
  'settings.amrWalletCached': 'cached',
  'settings.amrWalletRefresh': 'Refresh',
  'settings.amrWalletRefreshTitle': 'Refresh Open Design Cloud wallet balance',
  'settings.amrNotSignedIn': 'وارد نشده',
  'settings.amrSigningIn': 'در حال ورود…',
  'settings.amrActivationHint': 'صفحهٔ ورود باز نشد؟ برای باز کردن دوباره، دکمهٔ زیر را بزنید.',
  'settings.amrActivationBrowserFailed': 'مرورگر به‌طور خودکار باز نشد. برای ادامه، صفحهٔ ورود زیر را باز کنید.',
  'settings.amrActivationOpen': 'باز کردن صفحهٔ ورود',
  'settings.amrCancelSignIn': 'لغو ورود',
  'settings.amrAccountStatus': 'وضعیت حساب Open Design Cloud',
  'settings.amrConsole': 'مدیریت',
  'settings.amrBalance': 'موجودی',
  'settings.amrPlan': 'طرح',
  'settings.amrUpgrade': 'ارتقا',
  'settings.amrModelUpgradeHint': 'برای استفاده ارتقا دهید',
  'settings.amrLoginErrorCompact': 'ورود به Open Design Cloud ناموفق بود.',
  'settings.advanced': 'پیشرفته',
  'settings.amrLogin': 'ورود',
  'settings.amrLogout': 'خروج',
  'settings.amrLoggingIn': 'در حال ورود…',
  'settings.amrLoggingOut': 'در حال خروج…',
  'settings.amrLoggedInAs': 'وارد شده با عنوان {email}',
  'settings.amrLoggedInWithPlan': 'وارد شده با {email} · {plan}',
  'settings.amrLoggedInPill': 'وارد شده',
  'settings.amrNotLoggedIn': 'وارد نشده',
  'settings.apiSection': 'Anthropic API',
  'settings.quickFillProvider': 'پر کردن سریع ارائه‌دهنده',
  'settings.providerPreset': 'پیش‌تنظیم درگاه',
  'settings.protocolGroupProtocols': 'پروتکل‌ها',
  'settings.protocolGroupGateways': 'درگاه‌ها',
  'settings.customProvider': 'ارائه‌دهنده سفارشی',
  'settings.apiKey': 'کلید API',
  'settings.apiKeyGetLink': 'دریافت کلید ↗',
  'settings.showKey': 'نمایش کلید',
  'settings.hideKey': 'پنهان کردن کلید',
  'settings.show': 'نمایش',
  'settings.hide': 'پنهان',
  'settings.model': 'مدل',
  'settings.apiKeyInvalid': 'API key نامعتبر است.',
  'settings.apiKeyCleaned': 'فاصله‌های اضافی از API key حذف شد.',
  'settings.modelsLoadedFromAccount': '✓ {count} مدل از حساب شما بارگذاری شد.',
  'settings.modelsLoadedCount': '✓ {count} مدل بارگذاری شد.',
  'settings.modelSourceAccount': 'از حساب شما',
  'settings.modelSourceSuggested': 'پیشنهادی',
  'modelCapability.standard': 'Standard',
  'modelCapability.advanced': 'Advanced',
  'modelCapability.bestQuality': 'Best Quality',
  'modelCapability.standardDescription': 'Solid quality for regular tasks.',
  'modelCapability.advancedDescription': 'Stronger quality for more demanding tasks.',
  'modelCapability.bestQualityDescription': 'Best output quality for the most demanding work.',
  'modelCost.upToHalf': 'هزینه کم',
  'modelCost.halfToOne': 'هزینه متوسط',
  'modelCost.oneToFour': 'هزینه بالا',
  'modelCost.overFour': 'بیشترین هزینه',
  'settings.fetchModels': 'دریافت مدل‌ها',
  'settings.fetchModelsTitle': 'دریافت مدل‌های موجود از این ارائه‌دهنده',
  'settings.fetchModelsRunning': 'در حال دریافت مدل‌ها…',
  'settings.fetchModelsMissingFields': 'برای دریافت مدل‌ها، {fields} را پر کنید.',
  'settings.fetchModelsInvalidBaseUrl': 'برای دریافت مدل‌ها یک Base URL معتبر وارد کنید.',
  'settings.fetchModelsUnsupportedAzure': 'Azure OpenAI از نام‌های deployment استفاده می‌کند، بنابراین کشف مدل در اینجا در دسترس نیست.',
  'settings.fetchModelsUnsupportedOllama': 'کشف مدل Ollama Cloud هنوز در دسترس نیست. یک مدل را انتخاب یا تایپ کنید.',
  'settings.fetchModelsSuccess': '{count} مدل دریافت شد.',
  'settings.fetchModelsEmpty': 'هیچ مدل متنی سازگاری بازگردانده نشد.',
  'settings.fetchModelsUnsupported': 'کشف مدل برای این پروتکل در دسترس نیست.',
  'settings.fetchModelsFailed': 'دریافت مدل‌ها ممکن نشد: {detail}',
  'settings.suggestedModelsHint': 'این‌ها مدل‌های پیشنهادی برای این پروتکل هستند. ارائه‌دهنده شما ممکن است مدل‌های دیگری را پشتیبانی کند.',
  'settings.baseUrl': 'آدرس پایه',
  'settings.baseUrlInvalid': 'از URL عمومی http:// یا https:// استفاده کنید.',
  'settings.baseUrlCustomize': 'سفارشی‌سازی',
  'settings.baseUrlDefaultHint': 'نقطه پایانی پیش‌فرض. معمولاً نیازی به تغییر آن نیست.',
  'settings.azureBaseUrlPlaceholder': 'URL نقطه پایانی Azure را جای‌گذاری کنید',
  'settings.azureBaseUrlHint': 'این را در پورتال Azure پیدا کنید ← منبع شما ← Endpoint.',
  'settings.azureDeploymentModel': 'نام استقرار',
  'settings.azureCustomDeploymentName': 'نام deployment سفارشی',
  'settings.azureDeploymentModelHint': 'در Azure OpenAI، این فیلد به عنوان نام استقرار در /openai/deployments/<model> استفاده می‌شود. نام استقراری را که در Azure ساخته‌اید وارد کنید.',
  'settings.azureModelFetchHint': 'نام deployment را از منبع Azure خود وارد کنید. deployment‌های Azure را نمی‌توان به‌صورت خودکار دریافت کرد.',
  'settings.apiVersion': 'نسخه API',
  'settings.byokImageModel': 'مدل تولید تصویر',
  'settings.byokVideoModel': 'مدل تولید ویدیو',
  'settings.byokVideoI2vHint': 'مدل تصویر به ویدیو: تصویر مرجع لازم است (در غیر این صورت آخرین تصویر پروژه به‌طور خودکار استفاده می‌شود)',
  'settings.byokSpeechModel': 'مدل گفتار',
  'settings.byokSpeechVoice': 'صدای گفتار',
  'settings.byokModelDefaultOption': 'پیش‌فرض',
  'settings.maxTokens': 'حداکثر توکن (اختیاری)',
  'settings.maxTokensHint': 'سقف طول پاسخ. هر مدل مقدار پیش‌فرض تنظیم‌شدهٔ خود را دارد (در placeholder نمایش داده می‌شود)؛ برای استفاده از آن خالی بگذارید، یا برای جایگزینی، عددی وارد کنید.',
  'settings.apiHint': 'درخواست‌ها از طریق پراکسی daemon محلی به Base URL تنظیم‌شده ارسال می‌شوند. کلید فقط در همین مرورگر ذخیره می‌شود و همراه درخواست‌های ارائه‌دهنده فرستاده می‌شود.',
  'settings.skipForNow': 'فعلاً رد کنید',
  'settings.getStarted': 'شروع کنید',
  'settings.envConfigure': 'حالت اجرا',
  'settings.localCli': 'CLI محلی',
  'settings.anthropicApi': 'Anthropic API',
  'settings.noAgentSelected': 'هیچ عاملی انتخاب نشده',
  'settings.language': 'زبان',
  'settings.languageHint': 'زبان رابط را تغییر دهید. در این مرورگر ذخیره می‌شود.',
  'settings.appearance': 'ظاهر',
  'settings.appearanceHint': 'روشن، تاریک یا پیروی از تنظیمات سیستم.',
  'settings.themeSystem': 'سیستم',
  'settings.themeLight': 'روشن',
  'settings.themeDark': 'تاریک',
  'settings.agentModelHead': 'مدل برای:',
  'settings.modelPicker': 'مدل',
  'settings.modelSourceLive': 'زنده از CLI',
  'settings.modelSourceFallback': 'فهرست داخلی',
  'settings.reasoningPicker': 'سطح استدلال',
  'settings.modelPickerHint': 'هنگامی که CLI یک دستور `models` را ارائه می‌دهد از آن دریافت می‌شود. «پیش‌فرض» انتخاب را به پیکربندی خود CLI واگذار می‌کند؛ «سفارشی…» به شما امکان می‌دهد هر شناسه مدلی را که CLI می‌پذیرد تایپ کنید.',
  'settings.modelPickerLiveHint': 'مدل‌ها از CLI نصب‌شده به‌روزرسانی شدند. گزینه پیش‌فرض همچنان از تنظیمات CLI استفاده می‌کند.',
  'settings.modelPickerLiveCatalogOnlyHint': 'مدل‌ها از CLI نصب‌شده به‌روزرسانی شدند.',
  'settings.modelPickerFallbackHint': 'پیش‌فرض‌های داخلی نمایش داده می‌شوند. برای دریافت مدل‌های زنده از CLI روی اسکن مجدد کلیک کنید.',
  'settings.cliEnvTitle': 'پیشرفته: پراکسی و مسیرهای سفارشی',
  'settings.cliEnvHint': 'از این گزینه‌ها برای بازنویسی محیط CLI انتخاب‌شده استفاده کنید: API key، base URL پراکسی، home سفارشی یا مسیر اجرایی غیر استاندارد. اگر base URL تنظیم نشود، CLI از endpoint پیش‌فرض خودش استفاده می‌کند. اطلاعات محرمانه در تنظیمات محلی برنامه می‌مانند و فقط CLI انتخاب‌شده آن‌ها را می‌بیند.',
  'settings.cliEnvClaudeConfigDir': 'پوشه پیکربندی Claude Code',
  'settings.cliEnvClaudeBaseUrl': 'Base URL پروکسی Claude',
  'settings.cliEnvClaudeApiKey': 'API key برای Claude CLI',
  'settings.cliEnvCodexHome': 'خانه Codex',
  'settings.cliEnvCodexBin': 'مسیر فایل اجرایی Codex',
  'settings.cliEnvCodexBaseUrl': 'Base URL پراکسی Codex/OpenAI',
  'settings.cliEnvCodexApiKey': 'API key برای Codex/OpenAI CLI',
  'settings.modelCustom': 'سفارشی (در زیر تایپ کنید)…',
  'settings.modelCustomLabel': 'شناسه مدل سفارشی',
  'settings.modelCustomPlaceholder': 'مثلاً anthropic/claude-sonnet-4-6',
  'settings.mediaProviders': 'ارائه‌دهندگان رسانه',
  'settings.mediaProvidersHint': 'کلیدهای API برای تولید تصویر، ویدئو و صدا. به صورت محلی ذخیره و با daemon محلی همگام می‌شود.',
  'settings.mcpServerTitle': 'سرور MCP',
  'settings.mcpServerHint': 'Open Design را به‌عنوان سرور MCP برای عامل برنامه‌نویسی خود در دسترس قرار دهید.',
  'settings.externalMcpTitle': 'MCP خارجی',
  'settings.externalMcpHint': 'افزودن ابزارهای MCP از سرویس‌های خارجی (Higgsfield, GitHub, …).',
  'settings.mediaProviderApiKey': 'کلید API',
  'settings.mediaProviderBaseUrl': 'آدرس پایه',
  'settings.mediaProviderConfigured': 'پیکربندی شده',
  'settings.mediaProviderUnset': 'تنظیم نشده',
  'settings.mediaProviderClear': 'پاک کردن',
  'settings.mediaProviderClearConfirm': 'پاک کردن تنظیمات ذخیره‌شده‌ی {name}؟ برای استفاده از {name} باید آن‌ها را دوباره وارد کنید.',
  'settings.mediaProviderPlaceholder': 'کلید API را وارد کنید',
  'settings.mediaProviderBaseUrlPlaceholder': 'بازنویسی آدرس پایه پیش‌فرض',
  'settings.mediaProviderReload': 'بارگذاری دوباره از دیمن محلی',
  'settings.mediaProviderReloadError': 'بارگذاری دوبارهٔ تنظیمات ارائه‌دهنده‌های رسانه از دیمن محلی ممکن نشد.',
  'settings.mediaProviderReloadSuccess': 'تنظیمات ارائه‌دهنده‌های رسانه از دیمن محلی دوباره بارگذاری شد.',
  'settings.mediaProviderLoadError': 'بارگذاری تنظیمات ارائه‌دهنده‌های رسانه از دیمن محلی ممکن نشد. فعلاً از تنظیمات ذخیره‌شده در مرورگر استفاده می‌شود.',
  'settings.mediaProviderComingSoonHint': 'ما این موارد را برای نقشه راه پیگیری می‌کنیم؛ دیمون هنوز کلاینتی ارائه نمی‌دهد، بنابراین چیزی برای پیکربندی وجود ندارد.',
  'settings.privacy': 'حریم خصوصی',
  'settings.privacyHint': 'چه داده‌هایی با تیم Open Design به اشتراک گذاشته می‌شود',
  'settings.privacyConsentKicker': 'به ما در بهبود Open Design کمک کنید',
  'settings.privacyConsentLead': 'اشتراک‌گذاری داده‌های استفاده به ما کمک می‌کند عملکرد Open Design را در جریان‌های کاری واقعی بهتر بفهمیم تا بخش‌هایی را که بیشترین اثر را بر تجربه شما دارند بهبود دهیم.',
  'settings.privacyConsentFooter': 'می‌توانید این گزینه‌ها را هر زمان در Settings ← Privacy تغییر دهید.',
  'settings.privacyConsentShare': 'اشتراک‌گذاری',
  'settings.privacyConsentDecline': 'اشتراک‌گذاری نکن',
  'settings.privacyConsentAccept': 'متوجه شدم',
  'settings.privacyConsentBannerFooter': 'اشتراک‌گذاری داده به‌صورت پیش‌فرض روشن است. می‌توانید هر زمان آن را در Settings ← Privacy خاموش کنید.',
  'settings.privacyConsentPolicyLink': 'خواندن سیاست حریم خصوصی',
  'settings.privacyMetrics': 'معیارهای ناشناس',
  'settings.privacyMetricsHint': 'تعداد اجراها، مصرف Token، نرخ خطا و مدت زمان به‌عنوان شاخص‌های پایه استفاده.',
  'settings.privacyContent': 'محتوای مکالمه و ابزار',
  'settings.privacyContentHint': 'پس از حذف اسرار و اطلاعات حساس دیگر، از دستورها، پاسخ‌های دستیار، ورودی/خروجی ابزارها و زمینه موردنیاز برای بازبینی کیفیت استفاده می‌کنیم.',
  'settings.privacyInstallationId': 'شناسه ناشناس',
  'settings.privacyOptedOut': 'انصراف داده شد',
  'settings.privacyDataDeletion': 'حذف داده‌های من',
  'settings.privacyDataDeletionHint': 'شناسه ناشناس شما را تغییر می‌دهد و ارسال را متوقف می‌کند. ردیابی‌های موجود طبق سیاست نگه‌داری ما به مرور حذف می‌شوند.',
  'settings.about': 'درباره',
  'settings.aboutHint': 'جزئیات نسخه و اجرا',
  'settings.appVersion': 'نسخه',
  'settings.appChannel': 'کانال',
  'settings.appRuntime': 'محیط اجرا',
  'settings.appPlatform': 'سکو',
  'settings.appArchitecture': 'معماری',
  'settings.runtimePackaged': 'برنامه بسته‌بندی‌شده',
  'settings.runtimeDevelopment': 'توسعه',
  'settings.versionUnavailable': 'تا وقتی daemon آفلاین است جزئیات نسخه در دسترس نیست.',
  "settings.allowSilentUpdates": "اجازه به‌روزرسانی بی‌صدا",
  "settings.allowSilentUpdatesDesc": "به‌روزرسانی‌های payload دانلودشده را هنگام راه‌اندازی خودکار اعمال کن. به‌روزرسانی‌های نصاب همچنان ابتدا تأیید می‌خواهند.",
  'settings.installLatest': 'نصب جدیدترین',
  'settings.alreadyLatest': 'شما آخرین نسخه را دارید',
  'settings.updateCheck': 'بررسی به‌روزرسانی',
  'settings.updateNow': 'اکنون به‌روزرسانی کنید',
  'settings.updateRecheck': 'دوباره بررسی کنید',
  'settings.updateRetry': 'تلاش دوباره',
  'settings.updateViewReleases': 'یادداشت‌های انتشار',
  'settings.updateActionFailed': 'انجام عملیات به‌روزرسانی ممکن نشد.',
  'settings.updateQuitFailed': 'نصب‌کننده باز شد، اما Open Design نتوانست خودکار خارج شود.',
  'settings.updateStatusNotChecked': 'هنوز بررسی نشده',
  'settings.updateStatusDevelopment': 'نسخه‌های توسعه از به‌روزرسانی درون‌برنامه پشتیبانی نمی‌کنند.',
  'settings.updateStatusUnsupported': 'این محیط از به‌روزرسانی درون‌برنامه پشتیبانی نمی‌کند.',
  'settings.updateStatusChecking': 'در حال بررسی به‌روزرسانی...',
  'settings.updateStatusUpToDate': 'شما آخرین نسخه را دارید.',
  'settings.updateStatusAvailable': 'نسخه {version} پیدا شد. آماده‌سازی دانلود.',
  'settings.updateStatusAvailableUnknown': 'نسخه جدید پیدا شد. آماده‌سازی دانلود.',
  'settings.updateStatusDownloading': 'در حال دانلود به‌روزرسانی...',
  'settings.updateStatusDownloadingPercent': 'در حال دانلود به‌روزرسانی {percent}٪.',
  'settings.updateStatusReady': 'نسخه {version} آماده نصب است.',
  'settings.updateStatusReadyUnknown': 'به‌روزرسانی آماده نصب است.',
  'settings.updateStatusInstalling': 'در حال نصب به‌روزرسانی...',
  'settings.updateStatusFailed': 'بررسی ناموفق بود. دوباره تلاش کنید.',
  'settings.mcpTitle': 'سرور MCP',
  'settings.mcpHint': 'به Agentهای کدنویسی (Cursor، Claude Code، VS Code…) اجازه دهید پروژه‌های Open Design شما را مستقیماً بخوانند.',
  'settings.mcpDaemonError': 'امکان دسترسی به daemon محلی برای تعیین مسیرهای نصب وجود نداشت ({error}). مطمئن شوید که Open Design در حال اجراست، سپس این پنل را دوباره باز کنید.',
  'settings.mcpBuildDaemon': 'ابتدا daemon را بسازید.',
  'settings.mcpNodeMissing': 'باینری Node یافت نشد.',
  'settings.mcpBuildHint': 'apps/daemon/dist/cli.js یافت نشد. دستور `pnpm --filter @open-design/daemon build` را اجرا کنید و صفحه را تازه‌سازی کنید.',
  'settings.mcpMethodCli': 'دستور CLI',
  'settings.mcpInstructionCli': 'این را در ترمینال خود اجرا کنید.',
  'settings.mcpMethodToml': 'پیکربندی TOML',
  'settings.mcpInstructionCodex': 'این جدول را به {path} اضافه کنید. همین پیکربندی بین Codex CLI و افزونه IDE Codex مشترک است.',
  'settings.mcpMethodOneClick': 'نصب با یک کلیک',
  'settings.mcpInstructionCursor': 'برای نصب با یک پنجره تأیید، روی «Install in Cursor» کلیک کنید، یا این JSON را در {path} ادغام کنید.',
  'settings.mcpDeeplinkInstallCursor': 'نصب در Cursor',
  'settings.mcpMethodJson': 'پیکربندی JSON',
  'settings.mcpInstructionCopilot': 'Command Palette ({shortcut}) را باز کنید، «MCP: Open User Configuration» را اجرا کنید و این JSON را ادغام کنید. برای نمایش ابزارها، Copilot Chat باید در حالت Agent باشد.',
  'settings.mcpInstructionAntigravity': 'در Antigravity: منوی «...» پنل Agent ← MCP Servers ← Manage MCP Servers ← View raw config. این JSON را ادغام کنید.',
  'settings.mcpInstructionZed': 'تنظیمات Zed ({shortcut}) را باز کنید و این را در شیء سطح‌بالا ادغام کنید. Zed از «context_servers» استفاده می‌کند، نه «mcpServers».',
  'settings.mcpInstructionWindsurf': '{path} را باز کنید (یا از آیکون MCPها در Cascade ← Configure استفاده کنید) و ادغام کنید:',
  'settings.mcpCopyAria': 'کپی قطعه پیکربندی MCP',
  'settings.mcpResolvingFailed': '# حل مسیرها ناموفق بود، خطای بالا را ببینید',
  'settings.mcpLoadingPaths': '# در حال بارگذاری مسیرهای نصب از daemon محلی…',
  'settings.mcpCopied': 'کپی شد',
  'settings.mcpCopy': 'کپی',
  'settings.mcpCursorApproval': 'Cursor پیش از نوشتن پیکربندی، یک پنجره تأیید نمایش می‌دهد.',
  'settings.mcpCodexOneClickInstall': 'نصب در Codex',
  'settings.mcpCodexOneClickUninstall': 'حذف از Codex',
  'settings.mcpCodexOneClickUnavailable': 'Codex CLI در PATH یافت نشد — Codex را نصب کنید یا قطعه کد را به‌صورت دستی بچسبانید.',
  'settings.mcpCodexInstallSuccess': 'نصب شد. برای بارگذاری سرور جدید، Codex را راه‌اندازی مجدد کنید.',
  'settings.mcpCodexUninstallSuccess': 'از Codex حذف شد.',
  'settings.mcpCodexBusy': 'در حال کار…',
  'settings.mcpCodexInstallError': 'عملیات ناموفق بود: {error}',
  'settings.mcpRestartNote': 'برای شناسایی سرور جدید، کلاینت خود را راه‌اندازی مجدد کنید.',
  'settings.mcpRestartDetail': 'بیشتر ویرایشگرها سرورهای MCP را فقط هنگام راه‌اندازی بارگذاری می‌کنند. در Cursor / VS Code / Antigravity / Windsurf می‌توانید به جای راه‌اندازی مجدد کامل، دستور `Developer: Reload Window` را از command palette اجرا کنید. Zed و Claude Code نیاز به بستن و باز کردن مجدد دارند.',
  'settings.mcpCapabilitiesTitle': 'کارهایی که Agent شما می‌تواند انجام دهد',
  'settings.mcpCapabilityRead': 'خواندن یا جستجوی هر فایلی در یک پروژه (HTML، JSX، CSS، JSON، SVG، Markdown).',
  'settings.mcpCapabilityPull': 'دریافت یک بسته طراحی در یک فراخوانی: فایل ورودی به همراه هر متغیر CSS، کامپوننت و فونتی که به آن ارجاع می‌دهد.',
  'settings.mcpCapabilityDefault': 'به‌صورت پیش‌فرض از پروژه و فایلی که در Open Design باز کرده‌اید استفاده می‌کند، بنابراین می‌توانید بگویید «این را در اپ من بساز» بدون اینکه دوباره مشخص کنید کدام طراحی.',
  'settings.mcpRunningNote': 'برای موفقیت فراخوانی‌های ابزار MCP، Open Design باید در حال اجرا باشد. اگر Agent کدنویسی خود را پیش از باز کردن Open Design راه‌اندازی کرده‌اید، Agent را راه‌اندازی مجدد کنید تا بتواند به daemon زنده دسترسی پیدا کند.',
  'entry.tabDesigns': 'طرح‌ها',
  'entry.tabTemplates': 'قالب‌ها',
  'entry.tabDesignSystems': 'سیستم‌های طراحی',
  'entry.tabConnectors': 'اتصال‌دهنده‌ها',
  'entry.openSettingsTitle': 'تنظیمات',
  'entry.openSettingsAria': 'باز کردن تنظیمات',
  'entry.discordLabel': 'پیوستن به Discord',
  'entry.discordAria': 'به Discord اوپن دیزاین بپیوندید',
  'entry.discordAriaWithOnline': 'به Discord اوپن دیزاین بپیوندید - {online}',
  'entry.discordOnlineLabel': '{count} آنلاین',
  'entry.followXLabel': 'دنبال کردن @OpenDesignHQ در X',
  'entry.followThreadsLabel': 'Follow Open Design on Threads',
  'entry.youtubeLabel': 'Open Design on YouTube',
  'entry.followInstagramLabel': 'دنبال کردن @opendesign.ai در Instagram',
  'entry.followLinkedinLabel': 'دنبال کردن Open Design در LinkedIn',
  'entry.followXiaohongshuLabel': 'دنبال کردن Open Design در Xiaohongshu',
  'entry.resizeAria': 'تغییر اندازه نوار کناری',
  'entry.loadingWorkspace': 'در حال بارگذاری فضای کاری…',
  'entry.useEverywhereTitle': 'استفاده در همه‌جا',
  'entry.useEverywhereAria': 'باز کردن راهنمای «استفاده در همه‌جا» (CLI، MCP، HTTP، Skills)',
  'entry.workspaceTeamsLabel': 'Teams',
  'entry.workspaceTeamsTitle': 'Workspace برای تیم‌ها — به ما بگویید تیم شما به چه چیزی نیاز دارد',
  'entry.workspaceTeamsAria': 'باز کردن صفحهٔ Workspace برای تیم‌ها',
  'entry.navExpand': 'باز کردن نوار کناری',
  'entry.navCollapse': 'جمع کردن نوار کناری',
  'entry.navNewProject': 'پروژه جدید',
  'entry.navHome': 'خانه',
  'entry.navProjects': 'پروژه‌ها',
  'entry.navTasks': 'خودکارسازی‌ها',
  'entry.navPlugins': 'افزونه‌ها',
  'entry.navDesignSystems': 'سیستم‌های طراحی',
  'entry.navBrands': 'کیت برند',
  'entry.navIntegrations': 'یکپارچه‌سازی‌ها',
  'workspaceTabs.project': 'پروژه',
  'workspaceTabs.pluginDetails': 'جزئیات افزونه',
  'workspaceTabs.marketplace': 'بازارچه',
  'homeHero.title': 'امروز چه چیزی طراحی می‌کنید؟',
  'homeHero.startWithTemplate': 'با یک قالب شروع کنید…',
  'homeHero.startBlankProject': '…یا یک پروژه خالی شروع کنید',
  'homeHero.templatePicker.label': 'قالب',
  'homeHero.templatePicker.searchPlaceholder': 'جستجوی قالب‌ها',
  'homeHero.templatePicker.projectTypes': 'انواع پروژه',
  'homeHero.templatesScrollHint': 'برای کاوش قالب‌های بیشتر به بالا اسکرول کنید',
  'homeHero.templatesCollapse': 'جمع کردن قالب‌ها',
  'homeHero.subtitlePrefix': 'جایگزین متن‌باز Claude Design.',
  'homeHero.placeholder': 'آنچه می‌خواهید تولید کنید را توصیف کنید…',
  'homeHero.placeholderActive': 'کوئری نمونه را ویرایش کنید یا کوئری خود را بنویسید…',
  'homeHero.carousel.hint': 'یک فایل پیوست کنید، سیستم طراحی خود را متصل کنید، یا آنچه می‌خواهید بسازید را توصیف کنید',
  'homeHero.carousel.onePageBrief': 'نوشتن خلاصه‌ی یک‌صفحه‌ای پروژه',
  'homeHero.carousel.notesToDeck': 'تبدیل یادداشت‌هایم به ارائه',
  'homeHero.carousel.signupFlow': 'طراحی ماکت فرایند ثبت‌نام',
  'homeHero.carousel.improveBrief': 'بهبود خلاصه‌ی موجود پروژه',
  'homeHero.carousel.loadingAnimation': 'ساخت یک انیمیشن بارگذاری',
  'homeHero.carousel.teamUpdateSlides': 'طراحی اسلاید برای گزارش تیمی',
  'homeHero.carousel.ordersDashboard': 'ساخت نمونه‌ی اولیه داشبورد پیگیری سفارش‌ها',
  'homeHero.carousel.productDetail': 'چیدمان صفحه‌ی جزئیات محصول',
  'homeHero.carousel.caseStudy': 'تهیه‌ی طرح کلی یک مطالعه‌ی موردی',
  'homeHero.carousel.landingIntro': 'طراحی یک مقدمه‌ی کوتاه برای صفحه‌ی فرود',
  'homeHero.carousel.pitchDeck': 'ساخت پیچ‌دک برای یک محصول جدید',
  'homeHero.carousel.appIdea': 'توصیف ایده‌ی یک اپلیکیشن',
  'homeHero.carousel.landingLayout': 'طراحی چیدمان صفحه‌ی فرود',
  'homeHero.skills': 'مهارت‌ها',
  'homeHero.addMenu': 'افزودن زمینه',
  'homeHero.addPlugin': 'افزودن افزونه',
  'homeHero.addConnectors': 'افزودن کانکتورها',
  'homeHero.addMcp': 'افزودن سرور MCP',
  'homeHero.noPlugins': 'هیچ افزونه‌ای نصب نشده است',
  'homeHero.noMcp': 'هیچ سرور MCP وجود ندارد',
  'homeHero.noConnectors': 'هیچ کانکتور متصلی وجود ندارد',
  'homeHero.applying': 'در حال اعمال…',
  'homeHero.pluginTitle': 'افزونه: {title}',
  'homeHero.pluginPrefix': 'افزونه: {title}',
  'homeHero.skillPrefix': 'مهارت: {title}',
  'homeHero.removePlugin': 'حذف افزونه',
  'homeHero.removePluginAria': 'حذف افزونه {title}',
  'homeHero.clearActivePlugin': 'پاک کردن افزونه فعال',
  'homeHero.clearActiveSkill': 'پاک کردن مهارت فعال',
  'homeHero.contextItemsResolved': '{n} مورد زمینه‌ای یافت شد',
  'homeHero.removeFile': 'حذف فایل',
  'homeHero.contextSearchResults': 'نتایج جستجوی زمینه',
  'homeHero.contextSurfaces': 'سطوح زمینه',
  'homeHero.loadingContext': 'در حال بارگذاری زمینه…',
  'homeHero.noResults': 'نتیجه‌ای برای «{query}» یافت نشد.',
  'homeHero.searchPrompt': 'جستجوی فایل‌ها، افزونه‌ها، مهارت‌ها، سرورهای MCP و کانکتورها.',
  'homeHero.parameters': '{n} پارامتر',
  'homeHero.details': 'جزئیات',
  'homeHero.toRun': 'برای اجرا',
  'homeHero.forNewLine': 'برای خط جدید',
  'homeHero.run': 'اجرا',
  'homeHero.typeSomethingToRun': 'چیزی برای اجرا تایپ کنید',
  'homeHero.promptExamples': 'نمونه‌ها',
  'homeHero.footer.designSystem': 'سبک',
  'homeHero.footer.autoDesignSystem': 'خودکار',
  'homeHero.footer.autoDesignSystemSummary': 'به‌صورت خودکار مناسب‌ترین سیستم طراحی و سبک بصری را برای پرامپت فعلی انتخاب می‌کند.',
  'homeHero.footer.ratio': 'نسبت',
  'homeHero.footer.duration': 'مدت',
  'homeHero.footer.resolution': 'وضوح',
  'homeHero.footer.speakerNotes': 'یادداشت‌ها',
  'homeHero.footer.noSpeakerNotes': 'بدون یادداشت',
  'homeHero.footer.availableCount': '{n} در دسترس',
  'homeHero.footer.noMatches': 'موردی یافت نشد',
  'homeHero.moreShortcuts': 'بیشتر',
  'homeHero.railAria': 'یک دسته پروژه یا میانبر شروع را انتخاب کنید',
  'homeHero.subTypeAria': 'یک زیرنوع را انتخاب کنید',
  'homeHero.subTypeMore': 'بیشتر',
  'homeHero.confirmReplaceTitle': 'دستور فعلی جایگزین شود؟',
  'homeHero.confirmReplaceBody': 'استفاده از {title} متنی را که اکنون در ورودی است جایگزین می‌کند.',
  'homeHero.confirmReplace': 'جایگزینی',
  'homeHero.chip.prototype': 'نمونه اولیه',
  'homeHero.chip.webClone': 'همتاسازی وب‌سایت',
  'homeHero.chip.liveArtifact': 'آرتیفکت زنده',
  'homeHero.chip.deck': 'اسلاید',
  'homeHero.chip.image': 'تصویر',
  'homeHero.chip.video': 'ویدیو',
  'homeHero.chip.hyperframes': 'HyperFrames',
  'homeHero.chip.webgl': 'تجربه WebGL',
  'homeHero.chip.webglDesc': 'شیدرها، سه‌بعدی و بصری‌های مولد GPU',
  'homeHero.chip.worker': 'ویژوالایزر Worker',
  'homeHero.chip.workerDesc': 'شبیه‌سازی خارج از رشته، ذرات و مصورسازی داده',
  'homeHero.chip.audio': 'صدا',
  'homeHero.chip.createBrandKit': 'ساخت کیت برند',
  'homeHero.chip.createPlugin': 'ساخت افزونه',
  'homeHero.chip.figma': 'از Figma',
  'homeHero.chip.folder': 'از پوشه',
  'homeHero.chip.template': 'از قالب',
  'homeHero.chip.liveArtifactHint': 'یک آرتیفکت تعاملی HTML/CSS/JS بسازید که بتوانید آن را به‌صورت زنده پیش‌نمایش کنید.',
  'homeHero.chip.hyperframesHint': 'ساخت موشن مبتنی بر HTML: زیرنویس‌ها، تصاویر واکنش‌گرا به صدا، گذارهای صحنه.',
  'homeHero.chip.createBrandKitHint': 'یک کیت برند را از یک وب‌سایت استخراج کنید و در هر گفت‌وگویی به‌کار ببرید.',
  'homeHero.chip.createPluginHint': 'یک افزونه قابل استفاده مجدد Open Design بسازید و آن را به افزونه‌های من اضافه کنید.',
  'homeHero.chip.figmaHint': 'یک فریم Figma را به سیستم طراحی فعال منتقل کنید.',
  'homeHero.chip.folderHint': 'یک پوشه محلی موجود را وارد کنید و ویرایش را ادامه دهید.',
  'homeHero.chip.templateHint': 'از یک قالب همراه شروع کنید.',
  'homeHero.chip.wireframe': 'Wireframe',
  'homeHero.chip.mobile': 'Mobile app',
  'homeHero.chip.document': 'Document',
  'homeHero.chip.prototypeDesc': 'Interactive app mockups',
  'homeHero.chip.webCloneDesc': 'Source-first site reproduction',
  'homeHero.chip.wireframeDesc': 'Lo-fi screens & flows',
  'homeHero.chip.mobileDesc': 'iOS & Android screens',
  'homeHero.chip.deckDesc': 'Presentations & pitch decks',
  'homeHero.chip.documentDesc': 'Resumes, reports & PDFs',
  'homeHero.chip.imageDesc': 'Posters, graphics & art',
  'homeHero.chip.videoDesc': 'Clips, reels & promos',
  'homeHero.chip.audioDesc': 'Voiceovers, music & SFX',
  'homeHero.chip.hyperframesDesc': 'Motion graphics & loops',
  'homeHero.chip.liveArtifactDesc': 'Data-backed live dashboards',
  'homeHero.chip.createBrandKitDesc': 'Extract a brand design system',
  'homeHero.chip.prototypeNext': 'Open a chat that builds a high-fidelity, clickable web prototype you refine turn by turn.',
  'homeHero.chip.webCloneNext': 'Open a chat that asks for a target URL, reconstructs the site, and audits the clone.',
  'homeHero.chip.wireframeNext': 'Open a chat that sketches lo-fi screens and flows to validate structure first.',
  'homeHero.chip.mobileNext': 'Open a chat that lays out mobile screens for iOS and Android.',
  'homeHero.chip.deckNext': 'Open a chat that builds a slide deck you can present and export.',
  'homeHero.chip.documentNext': 'Open a chat that drafts a polished document — resume, report, or PDF.',
  'homeHero.chip.imageNext': 'Open a chat that generates on-brand images you can iterate on.',
  'homeHero.chip.videoNext': 'Open a chat that produces a short video you can refine.',
  'homeHero.chip.audioNext': 'Open a chat that creates voiceover, music, or sound effects.',
  'homeHero.chip.webClonePromptSeed': 'Website URL to clone: ',
  'homeWorkingDir.trigger': 'Select working directory',
  'homeWorkingDir.pick': 'Choose folder',
  'homeWorkingDir.replace': 'Change working directory',
  'homeWorkingDir.recent': 'Recent folders',
  'homeWorkingDir.recentEmpty': 'No recent folders',
  'homeWorkingDir.clear': 'Remove working directory',
  'homeWorkingDir.hint': 'Let the agent read this local folder (not imported into Design Files)',
  'homeWorkingDir.missing': 'This working folder no longer exists — pick another',
  'homeWorkingDir.applyFailed': 'Couldn\'t set the working directory — the folder may no longer exist',
  'workingDirPicker.title': 'پوشه',
  'workingDirPicker.homeTitle': 'در ذخیره‌سازی محلی ذخیره می‌شود — برای انتخاب پوشه کلیک کنید',
  'workingDirPicker.processing': 'در حال پردازش…',
  'workingDirPicker.select': 'ذخیره‌سازی محلی',
  'workingDirPicker.clearAria': 'پاک کردن دایرکتوری کاری',
  'workingDirPicker.replaceFailed': 'امکان جایگزینی دایرکتوری کاری وجود نداشت',
  'workingDirPicker.unavailable': 'انتخابگر پوشه در این نسخه در دسترس نیست. برای انتخاب پوشه، اپلیکیشن دسکتاپ را اجرا کنید.',
  'workingDirPicker.openUnavailable': 'برای نمایش پوشه، این پروژه را در اپلیکیشن دسکتاپ باز کنید.',
  'workingDirPicker.openFailed': 'امکان نمایش این پوشه وجود نداشت',
  'workingDirPicker.showInFileManager': 'نمایش در مدیر فایل',
  'workingDirPicker.replace': 'انتخاب پوشه…',
  'workingDirPicker.recent': 'دایرکتوری‌های اخیر',
  'workingDirPicker.defaultLabel': 'حافظهٔ محلی',
  'handoff.toTarget': 'واگذاری به {target}',
  'handoff.openInTarget': 'باز کردن در {target}',
  'handoff.openAction': 'باز کردن',
  'handoff.menuTitle': 'در کدام ویرایشگر باز شود؟',
  'handoff.action': 'واگذاری',
  'handoff.fallbackTitle': 'هیچ ویرایشگری در $PATH یافت نشد - در {target} باز می‌شود',
  'handoff.chooseTargetAria': 'انتخاب مقصد واگذاری',
  'handoff.optionsAria': 'گزینه‌های واگذاری',
  'handoff.editorSection': 'باز کردن با ویرایشگر',
  'handoff.cliSection': 'کپی برای CLI',
  'handoff.clickOpen': 'برای باز کردن کلیک کنید',
  'handoff.framework': 'فریم‌ورک کد',
  'handoff.framework.react': 'React',
  'handoff.framework.vue': 'Vue.js',
  'handoff.framework.svelte': 'Svelte',
  'handoff.framework.solid': 'SolidJS',
  'handoff.framework.next': 'Next.js',
  'handoff.framework.vanilla': 'JS',
  'handoff.frameworkPrompt.react': 'React',
  'handoff.frameworkPrompt.vue': 'Vue.js',
  'handoff.frameworkPrompt.svelte': 'Svelte',
  'handoff.frameworkPrompt.solid': 'SolidJS',
  'handoff.frameworkPrompt.next': 'Next.js / React',
  'handoff.frameworkPrompt.vanilla': 'JavaScript، HTML و CSS خام',
  'handoff.amrWebsite': 'باز کردن وب‌سایت Open Design Cloud',
  'handoff.copyPrompt': 'کپی پرامپت',
  'handoff.copyPromptForTarget': 'کپی پرامپت برای {target}',
  'handoff.copied': 'کپی شد',
  'handoff.projectPathUnavailable': 'مسیر پروژه هنوز در حال بارگذاری است. لحظه‌ای دیگر دوباره تلاش کنید.',
  'handoff.copyFailed': 'نوشتن در کلیپ‌بورد مسدود شد. لحظه‌ای دیگر دوباره تلاش کنید.',
  'handoff.promptIntro': 'ادامه از این پوشه محلی پروژه Open Design:',
  'handoff.promptTarget': 'مقصد',
  'handoff.promptCli': 'CLI',
  'handoff.promptStepsLead': 'شما کنترل را در {cli} به دست می‌گیرید. لطفاً:',
  'handoff.promptReadFiles': 'ابتدا وارد این دایرکتوری شوید یا آن را بخوانید. به DESIGN.md، README، فایل‌های HTML/CSS/JS موجود، دارایی‌ها و package.json (در صورت وجود) اولویت بدهید.',
  'handoff.promptKeepDesign': 'طراحی بصری، چیدمان، تعامل‌ها و دارایی‌های فعلی را حفظ کنید. در حد یک نقشه متوقف نشوید.',
  'handoff.promptProduceCode': 'کد واقعی و قابل اجرای {framework} تولید یا اصلاح کنید. اگر پروژه از قبل استک واضح‌تری دارد، تعارض را اعلام کرده و نتیجه را قابل اجرا نگه دارید.',
  'handoff.promptVerify': 'در پایان، دستورهای اجرا، پیش‌نمایش و راستی‌آزمایی را به من بگویید.',
  'handoff.promptCommandHint': 'برای شروع از دایرکتوری پروژه، از این استفاده کنید:',
  'handoff.promptProject': 'پروژه',
  'handoff.promptProjectId': 'شناسه پروژه',
  'handoff.notInstalled': 'نصب نشده',
  'handoff.notDetectedTitle': '{target} - در $PATH شناسایی نشد',
  'designSystemPicker.select': 'انتخاب سیستم طراحی',
  'designSystemPicker.loading': 'در حال بارگذاری سیستم‌های طراحی…',
  'designSystemPicker.searchPlaceholder': 'جستجوی سیستم‌های طراحی (عنوان / دسته‌بندی / خلاصه)',
  'designSystemPicker.searchCompactPlaceholder': 'جستجوی سیستم‌های طراحی',
  'designSystemPicker.noneTitle': 'بدون سیستم طراحی',
  'designSystemPicker.noneSummary': 'اجازه بده مدل آزادانه انتخاب کند',
  'designSystemPicker.empty': 'سیستم طراحی منطبقی یافت نشد',
  'designSystemPicker.openPreview': 'باز کردن پیش‌نمایش',
  'designSystemPicker.loadingPreview': 'در حال بارگذاری پیش‌نمایش…',
  'designSystemPicker.noPreview': 'صفحه پیش‌نمایشی وجود ندارد. برای مشاهده پیش‌نمایش کامل، Design Systems را باز کنید.',
  'designSystemPicker.previewHint': 'برای پیش‌نمایش یک سیستم طراحی، نشانگر را روی آن ببرید',
  'designSystemPicker.fullscreenAria': 'پیش‌نمایش تمام‌صفحه {title}',
  'designSystemPicker.closeFullscreen': 'بستن پیش‌نمایش تمام‌صفحه',
  'designSystemPicker.closeEsc': 'بستن (Esc)',
  'designSystemPicker.previewFrameTitle': 'پیش‌نمایش {title}',
  'designSystemPicker.fullscreenFrameTitle': 'پیش‌نمایش تمام‌صفحه {title}',
  'recentProjects.title': 'پروژه‌های اخیر',
  'recentProjects.viewAll': 'مشاهده همه',
  'recentProjects.empty': 'هنوز پروژه‌ای وجود ندارد — برای شروع یک پرامپت تایپ کنید.',
  'pluginsHome.title': 'انجمن',
  'pluginsHome.subtitle': 'گردش‌کارهای آماده Open Design که همراه این runtime ارائه شده‌اند. یکی را برای بارگذاری یک پرامپت شروع انتخاب کنید، یا برای موارد بیشتر در رجیستری بگردید.',
  'pluginsHome.browseRegistry': 'مرور رجیستری',
  'pluginsHome.count': '{filtered} از {total}',
  'pluginsHome.loadingCatalog': 'در حال بارگذاری کاتالوگ…',
  'pluginsHome.emptyCatalog': 'کاتالوگ خالی است. پلاگین‌های همراه با Open Design ارائه می‌شوند و باید به‌صورت خودکار اینجا نمایش داده شوند — اگر این مشکل ادامه داشت، daemon را مجدداً راه‌اندازی کنید.',
  'pluginsHome.emptyFiltered': 'هیچ افزونه‌ای با فیلترهای فعلی مطابقت ندارد.',
  'pluginsHome.clearFilters': 'پاک کردن فیلترها',
  'pluginsHome.modeAria': 'حالت افزونه',
  'pluginsHome.featured': 'ذخیره شد',
  'pluginsHome.totalInCatalog': '{n} مورد در کاتالوگ',
  'pluginsHome.categoryFilterAria': 'فیلتر دسته‌بندی',
  'pluginsHome.subcategoryFilterAria': 'فیلتر زیرمجموعه {label}',
  'pluginsHome.allCategory': 'همه {label}',
  'pluginsHome.searchPlaceholder': 'جستجوی پلاگین‌ها…',
  'pluginsHome.searchAria': 'جستجوی افزونه‌ها',
  'pluginsHome.clearSearch': 'پاک کردن جستجو',
  'pluginsHome.sortAria': 'ترتیب مرتب‌سازی',
  'pluginsHome.sortHot': 'پرطرفدار',
  'pluginsHome.sortNewest': 'جدیدترین',
  'pluginsHome.facet.import': 'وارد کردن',
  'pluginsHome.facet.create': 'ایجاد',
  'pluginsHome.facet.export': 'خروجی گرفتن',
  'pluginsHome.facet.share': 'اشتراک‌گذاری',
  'pluginsHome.facet.deploy': 'استقرار',
  'pluginsHome.facet.refine': 'پالایش',
  'pluginsHome.facet.extend': 'گسترش',
  'pluginsHome.facet.figma': 'Figma',
  'pluginsHome.facet.github': 'GitHub',
  'pluginsHome.facet.codeFolder': 'کد / پوشه',
  'pluginsHome.facet.url': 'URL',
  'pluginsHome.facet.screenshot': 'اسکرین‌شات',
  'pluginsHome.facet.pdf': 'PDF',
  'pluginsHome.facet.pptx': 'PPTX',
  'pluginsHome.facet.framer': 'Framer',
  'pluginsHome.facet.webflow': 'Webflow',
  'pluginsHome.facet.slides': 'اسلایدها',
  'pluginsHome.facet.publicLink': 'پیوند عمومی',
  'pluginsHome.facet.githubPr': 'GitHub PR',
  'pluginsHome.facet.githubGist': 'GitHub Gist',
  'pluginsHome.subfacet.business-dashboards': 'داشبوردها',
  'pluginsHome.subfacet.app-prototypes': 'اپلیکیشن\u200cها',
  'pluginsHome.subfacet.landing-marketing': 'لندینگ / بازاریابی',
  'pluginsHome.subfacet.developer-tools': 'ابزارهای توسعه\u200cدهنده',
  'pluginsHome.subfacet.docs-reports': 'اسناد / گزارش\u200cها',
  'pluginsHome.subfacet.brand-design': 'برند / طراحی',
  'pluginsHome.subfacet.pitch-business': 'پیچ / کسب\u200cوکار',
  'pluginsHome.subfacet.course-training': 'دوره / آموزش',
  'pluginsHome.subfacet.reports-briefings': 'گزارش\u200cها / خلاصه\u200cها',
  'pluginsHome.subfacet.product-sales': 'محصول / فروش',
  'pluginsHome.subfacet.engineering-talks': 'ارائه\u200cهای فنی',
  'pluginsHome.subfacet.creative-decks': 'دک\u200cهای خلاقانه',
  'pluginsHome.subfacet.ui-product-mockups': 'رابط کاربری / ماکاپ',
  'pluginsHome.subfacet.brand-visuals': 'برند / لوگو',
  'pluginsHome.subfacet.storyboards-motion-refs': 'استوری\u200cبورد',
  'pluginsHome.subfacet.social-content': 'شبکه اجتماعی / محتوا',
  'pluginsHome.subfacet.avatar-portrait': 'آواتار / پرتره',
  'pluginsHome.subfacet.illustration-style': 'تصویرسازی / سبک',
  'pluginsHome.subfacet.motion-effects': 'موشن / جلوه\u200cها',
  'pluginsHome.subfacet.social-short-form': 'شبکه اجتماعی / ویدیو کوتاه',
  'pluginsHome.subfacet.marketing-product': 'بازاریابی / محصول',
  'pluginsHome.subfacet.data-explainers': 'داده / توضیح',
  'pluginsHome.subfacet.cinematic-story': 'سینمایی / روایت',
  'pluginsHome.commercialCategory.student-coursework': 'Student coursework',
  'pluginsHome.commercialCategory.corporate-strategy': 'Corporate strategy',
  'pluginsHome.commercialCategory.professional-training': 'Professional training',
  'pluginsHome.commercialCategory.b2b-sales': 'B2B sales',
  'pluginsHome.commercialCategory.academic-research': 'Academic research',
  'pluginsHome.commercialCategory.marketing-gtm': 'Marketing & GTM',
  'pluginsHome.commercialCategory.data-finance': 'Data & finance',
  'pluginsHome.commercialCategory.fundraising-pitch': 'Fundraising pitch',
  'pluginsHome.commercialCategory.government-policy': 'Government & policy',
  'pluginsHome.commercialCategory.product-management': 'Product management',
  'pluginsHome.commercialCategory.consulting': 'Consulting',
  'pluginsHome.commercialCategory.career': 'Career',
  'pluginsHome.commercialCategory.ai-literacy': 'AI literacy',
  'pluginsHome.commercialCategory.life': 'Life & story',
  'pluginsHome.commercialCategory.design-craft': 'Design craft',
  'pluginsView.lede': 'گردش‌کارهای نصب‌شده را مرور کنید، ورودی‌های رجیستری را کشف کنید، منابع را مدیریت کنید و افزونه‌ها را برای توزیع تیمی آماده کنید.',
  'pluginsView.importPlugin': 'وارد کردن افزونه',
  'pluginsView.agentContext': 'زمینه Agent',
  'pluginsView.summaryAria': 'خلاصه افزونه',
  'pluginsView.areasAria': 'حوزه‌های افزونه',
  'pluginsView.loading': 'در حال بارگذاری پلاگین‌ها…',
  'pluginsView.tab.installed': 'نصب‌شده',
  'pluginsView.tab.available': 'در دسترس',
  'pluginsView.tab.sources': 'منابع',
  'pluginsView.tab.team': 'تیم',
  'pluginsView.tabHint.installed': 'افزونه‌های شما',
  'pluginsView.tabHint.available': 'از منابع',
  'pluginsView.tabHint.sources': 'کاتالوگ‌ها',
  'pluginsView.tabHint.team': 'سازمانی',
  'pluginsView.installedTitle': 'افزونه‌های نصب‌شده',
  'pluginsView.installedSubtitle': 'افزونه‌هایی که از منابع مارکت‌پلیس وارد یا نصب کرده‌اید.',
  'pluginsView.installedEmpty': 'هنوز هیچ افزونه کاربری نصب‌شده‌ای وجود ندارد. از ایجاد / وارد کردن استفاده کنید یا یک مورد در دسترس را نصب کنید.',
  'pluginsView.availableTitle': 'در دسترس از منابع',
  'pluginsView.availableSubtitle': 'ورودی‌های کاتالوگ کشف‌شده از مارکت‌پلیس‌های پیکربندی‌شده.',
  'pluginsView.availableFiltersAria': 'فیلترهای افزونه‌های در دسترس',
  'pluginsView.searchAvailableAria': 'جستجوی افزونه‌های در دسترس',
  'pluginsView.searchAvailablePlaceholder': 'جستجوی افزونه‌های در دسترس',
  'pluginsView.clearAvailableSearch': 'پاک کردن جستجوی افزونه‌های در دسترس',
  'pluginsView.source': 'منبع',
  'pluginsView.availableEmptyInstalled': 'هنوز هیچ مورد در دسترسی وجود ندارد. ورودی‌های کاتالوگ نصب‌شده از بخش در دسترس حذف می‌شوند؛ یکی را حذف نصب کنید تا دوباره در دسترس قرار گیرد.',
  'pluginsView.availableEmptyFiltered': 'هیچ مورد در دسترسی با فیلترهای شما مطابقت ندارد.',
  'pluginsView.availableEmptyNoSources': 'هنوز هیچ مورد در دسترسی وجود ندارد. یک منبع را در زبانه منابع اضافه کنید.',
  'pluginsView.installing': 'در حال نصب…',
  'pluginsView.install': 'نصب',
  'pluginsView.sourcesTitle': 'منابع رجیستری',
  'pluginsView.sourcesSubtitle': 'کاتالوگ‌های Marketplace که ورودی‌های افزونه‌های در دسترس را تأمین می‌کنند.',
  'pluginsView.sourceUrl': 'URL منبع',
  'pluginsView.defaultTrust': 'اعتماد پیش‌فرض',
  'pluginsView.trust.restricted': 'محدودشده',
  'pluginsView.trust.trusted': 'مورد اعتماد',
  'pluginsView.trust.official': 'رسمی',
  'pluginsView.adding': 'در حال افزودن…',
  'pluginsView.addSource': 'افزودن منبع',
  'pluginsView.sourcesEmpty': 'هنوز هیچ منبع رجیستری‌ای پیکربندی نشده است.',
  'pluginsView.pluginsCount': '{n} افزونه',
  'pluginsView.catalogVersion': 'کاتالوگ نسخه {version}',
  'pluginsView.trustFor': 'اعتماد برای {name}',
  'pluginsView.refreshing': 'در حال به‌روزرسانی…',
  'pluginsView.removing': 'در حال حذف…',
  'pluginsView.teamTitle': 'Marketplaceهای خصوصی تیمی',
  'pluginsView.teamBody': 'این بخش برای کاتالوگ‌های سازمانی و تیمی، سیاست‌های اعتماد خصوصی و کنترل‌های مشترک چرخه عمر افزونه رزرو شده است.',
  'pluginCard.details': 'جزئیات',
  'pluginCard.use': 'استفاده',
  'pluginCard.useWithQuery': 'استفاده با عبارت جستجو',
  'pluginCard.applying': 'در حال اعمال…',
  'pluginCard.duplicate': 'Remix',
  'pluginCard.duplicating': 'در حال Remix…',
  'pluginCard.duplicateFailed': 'امکان Remix این قالب وجود نداشت.',
  'pluginCard.saved': 'ذخیره شد',
  'pluginCard.publish': 'انتشار',
  'pluginCard.contribute': 'مشارکت',
  'pluginCard.starting': 'در حال شروع…',
  'pluginCard.detailsAria': 'مشاهده جزئیات {title}',
  'pluginCard.chooseUseAria': 'نحوه استفاده از {title} را انتخاب کنید',
  'pluginCard.useOptionsAria': 'گزینه‌های استفاده برای {title}',
  'pluginCard.duplicateAria': 'Remix کردن {title} به‌عنوان پروژه جدید',
  'pluginCard.saveAria': 'ذخیره {title}',
  'pluginCard.savedAria': '{title} ذخیره شده است',
  'pluginCard.shareAria': 'اشتراک‌گذاری {title}',
  'pluginCard.publishAria': 'انتشار {title} به‌عنوان یک مخزن GitHub',
  'pluginCard.publishTitle': 'انتشار افزونه به‌عنوان یک مخزن GitHub',
  'pluginCard.contributeAria': 'مشارکت {title} در Open Design',
  'pluginCard.contributeTitle': 'مشارکت افزونه در Open Design با یک PR',
  'skillPluginCandidate.createForMe': 'ساخت افزونه/قالب',
  'skillPluginCandidate.contributeToMain': 'مشارکت در open-design',
  'skillPluginCandidate.repoDescription': 'به نظر می‌رسد این مخزن می‌تواند به‌عنوان یک افزونه کار کند.',
  'integrations.kicker': 'یکپارچه‌سازی',
  'integrations.lede': 'سیستم‌های خارجی را متصل کنید، ابزارهای MCP را به حلقه Agent خود بیاورید و از Open Design در سایر IDEها، اسکریپت‌ها و خودکارسازی‌ها استفاده کنید.',
  'integrations.agentReady': 'آماده برای Agent',
  'integrations.areasAria': 'حوزه‌های یکپارچه‌سازی',
  'integrations.tabLabel.mcp': 'MCP',
  'integrations.tabLabel.skills': 'مهارت‌ها',
  'integrations.tabHint.mcp': 'ابزارهای خارجی',
  'integrations.tabHint.connectors': 'حساب‌ها و APIها',
  'integrations.tabHint.useEverywhere': 'CLI، HTTP، MCP',
  'integrations.skillsTitle': 'یکپارچه‌سازی‌های مهارت‌ها',
  'integrations.skillsBody': 'مدیریت یکپارچه‌سازی در سطح مهارت از شاخه‌ای دیگر در حال انتقال است. این برگه رزرو شده تا راه‌اندازی MCP، Connectorها و مهارت‌های آینده در همان مسیر یکپارچه‌سازی قرار گیرند.',
  'mcpClient.title': 'سرورهای خارجی MCP',
  'mcpClient.subtitle': 'ابزارهای شخص ثالث برای Agent کدنویسی شما.',
  'mcpClient.addServer': 'افزودن سرور',
  'mcpClient.emptyTitle': 'هیچ سرور MCP پیکربندی نشده است.',
  'mcpClient.emptyBody': 'برای شروع روی «افزودن سرور» کلیک کنید — یک قالب انتخاب کنید (Higgsfield OpenClaw، Pollinations، Allyson، Imagician، EdgeOne Pages، GitHub، Filesystem…) یا یک سرور سفارشی stdio / HTTP راه‌اندازی کنید.',
  'mcpClient.saveChanges': 'ذخیره تغییرات',
  'mcpClient.storedAt': 'ذخیره‌شده در',
  'mcpClient.daemonError': 'دسترسی به daemon محلی ممکن نشد. مطمئن شوید Open Design در حال اجراست، سپس این پنل را دوباره باز کنید.',
  'mcpClient.saveFailed': 'ذخیره ناموفق بود. بررسی کنید که daemon در حال اجرا باشد و دوباره تلاش کنید.',
  'useEverywhere.modalAria': 'استفاده از Open Design در همه‌جا',
  'useEverywhere.modalTitle': 'استفاده از Open Design در همه‌جا',
  'useEverywhere.modalSubtitle': 'Open Design را در هر IDE، Agent یا اسکریپتی بگنجانید — CLI، HTTP، MCP و Skills. از «Copy guide for an agent» استفاده کنید و آن را در Claude Code، Codex، Cursor، openclaw یا hermes جای‌گذاری کنید تا همه‌چیز راه‌اندازی شود.',
  'useEverywhere.closeAria': 'بستن استفاده در همه‌جا',
  'useEverywhere.closeTitle': 'بستن (Esc)',
  'useEverywhere.tabsAria': 'سطوح یکپارچه‌سازی',
  'useEverywhere.footStrong': 'انتقال با یک کلیک.',
  'useEverywhere.footBody': 'یک راهنمای ساختاریافته به فرمت markdown کپی می‌کند که Agent شما می‌تواند بلافاصله بر اساس آن عمل کند — نصب، تأیید و استفاده.',
  'useEverywhere.configureMcp': 'پیکربندی سرور MCP',
  'useEverywhere.copyGuide': 'کپی راهنما برای یک Agent',
  'useEverywhere.copy': 'کپی',
  'useEverywhere.copied': 'کپی شد',
  'useEverywhere.copyFailed': 'کپی ناموفق بود',
  'useEverywhere.copySnippetAria': 'کپی قطعه: {label}',
  'useEverywhere.section.overview.tab': 'نمای کلی',
  'useEverywhere.section.overview.heading': 'Open Design هر جا که Agent شما کار کند، کار می‌کند',
  'useEverywhere.section.overview.intro': 'Open Design چیزی فراتر از یک پنجره است — یک daemon محلیِ دارای دسترسی ویژه (`od`) به‌علاوه یک رجیستری از Skills + Design-Systems + Atoms است. به‌محض اینکه روی دستگاه شما در حال اجرا باشد، هر code agent (Claude Code، Codex، Cursor، OpenCode/openclaw، Hermes، یا اسکریپت خودتان) می‌تواند تولیدها را هدایت کند، پروژه‌ها را بررسی کند و از طریق چهار سطح قابل‌تعویض، آثار طراحی تولید کند.',
  'useEverywhere.section.overview.bullet1': 'CLI — `od <command>` برای اسکریپت‌های headless، CI و اتوماسیون shell.',
  'useEverywhere.section.overview.bullet2': 'سرور MCP — Open Design را به‌عنوان یک سرور Model Context Protocol سیم‌کشی می‌کند تا هر Agent سازگار با MCP بتواند skillها را فهرست کند، سناریوها را اجرا کند و آثار را بخواند.',
  'useEverywhere.section.overview.bullet3': 'HTTP API — نقاط پایانی REST + SSE در `http://127.0.0.1:7456/api/*`؛ همان سطحی که رابط وب از آن استفاده می‌کند.',
  'useEverywhere.section.overview.bullet4': 'Skills — بسته‌های آمادهٔ `SKILL.md` (سازگار با Claude) که هر Agent موجود در PATH شما می‌تواند بدون نیاز به Open Design اصلاً فراخوانی‌شان کند.',
  'useEverywhere.section.overview.bullet5': 'آثار استاندارد — پیش از شروع daemon، پروژه‌های واقعی HTML را از Skills، پلاگین‌های پیش‌فرض همراه و نمونه‌های پلاگین جامعه بسازید.',
  'useEverywhere.section.overview.snippet1': 'اجرای daemon (و رابط کاربری وب) به صورت محلی',
  'useEverywhere.section.overview.snippet2': 'از در دسترس بودن آن مطمئن شوید',
  'useEverywhere.section.overview.snippet3': 'دریافت آرتیفکت‌های استاندارد پیش از راه‌اندازی',
  'useEverywhere.section.overview.footer': 'daemon به صورت پیش‌فرض در `./.od/` (محلی پروژه) می‌نویسد. برای اشتراک‌گذاری داده‌ها میان پروژه‌ها، `OD_DATA_DIR=~/.open-design` را تنظیم کنید.',
  'useEverywhere.section.cli.tab': 'CLI · od',
  'useEverywhere.section.cli.heading': 'کنترل Open Design از هر shell',
  'useEverywhere.section.cli.intro': 'باینری `od` همراه با daemon ارائه می‌شود و همان باینری‌ای است که Claude Code / Codex هنگام اجرای یک تولید از آن استفاده می‌کنند. بیشتر زیرفرمان‌ها کلاینت‌های سبکی هستند که به daemon محلی درخواست POST می‌فرستند، بنابراین چه آن را با `pnpm tools-dev` راه‌اندازی کرده باشید و چه به‌عنوان یک اپلیکیشن بسته‌بندی‌شده، یکسان کار می‌کنند.',
  'useEverywhere.section.cli.bullet1': '`od` (بدون آرگومان) — daemon را بوت می‌کند و رابط وب را باز می‌کند.',
  'useEverywhere.section.cli.bullet2': '`od media generate ...` — تولید بایت‌های تصویر / ویدیو / صدا از طریق پروتکل یکپارچهٔ رسانه.',
  'useEverywhere.section.cli.bullet3': '`od run ...` — شروع یک اجرای پروژه از یک پرامپت + skill.',
  'useEverywhere.section.cli.bullet4': '`od plugin install <source>` / `od plugin apply <id>` — نصب و اعمال پلاگین‌های جامعه.',
  'useEverywhere.section.cli.bullet5': '`od skills list` / `od design-systems list` — بررسی آنچه به‌صورت محلی در دسترس است.',
  'useEverywhere.section.cli.bullet6': '`od status` / `od doctor` — تأیید سلامت daemon و شناسایی CLIهای Agent در PATH شما.',
  'useEverywhere.section.cli.snippet1': 'تولید یک تصویر (به ارائه‌دهنده رسانه پیکربندی‌شده واگذار می‌شود)',
  'useEverywhere.section.cli.snippet2': 'اجرای بدون رابط یک پلاگین سناریو و استریم رویدادها به‌صورت خطوط JSON',
  'useEverywhere.section.cli.snippet3': 'فهرست‌برداری از مهارت‌ها و سیستم‌های طراحی در دسترس محلی',
  'useEverywhere.section.cli.snippet4': 'بررسی آرتیفکت‌های مقداردهی‌شده از طریق CLI',
  'useEverywhere.section.cli.snippet5': 'تأیید محیط + Agentهای شناسایی‌شده (Claude، Codex، Cursor، …)',
  'useEverywhere.section.cli.footer': 'همهٔ زیردستورها `--daemon-url http://127.0.0.1:<port>` را می‌پذیرند تا یک daemon در حال اجرای مشخص را هدف بگیرند — هنگام اجرای یک نمونهٔ دومِ sandboxed برای تست‌ها مفید است.',
  'useEverywhere.section.mcp.tab': 'سرور MCP',
  'useEverywhere.section.mcp.heading': 'در معرض قرار دادن Open Design به‌عنوان یک سرور MCP برای هر Agent کدنویسی',
  'useEverywhere.section.mcp.intro': 'Open Design با یک سرور Model Context Protocol (`od mcp`) ارائه می‌شود که به هر کلاینت سازگار با MCP — Cursor، Claude Code، Antigravity، VS Code Copilot Chat، openclaw، hermes — اجازه می‌دهد ابزارهای Open Design را کشف کند (فهرست‌کردن skillها، رندر پیش‌نمایش‌ها، تولید رسانه، اجرای پلاگین‌ها) بدون نیاز به اجرای دستی در shell. این daemon برای هر کلاینت اصلی یک قطعهٔ نصب آمادهٔ جای‌گذاری را از طریق `GET /api/mcp/install-info` منتشر می‌کند.',
  'useEverywhere.section.mcp.bullet1': 'انتقال stdio — بدون پورت اضافی، کلاینت مستقیماً `od mcp` را اجرا می‌کند.',
  'useEverywhere.section.mcp.bullet2': 'هنگام راه‌اندازی به‌عنوان sidecar، URL داعمون فعال را به‌صورت خودکار از طریق سوکت وضعیت IPC محلی کشف می‌کند.',
  'useEverywhere.section.mcp.bullet3': 'برای نصب‌های ساده به `--daemon-url http://127.0.0.1:<port>` بازمی‌گردد تا فرایند MCP همیشه یک daemon در حال اجرا پیدا کند.',
  'useEverywhere.section.mcp.bullet4': '`OD_DATA_DIR` را پین می‌کند تا فرایند MCP ایجادشده در همان مکانی بنویسد که daemon از پیش استفاده می‌کند (از EPERM در باندل‌های اپلیکیشن بسته‌بندی‌شده macOS جلوگیری می‌کند).',
  'useEverywhere.section.mcp.snippet1': 'پیکربندی عمومی کلاینت MCP (در Cursor، Claude Code، Codex، … کار می‌کند)',
  'useEverywhere.section.mcp.snippet2': 'یا: قطعه متناسب با نصب خود را از daemon درخواست کنید',
  'useEverywhere.section.mcp.snippet3': 'نسخه MCP آرتیفکت‌های زنده (خواندن و به‌روزرسانی داشبوردها)',
  'useEverywhere.section.mcp.footer': 'در اپلیکیشن Open Design، به Settings ← Integrations بروید تا یک دستور نصب مخصوص کلاینت (Cursor، Claude Code، Antigravity، VS Code) را کپی کنید، به‌جای ویرایش دستی JSON.',
  'useEverywhere.section.http.tab': 'API HTTP',
  'useEverywhere.section.http.heading': 'همان سطح REST + SSE که رابط کاربری وب استفاده می‌کند',
  'useEverywhere.section.http.intro': 'daemon محلی یک API HTTP را در `http://127.0.0.1:7456` ارائه می‌دهد (پورت قابل پیکربندی است). هر اندپوینتی که رابط کاربری وب فراخوانی می‌کند، برای اسکریپت‌های شما نیز قابل استفاده است. اندپوینت‌های استریمینگ (نوبت‌های گفت‌وگو، اجرای پروژه‌ها) رویدادهای Server-Sent را با انواع قرارداد موجود در `@open-design/contracts` منتشر می‌کنند.',
  'useEverywhere.section.http.bullet1': '`GET /api/health` — زنده‌بودن daemon.',
  'useEverywhere.section.http.bullet2': '`GET /api/skills` و `GET /api/design-systems` — رجیستری‌های در دسترس.',
  'useEverywhere.section.http.bullet3': '`GET /api/projects` و `POST /api/projects` — فهرست‌کردن و ایجاد پروژه‌ها (POST پروژه + اولین گفتگو را برمی‌گرداند).',
  'useEverywhere.section.http.bullet4': '`GET /api/projects/:id/chat` — جریان SSE از رویدادهای Agent برای یک گفتگو.',
  'useEverywhere.section.http.bullet5': '`POST /api/plugins/:id/apply` — یک پلاگین نصب‌شده را متصل کنید و کوئری نمونهٔ رندرشده + ورودی‌هایش را دریافت کنید.',
  'useEverywhere.section.http.bullet6': '`GET /api/agents` — CLIهای code-agent شناسایی‌شده در PATH شما.',
  'useEverywhere.section.http.snippet1': 'فهرست مهارت‌های نصب‌شده (Agent از این‌ها به‌عنوان قالب استفاده خواهد کرد)',
  'useEverywhere.section.http.snippet2': 'ساخت یک پروژه از روی یک prompt (جریان کامل سمت سرور)',
  'useEverywhere.section.http.snippet3': 'یک نوبت چت را استریم کنید (SSE — هر خط با JSON-Lines سازگار است)',
  'useEverywhere.section.http.footer': 'تایپ‌های خالص TypeScript برای هر درخواست/پاسخ در `@open-design/contracts` قرار دارند — آن‌ها را در اسکریپت خود import کنید تا بدون سیم‌کشی یک generator، تکمیل خودکار کامل داشته باشید.',
  'useEverywhere.section.skills.tab': 'مهارت‌ها و حالت بدون رابط',
  'useEverywhere.section.skills.heading': 'Skillهای آمادهٔ استفاده برای هر Agent — حتی بدون اجرای Open Design',
  'useEverywhere.section.skills.intro': 'یک Skill دایرکتوری‌ای است با یک `SKILL.md` سازگار با Claude (فرانت‌متر YAML + بدنه). Open Design این فرمت را با namespace به نام `od:` گسترش می‌دهد (`mode`، `preview`، `design_system`، `inputs`، …) تا همان اثر هم درون Open Design و هم توسط یک Agent معمولی مانند Claude Code، Codex، openclaw یا hermes قابل‌استفاده باشد. کشف از یک زنجیرهٔ اولویت پیروی می‌کند تا پروژه‌ها بتوانند skillهای خود را بازنویسی کنند.',
  'useEverywhere.section.skills.bullet1': 'کشف: `./.claude/skills/` ← `./skills/` ← `~/.claude/skills/` (پروژه برنده می‌شود).',
  'useEverywhere.section.skills.bullet2': 'یک مهارت را به چند پروژه پیوند نمادین (symlink) دهید تا بدون کپی‌کردن آن را به اشتراک بگذارید.',
  'useEverywhere.section.skills.bullet3': 'هر مهارت می‌تواند connectorها، اتم‌ها، الزامات سیستم طراحی و یک خروجی نمونه `preview` برای گالری را اعلام کند.',
  'useEverywhere.section.skills.bullet4': 'بدون رابط: یک Agent که `od` در PATH آن باشد می‌تواند `od skills list` را فراخوانی کند و سپس هر مهارتی را اجرا کند؛ daemon برای جریان‌های فقط‌خواندنی اختیاری است.',
  'useEverywhere.section.skills.bullet5': '`pnpm seed:test-projects` همان شکل آرتیفکت را با نمونه‌های پلاگین پیش‌فرض و نمونه‌های پلاگین جامعه به کار می‌گیرد، سپس پروژه‌های `index.html` حاصل را به‌عنوان داده آزمایشی قابل استفاده مجدد ذخیره می‌کند.',
  'useEverywhere.section.skills.snippet1': 'حداقل SKILL.md (front matter سازگار با Claude + افزوده‌های Open Design)',
  'useEverywhere.section.skills.snippet2': 'پیوند نمادین یک مهارت مشترک به یک پروژه (سبک cc-switch)',
  'useEverywhere.section.skills.snippet3': 'بدون رابط: فهرست مهارت‌هایی که daemon هم‌اکنون می‌بیند',
  'useEverywhere.section.skills.snippet4': 'باندل فیکسچر آرتیفکت بدون رابط',
  'useEverywhere.section.skills.footer': 'مشخصات: `docs/skills-protocol.md` و `docs/agent-adapters.md` کل سطح آداپتور (Claude Code، Codex، Cursor، Agentهای پشتیبان MCP، بازگشت به API با روش BYOK) و استراتژی‌های تزریق مهارت برای هر آداپتور را پوشش می‌دهند.',
  'tasks.kicker': 'فضای کاری اتوماسیون',
  'tasks.comingSoon': 'به‌زودی',
  'tasks.lede': 'اتوماسیون‌ها prompt‌ها را به کار پایدار تبدیل می‌کنند: Orbit آن‌ها را اجرا می‌کند، روتین‌ها آن‌ها را نگه می‌دارند، زمان‌بندی‌ها تصمیم می‌گیرند چه زمانی فعال شوند و آرتیفکت‌های زنده آنچه را تغییر کرده نشان می‌دهند.',
  'tasks.newAutomation': 'اتوماسیون جدید',
  'tasks.previewNote': 'فقط سطح پیش‌نمایش. تنظیمات Orbit امروز در دسترس‌اند؛ روتین‌ها، زمان‌بندی‌ها و اتصال آرتیفکت‌های زنده با ادغام شاخه‌های بک‌اند اضافه خواهند شد.',
  'tasks.primitivesAria': 'اصول اولیه اتوماسیون',
  'tasks.primitive.orbit.title': 'Orbit',
  'tasks.primitive.orbit.body': 'یک محیط اجرای پایدار برای کارهای طولانی‌مدت یا تکرارشونده Agent.',
  'tasks.primitive.orbit.enabled': 'خلاصه روزانه فعال شد',
  'tasks.primitive.orbit.manualOnly': 'فقط دستی',
  'tasks.primitive.routines.title': 'روتین‌ها',
  'tasks.primitive.routines.body': 'تعریف‌های پایدار وظایف که پس از پایان یک گفت‌وگوی واحد باقی می‌مانند.',
  'tasks.primitive.routines.meta': 'پوسته محصول آماده است',
  'tasks.primitive.schedules.title': 'زمان‌بندی‌ها',
  'tasks.primitive.schedules.body': 'محرک‌های زمانی یا رویدادی که تصمیم می‌گیرند یک روتین چه زمانی باید اجرا شود.',
  'tasks.primitive.schedules.meta': 'شاخه در انتظار',
  'tasks.primitive.liveArtifacts.title': 'آرتیفکت‌های زنده',
  'tasks.primitive.liveArtifacts.body': 'گزارش‌ها و یادداشت‌هایی که در حین کار Agent به‌روزرسانی می‌شوند.',
  'tasks.primitive.liveArtifacts.meta': 'مدل پیش‌نمایش',
  'tasks.listAria': 'فهرست اتوماسیون‌ها',
  'tasks.routinesAndRuns': '{n} روتین و اجرا',
  'tasks.filtersAria': 'فیلترهای اتوماسیون',
  'tasks.filter.scheduled': 'زمان‌بندی‌شده',
  'tasks.filter.running': 'در حال اجرا',
  'tasks.filter.done': 'انجام شد',
  'tasks.configurationAria': 'پیکربندی خودکارسازی',
  'tasks.slot.trigger': 'محرک',
  'tasks.slot.pattern': 'الگو',
  'tasks.slot.runtime': 'زمان اجرا',
  'tasks.slot.output': 'خروجی',
  'tasks.liveArtifact': 'آرتیفکت زنده',
  'tasks.viewProgress': 'مشاهده پیشرفت',
  'tasks.pause': 'توقف موقت',
  'tasks.runNow': 'اجرای فوری',
  'tasks.openArtifact': 'باز کردن آرتیفکت',
  'tasks.status.dailyAt': 'روزانه · {time}',
  'tasks.status.pausedManual': 'متوقف‌شده · فقط دستی',
  'tasks.sample.orbit.title': 'خلاصه کانکتور Orbit Daily',
  'tasks.sample.orbit.metaEnabled': 'چکیده کانکتور زمان‌بندی شده است',
  'tasks.sample.orbit.metaDisabled': 'تنظیمات Orbit را برای فعال‌سازی باز کنید',
  'tasks.sample.orbit.previewEnabled': 'orbit_daily.html · اثر زنده',
  'tasks.sample.orbit.previewDisabled': 'اجرایی زمان‌بندی نشده است',
  'tasks.sample.orbit.triggerEnabled': 'زمان‌بندی · روزانه در ساعت {time}',
  'tasks.sample.orbit.triggerDisabled': 'دستی · اجرا در صورت نیاز',
  'tasks.sample.orbit.pattern': 'روال · خلاصهٔ connector',
  'tasks.sample.orbit.runtime': 'Orbit · زمان‌بندی‌شده توسط daemon',
  'tasks.sample.orbit.output': 'اثر زنده · گزارش قابل‌به‌روزرسانی',
  'tasks.sample.orbit.artifactMetaEnabled': 'پس از هر اجرا به‌روزرسانی می‌شود',
  'tasks.sample.orbit.artifactMetaDisabled': 'در انتظار زمان‌بندی',
  'tasks.sample.orbit.body1': '# خلاصه فعالیت Orbit Daily',
  'tasks.sample.orbit.body2': 'connectorهای بررسی‌شده · موفقیت‌ها، رد‌شده‌ها و شکست‌ها',
  'tasks.sample.orbit.body3': 'نکات برجسته به یک آرتیفکت زنده قابل به‌روزرسانی تبدیل می‌شوند.',
  'tasks.sample.mcp.title': 'تحقیق درباره جایگزین‌های MCP',
  'tasks.sample.mcp.status': 'در حال اجرا در orbit · ۲ ساعت و ۱۴ دقیقه',
  'tasks.sample.mcp.meta': '۱۴ / ۳۰ منبع پردازش شد',
  'tasks.sample.mcp.preview': 'research_notes.md · زنده',
  'tasks.sample.mcp.trigger': 'دستی · یک‌باره',
  'tasks.sample.mcp.pattern': 'پرامپت تحقیق عمیق',
  'tasks.sample.mcp.runtime': 'از راه دور · پایدار',
  'tasks.sample.mcp.output': 'گزارش زنده · به‌روزرسانی خودکار',
  'tasks.sample.mcp.artifactMeta': '۱۲ ثانیه پیش به‌روزرسانی شد',
  'tasks.sample.mcp.body1': '# جایگزین‌های MCP - یافته‌های موقت',
  'tasks.sample.mcp.body2': '۱۴ منبع بررسی شد · ۳ گزینه در فهرست نهایی',
  'tasks.sample.mcp.body3': '## فهرست منتخب',
  'tasks.sample.mcp.body4': '- اسکیماهای فراخوانی ابزار از طریق JSON-RPC...',
  'tasks.sample.mcp.body5': '- پروتکل‌های Agent مبتنی بر gRPC...',
  'tasks.sample.weekly.title': 'چکیده هفتگی تیم',
  'tasks.sample.weekly.status': 'بعدی: دوشنبه ۹:۰۰ صبح',
  'tasks.sample.weekly.meta': 'سند هفتگی تیم را به‌روزرسانی می‌کند',
  'tasks.sample.weekly.preview': 'team_weekly.md · اثر بعدی',
  'tasks.sample.weekly.trigger': 'زمان‌بندی · هفتگی',
  'tasks.sample.weekly.pattern': 'روال · خلاصه تیم',
  'tasks.sample.weekly.runtime': 'راه دور · تکرارشونده',
  'tasks.sample.weekly.output': 'آرتیفکت زنده · markdown',
  'tasks.sample.weekly.artifactMeta': '۴ روز پیش به‌روزرسانی شد',
  'tasks.sample.weekly.body1': '# هفتگی تیم',
  'tasks.sample.weekly.body2': '## در جریان',
  'tasks.sample.weekly.body3': '- مرحله یکپارچه‌سازی سیستم طراحی',
  'tasks.sample.weekly.body4': '- بازبینی کیفیت کانکتور',
  'tasks.sample.weekly.body5': '## ریسک‌ها',
  'tasks.sample.pr.title': 'یادآوری بازبینی PR',
  'tasks.sample.pr.status': 'هنگام PR جدید · ۲۳ دقیقه پیش اجرا شد',
  'tasks.sample.pr.meta': 'پیام مستقیم Slack ارسال می‌کند',
  'tasks.sample.pr.preview': 'آخرین تحویل موفق بود',
  'tasks.sample.pr.trigger': 'رویداد · PR جدید',
  'tasks.sample.pr.pattern': 'روال · اعلان',
  'tasks.sample.pr.runtime': 'محلی · اجرای سریع',
  'tasks.sample.pr.output': 'پیام · پیام مستقیم Slack',
  'tasks.sample.pr.artifactMeta': 'آخرین اجرا ۲۳ دقیقه پیش',
  'tasks.sample.pr.body1': 'PR #184 برای بازبینی باز شد',
  'tasks.sample.pr.body2': 'بازبین‌های منطبق: design-platform، web-runtime',
  'tasks.sample.pr.body3': 'تحویل: پیام مستقیم Slack ارسال شد',
  'tasks.sample.meeting.title': 'آماده‌سازی پیش از جلسه',
  'tasks.sample.meeting.status': 'فردا · ۱۰:۰۰ صبح',
  'tasks.sample.meeting.meta': 'یک‌باره · خلاصه ارسال می‌کند',
  'tasks.sample.meeting.preview': 'meeting_brief.md · در صف',
  'tasks.sample.meeting.trigger': 'زمان‌بندی · یک‌باره',
  'tasks.sample.meeting.pattern': 'پرامپت جلسه توجیهی',
  'tasks.sample.meeting.runtime': 'راه دور · محدود',
  'tasks.sample.meeting.output': 'آرتیفکت + پیام',
  'tasks.sample.meeting.artifactMeta': 'در صف تولید',
  'tasks.sample.meeting.body1': '# خلاصه جلسه',
  'tasks.sample.meeting.body2': 'منبع دستور جلسه: رویداد تقویم + اسناد مرتبط',
  'tasks.sample.meeting.body3': 'خروجی شامل تصمیمات، موانع و سؤالات خواهد بود.',
  'tasks.sample.candidate.title': 'پیگیری نامزدها',
  'tasks.sample.candidate.status': 'ناموفق · نیازمند توجه',
  'tasks.sample.candidate.meta': 'احراز هویت منقضی شد',
  'tasks.sample.candidate.preview': 'برای ازسرگیری، Greenhouse را دوباره متصل کنید',
  'tasks.sample.candidate.trigger': 'زمان‌بندی · روزانه',
  'tasks.sample.candidate.pattern': 'روال · همگام‌سازی متقاضیان',
  'tasks.sample.candidate.runtime': 'راه دور · تکرارشونده',
  'tasks.sample.candidate.output': 'آرتیفکت زنده · جدول',
  'tasks.sample.candidate.artifactMeta': 'تا بازیابی احراز هویت متوقف شد',
  'tasks.sample.candidate.body1': '# خط لوله نامزدها',
  'tasks.sample.candidate.body2': 'آخرین همگام‌سازی موفق: ۲ روز پیش',
  'tasks.sample.candidate.body3': 'اقدام لازم است: حساب منبع را دوباره متصل کنید.',
  'routines.title': 'خودکارسازی‌ها',
  'routines.subtitle': 'خودکارسازی‌های زمان‌بندی شده که بدون نظارت اجرا می‌شوند.',
  'routines.newAutomation': 'خودکارسازی جدید',
  'routines.loading': 'در حال بارگذاری…',
  'routines.empty': 'هنوز اتوماسیونی وجود ندارد.',
  'routines.emptyHint': 'برای زمان‌بندی یک اجرای خودکار Agent، روی «اتوماسیون جدید» کلیک کنید.',
  'routines.runHistoryLoading': 'در حال بارگذاری اجراها…',
  'routines.runHistoryEmpty': 'هنوز اجرایی وجود ندارد.',
  'routines.fieldName': 'نام',
  'routines.fieldNamePlaceholder': 'خلاصه صبحگاهی',
  'routines.fieldPrompt': 'دستور',
  'routines.fieldPromptPlaceholder': 'فعالیت دیروز GitHub و Linear را دریافت کن و خلاصه‌ای از تغییرات ارائه بده.',
  'routines.fieldSchedule': 'زمان‌بندی',
  'routines.fieldMinute': 'دقیقه از هر ساعت',
  'routines.fieldTime': 'زمان',
  'routines.fieldTimezone': 'منطقه زمانی',
  'routines.fieldsetProject': 'پروژه',
  'routines.kind.hourly': 'ساعتی',
  'routines.kind.daily': 'روزانه',
  'routines.kind.weekdays': 'روزهای کاری',
  'routines.kind.weekly': 'هفتگی',
  'routines.weekday.short.0': 'یک',
  'routines.weekday.short.1': 'دو',
  'routines.weekday.short.2': 'سه',
  'routines.weekday.short.3': 'چهار',
  'routines.weekday.short.4': 'پنج',
  'routines.weekday.short.5': 'جمعه',
  'routines.weekday.short.6': 'شنبه',
  'routines.weekday.long.0': 'یکشنبه',
  'routines.weekday.long.1': 'دوشنبه',
  'routines.weekday.long.2': 'سه‌شنبه',
  'routines.weekday.long.3': 'چهارشنبه',
  'routines.weekday.long.4': 'پنجشنبه',
  'routines.weekday.long.5': 'جمعه',
  'routines.weekday.long.6': 'شنبه',
  'routines.timeAm': 'AM',
  'routines.timePm': 'PM',
  'routines.describe.hourly': 'هر ساعت در دقیقه :{minute} اجرا می‌شود',
  'routines.describe.daily': 'هر روز در ساعت {time} {tz} اجرا می‌شود',
  'routines.describe.weekdays': 'دوشنبه تا جمعه در ساعت {time} {tz} اجرا می‌شود',
  'routines.describe.weekly': 'هر {day} در ساعت {time} {tz} اجرا می‌شود',
  'routines.modeCreate': 'در هر اجرا یک پروژه جدید بساز',
  'routines.modeCreateHint': 'یک فضای کاری تازه و مجزا برای هر اجرا.',
  'routines.modeReuse': 'استفاده مجدد از یک پروژه موجود',
  'routines.modeReuseHint': 'هر اجرا به‌صورت یک گفتگوی جدید درون پروژه قرار می‌گیرد.',
  'routines.pickProject': '— یک پروژه انتخاب کنید —',
  'routines.targetReuse': '→ {project}',
  'routines.targetCreate': '← هر اجرا یک پروژه جدید',
  'routines.tagPaused': 'متوقف‌شده',
  'routines.metaNext': 'بعدی: {when}',
  'routines.metaLast': 'آخرین:',
  'routines.triggerManual': 'دستی',
  'routines.triggerScheduled': 'زمان‌بندی‌شده',
  'routines.openProject': 'باز کردن پروژه',
  'routines.openProjectTitle': 'پروژه‌ای که این اجرا در آن نوشت را باز کن',
  'routines.runNow': 'اجرای فوری',
  'routines.edit': 'ویرایش',
  'routines.pause': 'توقف',
  'routines.resume': 'ادامه',
  'routines.history': 'تاریخچه',
  'routines.hideHistory': 'پنهان کردن تاریخچه',
  'routines.delete': 'حذف',
  'routines.deleteTitle': 'حذف این اتوماسیون',
  'routines.cancel': 'لغو',
  'routines.save': 'ذخیره',
  'routines.saving': 'در حال ذخیره…',
  'routines.create': 'ایجاد',
  'routines.creating': 'در حال ایجاد…',
  'routines.status.queued': 'در صف',
  'routines.status.running': 'در حال اجرا',
  'routines.status.succeeded': 'موفق',
  'routines.status.failed': 'ناموفق',
  'routines.status.canceled': 'لغوشده',
  'routines.confirmDelete': 'این اتوماسیون حذف شود؟ اجراهای گذشته و پروژه‌های آن‌ها حفظ می‌شوند.',
  'routines.errorPickProject': 'یک پروژه برای استفاده مجدد انتخاب کنید، یا به «ایجاد پروژه جدید در هر اجرا» تغییر دهید',
  'routines.errorAgentEmptyOutput': 'Agent بدون تولید هیچ خروجی‌ای تکمیل شد. ممکن است مدل یا ارائه‌دهنده پاسخ خالی برگردانده باشد — لاگ‌های Agent را برای خطاهای بالادستی بررسی کنید.',
  'entry.helpAria': 'راهنما',
  'entry.helpMenuAria': 'منوی راهنما',
  'entry.helpGetHelp': 'دریافت کمک در GitHub',
  'entry.helpSubmitFeature': 'پیشنهاد قابلیت',
  'entry.helpWhatsNew': 'تازه‌ها',
  'entry.helpDownloadDesktop': 'دانلود اپلیکیشن دسکتاپ',
  'entry.githubStarLabel': 'ستاره',
  'entry.githubStarTitle': 'برای ما در GitHub ستاره بگذارید',
  'entry.githubStarAria': 'به Open Design در GitHub ستاره بدهید',
  'entry.tabImageTemplates': 'قالب‌های تصویر',
  'entry.tabVideoTemplates': 'قالب‌های ویدئو',
  'promptTemplates.searchPlaceholder': 'جستجوی قالب‌ها…',
  'promptTemplates.countLabel': '{n} نتیجه',
  'promptTemplates.emptyImage': 'هنوز قالب پرامپت تصویر نصب نشده است.',
  'promptTemplates.emptyVideo': 'هنوز قالب پرامپت ویدئو نصب نشده است.',
  'promptTemplates.emptyNoMatch': 'هیچ قالبی با جستجوی شما مطابقت ندارد.',
  'promptTemplates.attributionFooter': 'برگرفته از کتابخانه‌های عمومی پرامپت. هر کارت به نویسنده اصلی لینک دارد.',
  'promptTemplates.openPreviewTitle': 'باز کردن پرامپت و پیش‌نمایش',
  'promptTemplates.sourcePrefix': 'منبع:',
  'promptTemplates.fetchError': 'بارگذاری متن این قالب ممکن نبود.',
  'promptTemplates.promptLabel': 'متن پرامپت',
  'promptTemplates.copyPrompt': 'کپی پرامپت',
  'promptTemplates.copyDone': 'کپی شد!',
  'promptTemplates.modelHint': 'مدل پیشنهادی: {model}',
  'promptTemplates.openSource': 'دیدن منبع اصلی',
  'promptTemplates.openFullscreen': 'باز کردن پیش‌نمایش تمام‌صفحه',
  'promptTemplates.closeFullscreen': 'بستن پیش‌نمایش تمام‌صفحه',
  'promptTemplates.allSources': 'همهٔ منابع',
  'promptTemplates.sourceFilterAria': 'فیلتر بر اساس منبع',
  'promptTemplates.retry': 'تلاش دوباره',
  'connectors.title': 'اتصال‌دهنده‌ها',
  'connectors.subtitle': 'منابع داده محلی و آینده که می‌توانند به مصنوعات زنده نیرو بدهند.',
  'connectors.account': 'حساب',
  'connectors.noAccount': 'متصل نیست',
  'connectors.tools': 'ابزارها',
  'connectors.connect': 'اتصال',
  'connectors.disconnect': 'قطع اتصال',
  'connectors.authorizationPending': 'در انتظار مجوز...',
  'connectors.authorizationPendingHint': 'مجوز را در پنجره بازشده کامل کنید.',
  'connectors.cancelAuthorization': 'لغو',
  'connectors.configure': 'پیکربندی',
  'connectors.unavailable': 'در دسترس نیست',
  'connectors.phaseStubTitle': 'APIهای اتصال‌دهنده در فاز ۳ می‌رسند؛ این فقط یک نمای پیش‌نمایش است.',
  'connectors.statusAvailable': 'در دسترس',
  'connectors.statusConnected': 'متصل',
  'connectors.statusError': 'خطا',
  'connectors.statusDisabled': 'غیرفعال',
  'connectors.gateTitle': 'برای ادامه کلید Composio API را اضافه کنید',
  'connectors.gateBody': 'کلید را در بالا جای‌گذاری کنید و روی ذخیره کلید بزنید تا یکپارچه‌سازی‌های موجود بارگیری شوند.',
  'connectors.aboutLabel': 'درباره',
  'connectors.detailsLabel': 'جزئیات',
  'connectors.statusLabel': 'وضعیت',
  'connectors.category.aiAgents': 'عامل‌های AI',
  'connectors.category.aiInfrastructure': 'زیرساخت AI',
  'connectors.category.accounting': 'حسابداری',
  'connectors.category.admin': 'مدیریت',
  'connectors.category.advertising': 'تبلیغات',
  'connectors.category.analytics': 'تحلیل‌ها',
  'connectors.category.automation': 'اتوماسیون',
  'connectors.category.cms': 'CMS',
  'connectors.category.crm': 'CRM',
  'connectors.category.calendar': 'تقویم',
  'connectors.category.commerce': 'تجارت',
  'connectors.category.communication': 'ارتباطات',
  'connectors.category.contacts': 'مخاطبین',
  'connectors.category.dataPlatform': 'پلتفرم داده',
  'connectors.category.database': 'پایگاه داده',
  'connectors.category.design': 'طراحی',
  'connectors.category.developer': 'ابزارهای توسعه‌دهنده',
  'connectors.category.documentation': 'مستندات',
  'connectors.category.erp': 'ERP',
  'connectors.category.education': 'آموزش',
  'connectors.category.email': 'ایمیل',
  'connectors.category.events': 'رویدادها',
  'connectors.category.fieldService': 'خدمات میدانی',
  'connectors.category.finance': 'مالی',
  'connectors.category.fitness': 'تناسب اندام',
  'connectors.category.forms': 'فرم‌ها',
  'connectors.category.gaming': 'بازی',
  'connectors.category.hr': 'منابع انسانی',
  'connectors.category.hospitality': 'مهمان‌داری',
  'connectors.category.itsm': 'ITSM',
  'connectors.category.integration': 'یکپارچه‌سازی',
  'connectors.category.localization': 'بومی‌سازی',
  'connectors.category.logistics': 'لجستیک',
  'connectors.category.maps': 'نقشه‌ها',
  'connectors.category.marketing': 'بازاریابی',
  'connectors.category.media': 'رسانه',
  'connectors.category.meetings': 'جلسات',
  'connectors.category.nonprofit': 'غیرانتفاعی',
  'connectors.category.observability': 'مشاهده‌پذیری',
  'connectors.category.payments': 'پرداخت‌ها',
  'connectors.category.personal': 'شخصی',
  'connectors.category.presentations': 'ارائه‌ها',
  'connectors.category.procurement': 'تدارکات',
  'connectors.category.product': 'محصول',
  'connectors.category.productivity': 'بهره‌وری',
  'connectors.category.projectManagement': 'مدیریت پروژه',
  'connectors.category.recruiting': 'استخدام',
  'connectors.category.research': 'پژوهش',
  'connectors.category.salesIntelligence': 'هوشمندی فروش',
  'connectors.category.scheduling': 'زمان‌بندی',
  'connectors.category.search': 'جستجو',
  'connectors.category.security': 'امنیت',
  'connectors.category.signing': 'امضا',
  'connectors.category.social': 'اجتماعی',
  'connectors.category.spreadsheets': 'صفحه‌گسترده‌ها',
  'connectors.category.storage': 'ذخیره‌سازی',
  'connectors.category.support': 'پشتیبانی',
  'connectors.category.surveys': 'نظرسنجی‌ها',
  'connectors.category.tasks': 'وظایف',
  'connectors.category.timeTracking': 'پیگیری زمان',
  'connectors.category.video': 'ویدیو',
  'connectors.category.whiteboard': 'وایت‌برد',
  'connectors.categoryLabel': 'دسته‌بندی',
  'connectors.providerLabel': 'ارائه‌دهنده',
  'connectors.toolsSection': 'ابزارها',
  'connectors.toolsLoading': 'در حال بارگیری ابزارها…',
  'connectors.noToolsAvailable': 'هنوز ابزاری در دسترس نیست. پس از اتصال، قابلیت‌های این ادغام آشکار می‌شود.',
  'connectors.toolDetailsUnavailable': 'جزئیات ابزارها در دسترس نیست، اما این کانکتور {n} ابزار را گزارش می‌دهد.',
  'connectors.loadMoreTools': 'بارگذاری ابزارهای بیشتر',
  'connectors.openDetailsAria': 'باز کردن جزئیات {name}',
  'connectors.toolsBadgeNone': 'بدون ابزار',
  'connectors.toolsBadgeOne': '{n} ابزار',
  'connectors.toolsBadgeMany': '{n} ابزار',
  'connectors.searchPlaceholder': 'جستجوی اتصال‌دهنده‌ها…',
  'connectors.searchAriaLabel': 'جستجوی اتصال‌دهنده‌ها بر اساس نام، ارائه‌دهنده یا ابزار',
  'connectors.searchClear': 'پاک کردن جستجو',
  'connectors.emptyNoMatchTitle': 'هیچ اتصال‌دهنده‌ای با «{query}» مطابقت ندارد',
  'connectors.emptyNoMatchBody': 'کلمه‌ی کلیدی دیگری را امتحان کنید یا جستجو را پاک کنید تا کل فهرست نمایش داده شود.',
  'connectors.emptyNoMatchAction': 'پاک کردن جستجو',
  'newproj.tabPrototype': 'نمونه اولیه',
  'newproj.tabLiveArtifact': 'مصنوع زنده جدید',
  'newproj.tabDeck': 'ارائه اسلاید',
  'newproj.tabTemplate': 'از قالب',
  'newproj.tabMedia': 'رسانه',
  'newproj.tabOther': 'سایر',
  'newproj.titlePrototype': 'نمونه اولیه جدید',
  'newproj.titleLiveArtifact': 'مصنوع زنده جدید',
  'newproj.titleDeck': 'ارائه اسلاید جدید',
  'newproj.titleTemplate': 'شروع از یک قالب',
  'newproj.titleImage': 'تصویر جدید',
  'newproj.titleVideo': 'ویدئوی جدید',
  'newproj.titleAudio': 'صدای جدید',
  'newproj.titleMedia': 'رسانه جدید',
  'newproj.titleOther': 'پروژه جدید',
  'newproj.namePlaceholder': 'نام پروژه',
  'newproj.fidelityLabel': 'دقت',
  'newproj.fidelityWireframe': 'وایرفریم',
  'newproj.fidelityHigh': 'دقت بالا',
  'newproj.toggleSpeakerNotes': 'استفاده از یادداشت‌های سخنران',
  'newproj.toggleSpeakerNotesHint': 'متن کمتر روی اسلایدها — نکات صحبت را در یادداشت‌ها نگه دارید.',
  'newproj.toggleAnimations': 'افزودن انیمیشن',
  'newproj.toggleAnimationsHint': 'افزودن حرکت (ورود، هاور، انتقال) بر روی قالب.',
  'newproj.targetPlatformsLabel': 'پلتفرم‌های هدف',
  'newproj.targetPlatformsHint': 'یک یا چند مورد را انتخاب کنید. وب واکنش‌گرا فقط نقاط شکست مرورگر را پوشش می‌دهد؛ برای نسخه‌های بومی چندسکویی، iOS، Android، اپ تبلت یا اپ دسکتاپ را اضافه کنید.',
  'newproj.platform.responsive.label': 'وب واکنش‌گرا',
  'newproj.platform.responsive.hint': 'یک تجربه وب سازگارشده برای مرورگرهای دسکتاپ، تبلت و موبایل',
  'newproj.platform.webDesktop.label': 'وب دسکتاپ',
  'newproj.platform.webDesktop.hint': 'محصول یا صفحه فرود مبتنی بر مرورگر',
  'newproj.platform.mobileIos.label': 'اپ iOS',
  'newproj.platform.mobileIos.hint': 'قاب‌های iPhone و قواعد تعامل iOS',
  'newproj.platform.mobileAndroid.label': 'اپ Android',
  'newproj.platform.mobileAndroid.hint': 'قاب‌های Pixel و قواعد تعامل Material',
  'newproj.platform.tablet.label': 'اپ تبلت',
  'newproj.platform.tablet.hint': 'تجربه تبلت با سبک بومی و نماهای تقسیم‌شده',
  'newproj.platform.desktopApp.label': 'اپ دسکتاپ',
  'newproj.platform.desktopApp.hint': 'پوسته اپ macOS/Windows',
  'newproj.surfaceOptionsLabel': 'سطوح مکمل',
  'newproj.includeLandingPage': 'افزودن صفحه فرود',
  'newproj.includeLandingPageHint': 'یک صفحه بازاریابی واکنش‌گرا برای تبلیغات، فهرست انتظار، کمپین‌های راه‌اندازی، دانلود اپ یا توضیح محصول اضافه کنید.',
  'newproj.includeOsWidgets': 'افزودن ویجت‌های سیستم‌عامل',
  'newproj.includeOsWidgetsHint': 'ویجت‌های بومی صفحه اصلی، صفحه قفل یا دسترسی سریع را برای اپ‌های موبایل/تبلت اضافه کنید.',
  'newproj.includeOsWidgetsDisabledHint': 'زمانی در دسترس است که اپ iOS، Android یا تبلت به‌عنوان پلتفرم هدف انتخاب شده باشد.',
  'newproj.templateLabel': 'قالب',
  'newproj.noTemplatesTitle': 'هنوز هیچ قالبی وجود ندارد',
  'newproj.noTemplatesBody': 'هر پروژه‌ای را باز کنید، سپس از منوی اشتراک‌گذاری در داخل نمایشگر فایل آن را به قالب تبدیل کنید. قالب‌ها اینجا نمایش داده می‌شوند.',
  'newproj.savedTemplate': 'قالب ذخیره شده',
  'newproj.fileSingular': 'فایل',
  'newproj.filePlural': 'فایل',
  'newproj.create': 'ایجاد',
  'newproj.locationLabel': 'ذخیره در',
  'newproj.locationDefault': 'پروژه‌های Open Design',
  'newproj.locationExternalBase': 'پایهٔ خارجی',
  'newproj.createLiveArtifact': 'ایجاد مصنوع زنده',
  'newproj.createFromTemplate': 'ایجاد از قالب',
  'newproj.createDisabledTitle': 'ابتدا یک پروژه را به عنوان قالب ذخیره کنید (منوی اشتراک‌گذاری در داخل هر پروژه).',
  'newproj.importClaudeZip': 'وارد کردن ZIP طراحی Claude',
  'newproj.importClaudeZipTitle': 'وارد کردن یک فایل .zip صادر شده از Claude Design',
  'newproj.importingClaudeZip': 'در حال وارد کردن…',
  'newproj.privacyFooter': 'به طور پیش‌فرض فقط شما می‌توانید پروژه خود را ببینید.',
  'newproj.designSystem': 'سیستم طراحی',
  'newproj.dsNoneFreeform': 'هیچ — آزاد',
  'newproj.dsNoneSubtitleEmpty': 'بدون توکن‌های سیستم، پالت خود را انتخاب کنید',
  'newproj.dsNoneSubtitleSelected': 'از توکن‌های سیستم صرف نظر کنید. عامل پالت خود را انتخاب می‌کند.',
  'newproj.dsCategoryFallback': 'سیستم طراحی',
  'newproj.dsSearch': 'جستجوی سیستم‌های طراحی…',
  'newproj.dsModeAria': 'حالت انتخاب',
  'newproj.dsModeSingle': 'تکی',
  'newproj.dsModeMulti': 'چندگانه',
  'newproj.dsNoneTitle': 'هیچ — آزاد',
  'newproj.dsNoneSub': 'از توکن‌های سیستم صرف نظر کنید. عامل پالت خود را انتخاب می‌کند.',
  'newproj.dsEmpty': 'هیچ سیستم طراحی با «{query}» مطابقت ندارد.',
  'newproj.dsFootSingular': 'فقط الهام‌بخش است.',
  'newproj.dsFootPlural': 'فقط الهام‌بخش هستند.',
  'newproj.dsFootClear': 'پاک کردن',
  'newproj.dsBadgeDefault': 'پیش‌فرض',
  'newproj.dsPrimaryFallback': 'اصلی',
  'newproj.surfaceImage': 'تصویر',
  'newproj.surfaceVideo': 'ویدئو',
  'newproj.surfaceAudio': 'صدا',
  'newproj.modelLabel': 'مدل',
  'newproj.modelSearch': 'جستجوی مدل‌ها…',
  'newproj.modelEmpty': 'مدلی پیدا نشد.',
  'newproj.modelRecommended': 'پیشنهادی',
  'newproj.modelMissingTitle': 'انتخاب مدل',
  'newproj.modelMissingSub': 'برای این سطح یک مدل انتخاب کنید.',
  'newproj.aspectLabel': 'نسبت تصویر',
  'newproj.videoLengthLabel': 'طول',
  'newproj.videoLengthSeconds': '{n}ث',
  'newproj.audioKindLabel': 'نوع صدا',
  'newproj.audioKindMusic': 'موسیقی',
  'newproj.audioKindSpeech': 'گفتار / TTS',
  'newproj.audioKindSfx': 'افکت صوتی',
  'newproj.audioDurationLabel': 'مدت',
  'newproj.audioDurationSeconds': '{n}ث',
  'newproj.voiceLabel': 'صدا',
  'newproj.voicePlaceholder': 'شناسه صدای ارائه‌دهنده، اختیاری',
  'newproj.connectorsLabel': 'اتصال‌دهنده‌ها',
  'newproj.connectorsHint': 'منابع داده‌ای که این مصنوع می‌تواند از آن‌ها استفاده کند.',
  'newproj.connectorsEmptyTitle': 'هیچ اتصال‌دهنده‌ای پیکربندی نشده',
  'newproj.connectorsEmptyBody': 'یک منبع داده متصل کنید تا مصنوع زنده به‌جای داده‌های جایگزین از داده‌های واقعی استفاده کند.',
  'newproj.connectorsEmptyCta': 'پیکربندی اتصال‌دهنده‌ها ←',
  'newproj.connectorsLoading': 'در حال بارگذاری اتصال‌دهنده‌ها…',
  'newproj.connectorsCountOne': '{n} متصل',
  'newproj.connectorsCountMany': '{n} متصل',
  'newproj.connectorsManage': 'مدیریت',
  'newproj.promptTemplateLabel': 'قالب مرجع',
  'newproj.promptTemplateNoneTitle': 'بدون قالب — توصیف اختصاصی',
  'newproj.promptTemplateNoneSub': 'گالری را رد کنید و خودتان توضیح دهید',
  'newproj.promptTemplateRefSub': 'قالب مرجع',
  'newproj.promptTemplateSearch': 'جست‌وجوی قالب‌ها…',
  'newproj.promptTemplateEmpty': 'هنوز قالبی برای این نوع نصب نشده است.',
  'newproj.promptTemplateBodyLabel': 'پرامپت (قابل ویرایش)',
  'newproj.promptTemplateOptimizeHint': 'هر چیزی را می‌توانید ویرایش کنید — تغییرات شما به بریف ایجنت اضافه می‌شود.',
  'newproj.promptTemplateBodyEmpty': 'متن خالی است — ایجنت هیچ مرجع قالبی دریافت نمی‌کند.',
  'newproj.deleteTemplateTitle': 'حذف قالب',
  'newproj.deleteTemplateConfirm': 'آیا «{name}» حذف شود؟ این عمل قابل بازگشت نیست.',
  'newproj.deleteTemplateConfirmCta': 'حذف قالب',
  'newproj.deleteTemplateError': 'حذف این قالب ممکن نشد. لطفاً دوباره تلاش کنید.',
  'designs.subRecent': 'اخیر',
  'designs.subYours': 'طرح‌های شما',
  'designs.filterAria': 'فیلتر پروژه‌ها',
  'designs.searchPlaceholder': 'جستجو…',
  'designs.emptyNoProjects': 'هنوز هیچ پروژه‌ای وجود ندارد.',
  'designs.emptyNoMatch': 'هیچ پروژه‌ای با جستجوی شما مطابقت ندارد.',
  'designs.deleteTitle': 'حذف پروژه',
  'designs.deleteConfirm': 'آیا «{name}» حذف شود؟',
  'designs.cardFreeform': 'آزاد',
  'designs.badgeLive': 'زنده',
  'designs.liveArtifactBadgesAria': 'نشان‌های مصنوعات زنده',
  'designs.liveCount': '{n} زنده',
  'designs.statusLive': 'مصنوع زنده',
  'designs.statusArchived': 'بایگانی‌شده',
  'designs.statusError': 'خطا',
  'designs.statusRefreshing': 'در حال بازخوانی…',
  'designs.statusRefreshFailed': 'بازخوانی ناموفق بود',
  'designs.statusRefreshed': 'بازخوانی شد',
  'designs.status.notStarted': 'شروع نشده',
  'designs.status.queued': 'در صف',
  'designs.status.running': 'در حال اجرا',
  'designs.status.awaitingInput': 'نیازمند ورودی',
  'designs.status.succeeded': 'تکمیل شد',
  'designs.status.published': 'منتشر شد',
  'designs.status.failed': 'ناموفق',
  'designs.status.canceled': 'لغو شد',
  'designs.viewToggleAria': 'حالت نمایش',
  'designs.viewGrid': 'نمای شبکه‌ای',
  'designs.viewKanban': 'نمای برد',
  'designs.kanbanEmptyColumn': 'هیچ طرحی نیست',
  'designs.deleteAria': 'حذف پروژه {name}',
  'designs.menuMore': 'اقدامات بیشتر',
  'designs.menuRename': 'تغییر نام',
  'designs.menuDuplicate': 'Duplicate project',
  'designs.menuDelete': 'حذف',
  'designs.renamePrompt': 'نام جدید برای «{name}»',
  'designs.selectMode': 'انتخاب',
  'designs.cancelSelect': 'لغو',
  'designs.deleteSelected': 'حذف موارد انتخاب‌شده',
  'designs.selectedCount': '{n} مورد انتخاب شد',
  'designs.deleteSelectedConfirm': '{n} پروژه حذف شود؟',
  'designs.deleteSelectedSuccess': '{n} پروژه با موفقیت حذف شد.',
  'designs.deleteSelectedPartial': '{deleted} پروژه حذف شد؛ {failed} مورد ناموفق بود.',
  'designs.tagPrototype': 'پروتوتایپ',
  'designs.tagLiveArtifact': 'آرتیفکت زنده',
  'designs.tagSlide': 'اسلاید',
  'designs.tagMedia': 'رسانه',
  'designs.renameTitle': 'تغییر نام پروژه',
  'designs.renameSave': 'OK',
  'designs.renameCancel': 'لغو',
  'examples.typeLabel': 'نوع',
  'examples.surfaceLabel': 'سطح',
  'examples.surfaceWeb': 'وب',
  'examples.surfaceImage': 'تصویر',
  'examples.surfaceVideo': 'ویدئو',
  'examples.surfaceAudio': 'صدا',
  'examples.scenarioLabel': 'سناریو',
  'examples.modeAll': 'همه',
  'examples.modePrototypeDesktop': 'نمونه اولیه · دسکتاپ',
  'examples.modePrototypeMobile': 'نمونه اولیه · موبایل',
  'examples.modeDeck': 'اسلایدها',
  'examples.modeDocument': 'اسناد و قالب‌ها',
  'examples.modeOrbit': 'Orbit',
  'examples.modeLive': 'زنده',
  'examples.scenarioGeneral': 'عمومی',
  'examples.scenarioEngineering': 'مهندسی',
  'examples.scenarioProduct': 'محصول',
  'examples.scenarioDesign': 'طراحی',
  'examples.scenarioMarketing': 'بازاریابی',
  'examples.scenarioSales': 'فروش',
  'examples.scenarioFinance': 'مالی',
  'examples.scenarioHr': 'منابع انسانی',
  'examples.scenarioOperations': 'عملیات',
  'examples.scenarioSupport': 'پشتیبانی',
  'examples.scenarioLegal': 'حقوقی',
  'examples.scenarioEducation': 'آموزش',
  'examples.scenarioPersonal': 'شخصی',
  'examples.searchPlaceholder': 'جستجوی نمونه‌ها…',
  'examples.searchAria': 'جستجوی نمونه‌ها بر اساس نام',
  'examples.emptyNoSkills': 'هیچ مهارتی موجود نیست. آیا daemon در حال اجرا است؟',
  'examples.emptyNoMatch': 'هیچ نمونه‌ای با این فیلترها مطابقت ندارد.',
  'examples.openPreview': '⤢ باز کردن پیش‌نمایش',
  'examples.loadingPreview': 'در حال بارگذاری پیش‌نمایش…',
  'examples.hoverPreview': 'برای پیش‌نمایش هاور کنید',
  'examples.usePrompt': 'استفاده از این پرامپت',
  'examples.previewModalTitle': 'باز کردن پیش‌نمایش کامل (modal)',
  'examples.shareTitle': 'اشتراک‌گذاری این نمونه',
  'examples.shareLoadFirst': 'ابتدا برای بارگذاری پیش‌نمایش هاور کنید',
  'examples.unavailablePlaceholder': 'پیش‌نمایش {kind} همراه ندارد — برای جزئیات باز کنید',
  'examples.shareUnavailable': 'پیش‌نمایش {kind} برای اشتراک‌گذاری همراه ندارد',
  'examples.shareMenu': 'اشتراک‌گذاری ▾',
  'examples.exportPdfAllSlides': 'صادرکردن به PDF (همه اسلایدها)',
  'examples.exportPptxLocked': 'صادرکردن به PPTX… (ابتدا قالب را باز کنید)',
  'examples.tagSlideDeck': 'ارائه اسلاید',
  'examples.tagTemplate': 'قالب',
  'examples.tagDesignSystem': 'سیستم طراحی',
  'examples.tagMobilePrototype': 'نمونه اولیه موبایل',
  'examples.tagDesktopPrototype': 'نمونه اولیه دسکتاپ',
  'examples.tagImage': 'تصویر',
  'examples.tagVideo': 'ویدئو',
  'examples.tagAudio': 'صدا',
  'examples.previewLabel': 'پیش‌نمایش',
  'ds.surfaceLabel': 'سطح',
  'ds.surfaceWeb': 'وب',
  'ds.surfaceImage': 'تصویر',
  'ds.surfaceVideo': 'ویدئو',
  'ds.surfaceAudio': 'صدا',
  'ds.searchPlaceholder': 'جستجوی سیستم‌های طراحی…',
  'ds.emptyNoMatch': 'هیچ سیستم طراحی با جستجوی شما مطابقت ندارد.',
  'ds.badgeDefault': 'پیش‌فرض',
  'ds.preview': 'پیش‌نمایش',
  'ds.previewTitle': 'پیش‌نمایش سیستم طراحی',
  'ds.categoryAll': 'همه',
  'ds.categoryUncategorized': 'دسته‌بندی نشده',
  'ds.showcase': 'ویترین',
  'ds.tokens': 'توکن‌ها',
  'ds.specToggle': 'DESIGN.md',
  'ds.specLoading': 'بارگذاری DESIGN.md…',
  'avatar.title': 'حساب و تنظیمات',
  'avatar.localCli': 'CLI محلی',
  'avatar.anthropicApi': 'API انتروپیک',
  'avatar.useLocal': 'استفاده از CLI محلی',
  'avatar.useApi': 'استفاده از API · BYOK',
  'avatar.codeAgent': 'عامل کد',
  'avatar.rescan': 'اسکن مجدد PATH',
  'avatar.amrConsole': 'حساب Open Design Cloud',
  'avatar.amrConsoleMeta': 'موجودی و شارژ',
  'avatar.settings': 'تنظیمات',
  'avatar.backToProjects': 'بازگشت به پروژه‌ها',
  'avatar.metaActive': 'فعال',
  'avatar.metaOffline': 'آفلاین',
  'avatar.metaSelected': 'انتخاب شده',
  'avatar.noAgentSelected': 'هیچ عاملی انتخاب نشده',
  'avatar.modelSection': 'مدل',
  'avatar.modelLabel': 'مدل',
  'avatar.reasoningLabel': 'استدلال',
  'avatar.customSuffix': '(سفارشی)',
  'socialShare.openDesignSection': 'اشتراک‌گذاری Open Design',
  'socialShare.openDesignTitle': 'Open Design در GitHub',
  'socialShare.openDesignText': 'Open Design یک فضای کاری متن‌باز برای ساخت، ویرایش، استقرار و تحویل آرتیفکت‌های طراحی است.',
  'socialShare.openDesignCopyText': '{text}\n{url}',
  'socialShare.projectSection': 'اشتراک‌گذاری در شبکه‌های اجتماعی',
  'socialShare.publishPageTitle': 'انتشار صفحه اشتراک‌گذاری',
  'socialShare.publishPageSubtitle': 'این پیش‌نمایش را منتشر کنید تا بتوان آن را در شبکه‌های اجتماعی به اشتراک گذاشت.',
  'socialShare.projectTitle': '{title} · Open Design',
  'socialShare.projectText': 'ساخته‌شده با Open Design: {title}. آرتیفکت مستقرشده را ببینید و به مخزن ستاره بدهید: {repo}',
  'socialShare.projectCopyText': 'ساخته‌شده با Open Design: {title}\n{url}\nمخزن Open Design: {repo}',
  'socialShare.deployFirst': 'استقرار سپس اشتراک‌گذاری…',
  'socialShare.copied': 'کپی شد',
  'socialShare.platform.x': 'X',
  'socialShare.platform.linkedin': 'LinkedIn',
  'socialShare.platform.facebook': 'Facebook',
  'socialShare.platform.reddit': 'Reddit',
  'socialShare.platform.telegram': 'Telegram',
  'socialShare.platform.whatsapp': 'WhatsApp',
  'socialShare.platform.weibo': 'Weibo',
  'socialShare.platform.line': 'LINE',
  'socialShare.platform.instagram': 'Instagram',
  'socialShare.platform.xiaohongshu': 'شیائوهنگ‌شو',
  'inlineSwitcher.chipTitle': 'تغییر CLI / مدل',
  'inlineSwitcher.chipCli': 'CLI محلی',
  'inlineSwitcher.chipByok': 'BYOK',
  'inlineSwitcher.modelDefault': 'پیش‌فرض',
  'inlineSwitcher.noAgent': 'بدون عامل',
  'inlineSwitcher.modeLabel': 'حالت',
  'inlineSwitcher.agentLabel': 'عامل',
  'inlineSwitcher.providerLabel': 'ارائه‌دهنده',
  'inlineSwitcher.modelLabel': 'مدل',
  'inlineSwitcher.useCli': 'استفاده از CLI محلی',
  'inlineSwitcher.useByok': 'استفاده از کلید API شخصی',
  'inlineSwitcher.daemonOffline': 'Daemon آفلاین — تنظیمات را باز کنید',
  'inlineSwitcher.noAgentsDetected': 'هیچ CLI در PATH یافت نشد',
  'inlineSwitcher.openSettingsForModel': 'ارائه‌دهنده را در تنظیمات پیکربندی کنید',
  'inlineSwitcher.missingApiKey': 'کلید API تنظیم نشده — تنظیمات را باز کنید.',
  'inlineSwitcher.openFullSettings': 'باز کردن تنظیمات اجرا',
  'inlineSwitcher.customSuffix': '(سفارشی)',
  'project.backToProjects': 'بازگشت به پروژه‌ها',
  'project.brandReadyTitle': 'سیستم طراحی {name} آماده است',
  'project.brandReadyTitleGeneric': 'سیستم طراحی شما آماده است',
  'project.brandReadyCta': 'پیش‌نمایش در سیستم‌های طراحی',
  'project.brandReadyDismiss': 'رد کردن',
  'project.brandReadyRefineHint': 'Automatic extraction can miss details. Refine it before using this system broadly.',
  'project.brandReadyAiOptimize': 'AI Optimize',
  'project.brandReadyEditManually': 'Edit manually',
  'project.brandReadyPreviewOpened': 'پیش‌نمایش سیستم طراحی باز شد.',
  'project.metaFreeform': 'آزاد',
  'project.typePrototype': 'نمونه اولیه',
  'project.typeDeck': 'اسلایدها',
  'project.typeTemplate': 'قالب',
  'project.typeImage': 'تصویر',
  'project.typeVideo': 'ویدیو',
  'project.typeAudio': 'صدا',
  'project.customInstructions': 'دستورالعمل‌های پروژه',
  'project.customInstructionsPlaceholder': 'دستورالعمل‌های این پروژه (در هر پیام تزریق می‌شود)…',
  'project.resizeChatPanel': 'تغییر اندازه پنل چت',
  'project.instructionsActive': 'فعال — در هر پیام گنجانده می‌شود',
  'project.missing': 'This project has been deleted or no longer exists.',
  'chat.tabChat': 'چت',
  'chat.tabComments': 'نظرات',
  'chat.commentsSoon': 'نظرات — به زودی',
  'chat.comments.attached': 'پیوست‌شده به گفتگو',
  'chat.comments.emptyAttached': 'هیچ نظری پیوست نشده است.',
  'chat.comments.saved': 'نظرات ذخیره‌شده',
  'chat.comments.emptySaved': 'هیچ نظر ذخیره‌شده‌ای وجود ندارد.',
  'chat.comments.add': 'افزودن',
  'chat.comments.addAll': 'افزودن همه',
  'chat.comments.remove': 'حذف',
  'chat.comments.placeholder': 'درباره این عنصر نظر بدهید…',
  'chat.comments.addSend': 'افزودن و ارسال',
  'chat.comments.updateSend': 'به‌روزرسانی و ارسال',
  'chat.comments.removeAttachment': 'حذف پیوست نظر',
  'chat.comments.removeAttachmentAria': 'حذف پیوست نظر برای {name}',
  'chat.comments.comment': 'نظر',
  'chat.comments.sendToChat': 'ارسال به گفتگو',
  'chat.comments.sending': 'در حال ارسال…',
  'chat.comments.edit': 'ویرایش',
  'chat.comments.select': 'انتخاب',
  'chat.comments.selectAll': 'انتخاب همه',
  'chat.comments.deselect': 'لغو انتخاب',
  'chat.comments.nSelected': '{n} مورد انتخاب‌شده',
  'chat.comments.pin': 'سنجاق کردن',
  'chat.comments.addNote': 'افزودن یادداشت',
  'chat.comments.savedToast': 'نظر ذخیره شد',
  'chat.comments.pinSavedToast': 'سنجاق ذخیره شد',
  'chat.comments.pinAtCoords': 'at {x}, {y}',
  'chat.comments.capturedItems': '{n} مورد ثبت‌شده',
  'chat.comments.clear': 'پاک کردن',
  'chat.comments.targetImage': 'تصویر',
  'chat.comments.targetControl': 'کنترل',
  'chat.comments.targetLink': 'پیوند',
  'chat.comments.targetText': 'متن',
  'chat.comments.targetSection': 'بخش',
  'chat.comments.targetPage': 'صفحه',
  'chat.comments.targetArea': 'ناحیه',
  'chat.annotationNotePlaceholder': 'افزودن یادداشت برای این نشانه',
  'chat.annotationAttachImage': 'پیوست تصویر',
  'chat.annotationAttachedImages': 'تصاویر پیوست‌شده',
  'chat.annotationAttachedRemove': 'حذف آخرین تصویر',
  'chat.annotationAddToInput': 'افزودن به ورودی',
  'chat.annotationAddingToInput': 'در حال افزودن...',
  'chat.annotationQueue': 'صف',
  'chat.annotationQueueing': 'در حال افزودن به صف...',
  'chat.annotationSubmitOptions': 'گزینه‌های ارسال',
  'chat.annotationSending': 'در حال ارسال...',
  'chat.annotationSendDisabledReason': 'در حال حاضر یک وظیفه در حال اجراست',
  'chat.annotationPreviewMissing': 'امکان ثبت پیش‌نمایش وجود نداشت. لطفاً دوباره تلاش کنید.',
  'chat.annotationPreviewMissingInk': 'امکان ثبت پیش‌نمایش وجود نداشت. برای جلوگیری از ارسال صرفِ ترسیم، دوباره تلاش کنید.',
  'chat.annotationSentWithoutScreenshot': 'پیش‌نمایش قابل ثبت نبود. حاشیه‌نویسی بدون اسکرین‌شات ارسال شد.',
  'chat.annotationTimeout': 'زمان ارسال حاشیه‌نویسی به پایان رسید. لطفاً دوباره تلاش کنید.',
  'chat.annotationFailed': 'ارسال حاشیه‌نویسی ناموفق بود. لطفاً دوباره تلاش کنید.',
  'chat.annotationProjectCreateFailed': 'امکان ایجاد پروژه وجود نداشت، بنابراین حاشیه‌نویسی ارسال نشد.',
  'chat.annotationUploadFailed': 'بارگذاری پیوست ناموفق بود. لطفاً دوباره تلاش کنید.',
  'chat.conversationsTitle': 'مکالمات',
  'chat.conversationsAria': 'تاریخچه مکالمات',
  'chat.newConversation': 'مکالمه جدید',
  'chat.newConversationsTitle': 'مکالمه جدید',
  'chat.conversationsHeading': 'مکالمات',
  'chat.new': 'جدید',
  'chat.emptyConversations': 'هنوز هیچ مکالمه‌ای وجود ندارد.',
  'chat.deleteConversation': 'حذف مکالمه',
  'chat.renameConversationLabel': 'تغییر نام «{title}»',
  'chat.deleteConversationConfirm': 'آیا «{title}» حذف شود؟ این کار پیام‌های آن را حذف می‌کند.',
  'chat.untitledConversation': 'مکالمه بدون عنوان',
  'chat.forkedConversationTitle': 'فورک {title}',
  'chat.forkConversationFailed': 'فورک کردن این مکالمه ممکن نبود.',
  'chat.startTitle': 'یک مکالمه شروع کنید',
  'chat.startHint': 'آنچه می‌خواهید بسازید را توصیف کنید، یا از یکی از این نمونه‌ها شروع کنید:',
  'chat.brandBrowserAssistDesktopOnly': 'Browser assist needs the desktop app so Open Design can read the live browser page.',
  'chat.brandBrowserAssistReadFailed': 'Could not read the browser page. Make sure the brand site is open and fully loaded.',
  'chat.brandBrowserAssistMessage': 'Open Design needs browser assist to finish this brand extraction. Use the card below to open Browser, then click More, choose Download Page, wait for the success message, and use the left Next Step card to continue extraction.',
  'chat.brandBrowserLocalSnapshotMissing': 'No saved page snapshot is available for this URL.',
  'chat.brandBrowserLocalSnapshotReadFailed': 'Could not read the saved page snapshot.',
  'chat.brandBrowserSnapshotSaveFailed': 'Could not save a page snapshot from the browser.',
  'chat.brandBrowserAssistDownloadGuideTitle': 'Browser opened',
  'chat.brandBrowserAssistDownloadGuideDetails': 'Step 1: Browser is open. Step 2: click More, then Download Page. Step 3: wait for the saved snapshot success message. Step 4: return to the left Next Step card and click Continue extraction to continue the programmatic extraction.',
  'brandEnrichment.title': "بهینه سازی با AI",
  'brandEnrichment.body': "Open Design یک استخراج عمیق تر را در پس زمینه اجرا می کند، skills مناسب design system را خودکار اعمال می کند و همین سیستم را درجا به روز می کند. این کار ممکن است 10 تا 20 دقیقه طول بکشد؛ می توانید به کارتان ادامه دهید.",
  'brandEnrichment.cta': "بهینه سازی با AI",
  'brandEnrichment.busy': "در حال شروع بهینه سازی با AI...",
  'brandExtractionTranscript.sourceDesignMd': 'DESIGN.md چسبانده شده',
  'brandExtractionTranscript.user': 'یک سیستم طراحی از {source} استخراج کن.',
  'brandExtractionTranscript.doneTitle': 'استخراج برنامه‌ای برای {name} تمام شد.',
  'brandExtractionTranscript.doneBody': 'سیستم طراحی {designSystemId} را از {source} ایجاد و ثبت کردم. اکنون آماده پیش‌نمایش است و می‌تواند در طراحی‌های جدید استفاده شود.',
  'brandExtractionTranscript.next': 'در ادامه می‌توانید AI Optimize را برای یک دور استخراج عمیق‌تر اجرا کنید، یا با این سیستم یک طراحی جدید بسازید.',
  'chat.fillInputTitle': 'برای پر کردن ورودی کلیک کنید',
  'chat.jumpToLatest': 'رفتن به آخرین',
  'chat.scrollToLatest': 'اسکرول به آخرین',
  'chat.you': 'شما',
  'chat.openFile': 'باز کردن {name}',
  'chat.copyPrompt': 'کپی پرامپت',
  'chat.copyErrorDiagnostic': 'کپی اطلاعات عیب‌یابی خطا',
  'chat.copyDone': 'کپی شد!',
  'chat.inspect.noEditableTargets': 'هیچ متن قابل‌ویرایش یا هدف استایلی یافت نشد.',
  'chat.inspect.noCommentTargets': 'هیچ متن قابل‌نظردهی یا هدف بصری یافت نشد.',
  'chat.inspect.editHint': 'برای ویرایش، یک متن یا هدف استایل را در پیش‌نمایش انتخاب کنید.',
  'chat.inspect.commentHint': 'برای نظردهی، یک متن یا ناحیه را در پیش‌نمایش انتخاب کنید.',
  'chat.composerPlaceholder': 'آنچه می‌خواهید بسازید را توصیف کنید…',
  'chat.activeFileEditingLabel': 'در حال ویرایش',
  'chat.activeFilePlaceholder': 'از Open Design بخواهید {file} را تغییر دهد...',
  'chat.designArtifactsShowMore': 'نمایش {count} فایل طراحی دیگر',
  'chat.mode.chat.label': 'پرسش',
  'chat.mode.chat.title': 'حالت پرسش',
  'chat.mode.chat.summary': 'برای پاسخ سریع، ویرایش، برنامه ریزی و گفتگو بدون اینکه فرض شود باید خروجی طراحی ساخته شود.',
  'chat.mode.chat.solves': 'برای روشن کردن ایده ها، بهتر کردن پرامپت ها، مقایسه گزینه ها یا پرسیدن درباره کار موجود استفاده کنید.',
  'chat.mode.chat.query1': 'این پیش نویس را خلاصه کن و شکاف ها را بگو.',
  'chat.mode.chat.query2': 'کمکم کن بهترین ساختار را برای این صفحه فرود انتخاب کنم.',
  'chat.mode.chat.query3': 'این طراحی را بررسی کن و بهبودهای مشخص پیشنهاد بده.',
  'chat.mode.plan.label': "Plan",
  'chat.mode.plan.title': "Plan mode",
  'chat.mode.plan.summary': "Creates an editable plan document first, then hands off to Design after you review it.",
  'chat.mode.plan.solves': "Use it for PRDs, slide outlines, prototype briefs, wireframes, storyboards, and any broad request that needs confirmation before generation.",
  'chat.mode.plan.query1': "Create a slide-by-slide PPT outline first.",
  'chat.mode.plan.query2': "Draft a PRD before generating the prototype.",
  'chat.mode.plan.query3': "Turn this idea into an editable design plan.",
  'chat.mode.design.label': 'طراحی',
  'chat.mode.design.title': 'حالت Design',
  'chat.mode.design.summary': 'برای ساخت یا تغییر خروجی های مشخص: صفحه، پروتوتایپ، آرتیفکت زنده، اسلاید، تصویر، ویدئو، HyperFrames، صوت، داشبورد و فایل های پروژه.',
  'chat.mode.design.solves': 'وقتی می خواهید Open Design فایل بسازد، workspace را به روز کند یا brief را به خروجی های چندرسانه ای قابل تحویل تبدیل کند استفاده کنید.',
  'chat.mode.design.query1': 'از این brief یک صفحه فرود لانچ محصول و پروتوتایپ HyperFrames بساز.',
  'chat.mode.design.query2': 'یک deck سرمایه گذاری ۱۰ اسلایدی با یادداشت ارائه بساز.',
  'chat.mode.design.query3': 'برای این کمپین ایده های تصویر، ویدئو و صوت تولید کن.',
  'chat.mode.cardBestFor': 'مناسب برای',
  'chat.mode.cardTry': 'نمونه درخواست',
  'chat.mode.cardCost': 'مصرف معمول',
  'chat.mode.chat.cost': 'کم',
  'chat.mode.chat.costNote': 'فقط گفت‌وگو — چیزی تولید نمی‌شود، بنابراین کمترین مصرف را دارد.',
  'chat.mode.plan.cost': 'متوسط',
  'chat.mode.plan.costNote': 'پیش از هر تولیدی، یک سند طرح قابل‌ویرایش می‌سازد.',
  'chat.mode.design.cost': 'زیاد',
  'chat.mode.design.costNote': 'فایل‌ها و محتوای چندوجهی تولید می‌کند، بنابراین هر اجرا ممکن است بیشترین مصرف را داشته باشد.',
  'chat.composerHint': '⌘/Ctrl + Enter برای ارسال · هدف، محتوا، سبک و قالب را ذکر کنید',
  'chat.cliSettingsTitle': 'تنظیمات CLI و مدل',
  'chat.cliSettingsAria': 'باز کردن تنظیمات CLI و مدل',
  'chat.attachTitle': 'ضمیمه کردن فایل‌ها (یا چسباندن / رها کردن)',
  'chat.addContextTitle': 'Add context',
  'chat.attachAria': 'ضمیمه کردن فایل‌ها',
  'chat.importTitle': 'وارد کردن منابع (به زودی)',
  'chat.importLabel': 'وارد کردن',
  'chat.importComingSoon': 'به زودی',
  'chat.importSoon': 'به زودی',
  'chat.importFig': 'آپلود فایل .fig',
  'chat.importGitHub': 'اتصال به GitHub',
  'chat.importWeb': 'گرفتن عنصر وب',
  'chat.importFolder': 'لینک کردن پوشه کد',
  'chat.importSkills': 'مهارت‌ها و سیستم‌های طراحی',
  'chat.importProject': 'ارجاع به پروژه دیگر',
  'chat.importDesignSystemHeader': 'یک سیستم طراحی انتخاب کنید',
  'chat.importDesignSystemBack': 'بازگشت',
  'chat.importDesignSystemSearch': 'جستجوی سیستم‌های طراحی…',
  'chat.importDesignSystemEmpty': 'هیچ سیستم طراحی با "{query}" مطابقت ندارد',
  'chat.importDesignSystemNone': 'هیچ‌کدام — آزاد',
  'chat.importDesignSystemNoneSub': 'این بار به هیچ سیستمی پایبند نباشید',
  'chat.importDesignSystemActive': 'فعال',
  'chat.importDesignSystemSwitched': 'سیستم طراحی به {title} تغییر کرد',
  'chat.importDesignSystemFailed': 'تغییر سیستم طراحی ناموفق بود. لطفاً دوباره تلاش کنید.',
  'chat.importDesignSystemLoadFailed': 'بارگذاری سیستم‌های طراحی ممکن نشد.',
  'browserUse.title': 'الهام',
  'browserUse.summary': '{count} اقدام وب، با اولویت‌دهی به استخراج دارایی‌ها، زبان طراحی، حرکت، بررسی‌های بصری و ساختار اجزا.',
  'browserUse.searchAria': 'جستجوی الهام',
  'browserUse.searchPlaceholder': 'جستجوی اسکرین‌شات‌ها، فونت‌ها، رنگ‌ها، a11y...',
  'browserUse.empty': 'هیچ الهام منطبقی یافت نشد',
  'browserUse.unavailable': 'الهام در اینجا در دسترس نیست',
  'browserUse.added': 'به نوشتارگر اضافه شد',
  // Design Browser
  'designBrowser.aria': 'Design Browser',
  'designBrowser.goBack': 'Go Back',
  'designBrowser.goForward': 'Go Forward',
  'designBrowser.reload': 'Reload',

  'designBrowser.stopLoading': 'توقف بارگذاری',
  'designBrowser.viewportAria': 'Browser viewport',
  'designBrowser.addressPlaceholder': 'Enter URL or search...',
  'designBrowser.addressAria': 'Browser address',
  'designBrowser.suggestion.reference': 'Reference',
  'designBrowser.suggestion.history': 'History',
  'designBrowser.menu.copyScreenshot': 'Copy Screenshot',
  'designBrowser.menu.hardReload': 'Hard Reload',
  'designBrowser.menu.copyUrl': 'Copy URL',
  'designBrowser.menu.openInBrowser': 'Open in Browser',
  'designBrowser.menu.savePageBrief': 'Save Page Brief',
  'designBrowser.menu.clearBrowsingHistory': 'Clear Browsing History',
  'designBrowser.menu.clearCookies': 'Clear Cookies',
  'designBrowser.menu.clearAllData': 'Clear All Data',
  'designBrowser.status.openHttpUrlFirst': 'Open an http URL first',
  'designBrowser.status.openPageBeforeScreenshot': 'Open a page before taking a screenshot',
  'designBrowser.status.screenshotCopied': 'Screenshot copied to clipboard',
  'designBrowser.status.openPageBeforeBrief': 'Open a page before saving a brief',
  'designBrowser.status.openPageBeforeTools': 'Open a page before using browser tools',
  'designBrowser.status.clickElementToComment': 'Click an element to comment',
  'designBrowser.status.clickElementToTune': 'Click an element to tune',
  'designBrowser.status.noElementSelected': 'No browser element selected',
  'designBrowser.status.addBrowserComment': 'Add a browser comment',
  'designBrowser.status.tuneElementThenSaveHtml': 'Tune the element, then save HTML',
  'designBrowser.status.tuneLiveOnly': 'Tune is live only for non-project pages',
  'designBrowser.status.pickerFailed': 'Browser element picker failed',
  'designBrowser.status.applyStyleFailed': 'Could not apply style in browser page',
  'designBrowser.status.editTextFailed': 'Could not edit text in browser page',
  'designBrowser.status.onlyProjectHtmlCanSave': 'Only project-local HTML pages can be saved',
  'designBrowser.status.htmlSaved': 'HTML changes saved',
  'designBrowser.status.htmlSaveFailed': 'HTML save failed',
  'designBrowser.status.commentSavingUnavailable': 'Comment saving is unavailable',
  'designBrowser.status.commentSaved': 'Browser comment saved',
  'designBrowser.status.commentSendingUnavailable': 'Comment sending is unavailable',
  'designBrowser.comments.aria': 'Browser comments',
  'designBrowser.comments.openFor': 'Open browser comment for {label}',
  'designBrowser.comment.dialog': 'Browser comment',
  'designBrowser.comment.elementFallback': 'Browser element',
  'designBrowser.comment.close': 'Close browser comment',
  'designBrowser.comment.noteAria': 'Browser comment note',
  'designBrowser.comment.placeholder': 'Describe the change or issue...',
  'designBrowser.comment.addNote': 'Add note',
  'designBrowser.comment.saveComment': 'Save comment',
  'designBrowser.comment.sending': 'Sending...',
  'designBrowser.comment.sendToChat': 'Send to chat',
  'designBrowser.inspect.editTitle': 'Edit HTML element',
  'designBrowser.inspect.tuneTitle': 'Tune browser element',
  'designBrowser.inspect.closeTune': 'Close browser tune',
  'designBrowser.inspect.colors': 'Colors',
  'designBrowser.inspect.text': 'Text',
  'designBrowser.inspect.fill': 'Fill',
  'designBrowser.inspect.type': 'Type',
  'designBrowser.inspect.size': 'Size',
  'designBrowser.inspect.weight': 'Weight',
  'designBrowser.inspect.spacing': 'Spacing',
  'designBrowser.inspect.pad': 'Pad',
  'designBrowser.inspect.radius': 'Radius',
  'designBrowser.inspect.content': 'Content',
  'designBrowser.inspect.elementText': 'Element text',
  'designBrowser.inspect.saving': 'Saving...',
  'designBrowser.inspect.saveHtml': 'Save HTML',
  'designBrowser.inspect.liveOnly': 'Live only',
  'designBrowser.reference.kicker': 'Open Design browser',
  'designBrowser.reference.title': 'Reference Board',
  'designBrowser.reference.subtitle': 'A curated set of references across inspiration, real product UI, motion, color, type, assets, and design systems. Open one to browse it live while gathering design language for the next artifact.',
  'designBrowser.reference.categoryAria': 'Reference category',
  'designBrowser.reference.searchPlaceholder': 'Search references...',
  'designBrowser.reference.searchAria': 'Search references',
  'designBrowser.reference.clearSearch': 'Clear search',
  'designBrowser.reference.noMatches': 'No references match “{query}”.',
  'designBrowser.reference.clearFilters': 'Clear filters',
  'designBrowser.reference.open': 'Open',
  'designBrowser.reference.group.inspiration': 'Inspiration',
  'designBrowser.reference.group.interfaces': 'Real Interfaces',
  'designBrowser.reference.group.motion': 'Motion',
  'designBrowser.reference.group.color': 'Color',
  'designBrowser.reference.group.type': 'Typography',
  'designBrowser.reference.group.icons': 'Icons',
  'designBrowser.reference.group.illustration': 'Illustration',
  'designBrowser.reference.group.photography': 'Photography',
  'designBrowser.reference.group.3d': '3D & Graphics',
  'designBrowser.reference.group.mockups': 'Mockups',
  'designBrowser.reference.group.systems': 'Design Systems',
  'designBrowser.reference.group.components': 'Components',
  'designBrowser.reference.group.guidelines': 'Guidelines & A11y',
  'designBrowser.reference.group.tools': 'Tools & Resources',
  'designBrowser.reference.site.dribbble.detail': 'Design shots and UI inspiration.',
  'designBrowser.reference.site.behance.detail': 'Creative portfolios and case studies.',
  'designBrowser.reference.site.awwwards.detail': 'Award-winning website design.',
  'designBrowser.reference.site.godly.detail': 'Curated modern web design.',
  'designBrowser.reference.site.land_book.detail': 'Landing page gallery and patterns.',
  'designBrowser.reference.site.mobbin.detail': 'Real app screens and UI patterns.',
  'designBrowser.reference.site.screenlane.detail': 'Latest UI design patterns from apps.',
  'designBrowser.reference.site.pageflows.detail': 'Real product user flows and onboarding.',
  'designBrowser.reference.site.uisources.detail': 'Interaction patterns from top apps.',
  'designBrowser.reference.site.collectui.detail': 'Daily UI collection by category.',
  'designBrowser.reference.site.gsap.detail': 'Production animation engine and examples.',
  'designBrowser.reference.site.animations.detail': 'Animation patterns and interaction examples.',
  'designBrowser.reference.site.transitions.detail': 'Transition patterns for modern interfaces.',
  'designBrowser.reference.site.motionsites.detail': 'High-end motion and interaction references.',
  'designBrowser.reference.site.motion.detail': 'Scroll and timeline animation inspiration.',
  'designBrowser.reference.site.animography.detail': 'Animated type and kinetic lettering.',
  'designBrowser.reference.site.reactbits.detail': 'React text animation reference for shiny kinetic type.',
  'designBrowser.reference.site.coolors.detail': 'Fast color palette generator.',
  'designBrowser.reference.site.colorhunt.detail': 'Curated color palettes.',
  'designBrowser.reference.site.realtimecolors.detail': 'Preview palettes on a real UI.',
  'designBrowser.reference.site.color_adobe.detail': 'Color wheel and harmony rules.',
  'designBrowser.reference.site.happyhues.detail': 'Palettes shown in real context.',
  'designBrowser.reference.site.fonts_google.detail': 'Open-source font library.',
  'designBrowser.reference.site.fontshare.detail': 'Quality fonts free for commercial use.',
  'designBrowser.reference.site.typewolf.detail': 'Fonts in use and pairing guidance.',
  'designBrowser.reference.site.fontpair.detail': 'Font pairing suggestions.',
  'designBrowser.reference.site.fontsinuse.detail': 'Typography in real-world design.',
  'designBrowser.reference.site.thesvg.detail': 'SVG assets and vector references.',
  'designBrowser.reference.site.svglogos.detail': 'Clean SVG logos for product and brand mocks.',
  'designBrowser.reference.site.icons_lobehub.detail': 'Product and AI-brand icons for interfaces.',
  'designBrowser.reference.site.icon_sets_iconify.detail': '200k+ open-source icons in one place.',
  'designBrowser.reference.site.lucide.detail': 'Clean, consistent open icon set.',
  'designBrowser.reference.site.heroicons.detail': 'Tailwind-made SVG icons.',
  'designBrowser.reference.site.svgrepo.detail': 'Free SVG vectors and icons.',
  'designBrowser.reference.site.storyset.detail': 'Customizable vector illustrations.',
  'designBrowser.reference.site.undraw.detail': 'Open-source MIT illustrations.',
  'designBrowser.reference.site.blush.detail': 'Mix-and-match illustrations.',
  'designBrowser.reference.site.lummi.detail': 'Free AI-generated visuals.',
  'designBrowser.reference.site.whirrls.detail': 'Hand-drawn image references.',
  'designBrowser.reference.site.worldindots.detail': 'Dot-map and data-viz references.',
  'designBrowser.reference.site.unsplash.detail': 'Free high-resolution photos.',
  'designBrowser.reference.site.pexels.detail': 'Free stock photos and video.',
  'designBrowser.reference.site.pixabay.detail': 'Royalty-free images and media.',
  'designBrowser.reference.site.cosmos.detail': 'Visual discovery and mood boards.',
  'designBrowser.reference.site.spline.detail': 'Browser-based 3D design.',
  'designBrowser.reference.site.threejs.detail': 'WebGL 3D references and demos.',
  'designBrowser.reference.site.womp.detail': 'Easy in-browser 3D creation.',
  'designBrowser.reference.site.pixcap.detail': '3D icons, mockups, and scenes.',
  'designBrowser.reference.site.shots.detail': 'Device and browser mockups.',
  'designBrowser.reference.site.mockuuups.detail': 'Drag-and-drop device mockups.',
  'designBrowser.reference.site.angle.detail': '3D device mockup library.',
  'designBrowser.reference.site.rotato.detail': 'Animated 3D product mockups.',
  'designBrowser.reference.site.impeccable.detail': 'High-quality style and interface references.',
  'designBrowser.reference.site.styles_refero.detail': 'Design style references and visual systems.',
  'designBrowser.reference.site.brandfetch.detail': 'Brand assets, logos, and identity.',
  'designBrowser.reference.site.designsystemsrepo.detail': 'Gallery of public design systems.',
  'designBrowser.reference.site.startups.detail': 'Top startup product and brand references.',
  'designBrowser.reference.site.base_ui.detail': 'Unstyled accessible primitives for custom systems.',
  'designBrowser.reference.site.ui_shadcn.detail': 'Composable React components built on Radix and Tailwind.',
  'designBrowser.reference.site.heroui.detail': 'Modern React component library and design system.',
  'designBrowser.reference.site.radix_ui.detail': 'Accessible low-level UI primitives.',
  'designBrowser.reference.site.react_spectrum_adobe.detail': 'Accessible behavior primitives from Adobe.',
  'designBrowser.reference.site.headlessui.detail': 'Unstyled accessible components for Tailwind projects.',
  'designBrowser.reference.site.mui.detail': 'Material-based React component ecosystem.',
  'designBrowser.reference.site.mantine.detail': 'Full-featured React components and hooks.',
  'designBrowser.reference.site.chakra_ui.detail': 'Accessible React components with theme tokens.',
  'designBrowser.reference.site.ant.detail': 'Enterprise component system and patterns.',
  'designBrowser.reference.site.ark_ui.detail': 'Headless components across modern frameworks.',
  'designBrowser.reference.site.daisyui.detail': 'Tailwind CSS component classes and themes.',
  'designBrowser.reference.site.developer_apple.detail': 'Apple platform design guidelines.',
  'designBrowser.reference.site.m3_material.detail': 'Google\'s Material Design 3.',
  'designBrowser.reference.site.lawsofux.detail': 'UX principles and heuristics.',
  'designBrowser.reference.site.webaim.detail': 'Color contrast checker.',
  'designBrowser.reference.site.a11yproject.detail': 'Accessibility checklist and patterns.',
  'designBrowser.reference.site.toolfolio.detail': 'Design tools, resources, and collections.',
  'designBrowser.reference.site.getdesign.detail': 'Curated design resources.',
  'designBrowser.reference.site.tasteskill.detail': 'Design taste training and critique references.',
  'designBrowser.reference.site.uigoodies.detail': 'Hand-picked design resources.',
  'designBrowser.reference.site.sidebar.detail': 'Five design links, every day.',
  'designBrowser.reference.site.github.detail': 'Reference implementation for embedded browser workflows.',
  'browserUse.category.assets': 'استخراج دارایی‌ها',
  'browserUse.category.tokens': 'زبان طراحی',
  'browserUse.category.motion': 'حرکت',
  'browserUse.category.visual': 'بررسی‌های بصری',
  'browserUse.category.structure': 'کامپوننت‌ها',
  'browserUse.category.project': 'اجرای پروژه',
  'browserUse.category.general': 'عمومی',
  'browserUse.input.none': 'بدون ورودی',
  'browserUse.input.assetKind': 'kind: images | svgs | media | fonts, limit=200',
  'browserUse.input.optionalSelector': 'انتخابگر اختیاری',
  'browserUse.input.requirementSelector': 'الزام، انتخابگر اختیاری',
  'browserUse.input.selectorOptional': 'انتخابگر اختیاری',
  'browserUse.input.scaleOne': 'scale=1',
  'browserUse.input.selectorScaleTwo': 'انتخابگر، scale=2',
  'browserUse.input.gridOverlay': '۱۲ ستون، حداکثر ۱۲۰۰، فاصله ۲۴',
  'browserUse.input.bodySelector': 'selector=\'body\'',
  'browserUse.input.navigate': 'URL، دامنه یا عبارت‌های جستجو',
  'browserUse.input.selector': 'انتخابگر',
  'browserUse.input.selectorText': 'انتخابگر و متن',
  'browserUse.input.scroll': 'پیکسل، بالا، پایین یا صفحه',
  'browserUse.input.terminalRun': 'دستور، مهلت زمانی ۱۲۰ ثانیه',
  'browserUse.input.command': 'دستور',
  'browserUse.input.maxChars': 'maxChars=8000',
  'browserUse.input.custom': '{input}',
  'browserUse.action.extract_logo.output': 'بهترین گزینه‌های لوگو از هدر، ناوبری، نام کلاس‌ها، موقعیت، تصویر OG و گزینه جایگزین favicon.',
  'browserUse.action.list_images.output': 'تمام تصاویر img، srcset، source و تصاویر پس‌زمینه CSS همراه با ابعاد و متن جایگزین.',
  'browserUse.action.download_assets.output': 'پوشه دارایی دانلودشده به همراه _manifest.json با پشتیبانی از referer و کوکی.',
  'browserUse.action.extract_svgs.output': 'SVGهای درون‌خطی و فایل‌های .svg پیوندشده که به‌صورت فایل‌های SVG جداگانه ذخیره شده‌اند.',
  'browserUse.action.optimize_svgs.output': 'فایل‌های SVG بهینه‌شده به همراه نسبت فشرده‌سازی.',
  'browserUse.action.extract_colors.output': 'پالت وزن‌دار به همراه متغیرهای رنگ CSS در :root به‌صورت palette.json و palette.html.',
  'browserUse.action.extract_fonts.output': 'پرکاربردترین خانواده‌های فونت، اندازه‌ها، وزن‌ها و قواعد @font-face به‌صورت typography.json.',
  'browserUse.action.extract_design_tokens.output': 'شعاع، سایه، فاصله‌گذاری و متغیرهای CSS به‌صورت tokens.json.',
  'browserUse.action.extract_type_scale.output': 'مقیاس تایپوگرافی سرتیتر، متن و دکمه به همراه اندازه، وزن، ارتفاع خط و نسبت‌ها.',
  'browserUse.action.extract_buttons.output': 'کتابخانه سبک دکمه بدون تکرار به‌صورت buttons.html و buttons.json.',
  'browserUse.action.extract_grid_system.output': 'کانتینرهای grid و flex، جهت، فاصله‌ها، ستون‌ها و حداکثر عرض‌ها به‌صورت layout.json.',
  'browserUse.action.extract_breakpoints.output': 'نقاط شکست media-query واکنش‌گرا به‌صورت breakpoints.json.',
  'browserUse.action.extract_gradients.output': 'گرادیان‌های CSS به‌صورت gradients.css، gradients.json و HTML پیش‌نمایش.',
  'browserUse.action.extract_shadows.output': 'سایه‌های جعبه، سایه‌های متن و سایه‌های افتاده به‌صورت shadows.json به همراه پیش‌نمایش.',
  'browserUse.action.extract_easings.output': 'توابع easing گذار و انیمیشن به‌صورت easings.json.',
  'browserUse.action.export_tokens.output': 'tokens.css، tokens.scss، tailwind.theme.js و style-dictionary.tokens.json.',
  'browserUse.action.extract_animations.output': '@keyframes، قواعد گذار و transform، کتابخانه‌های حرکت شناسایی‌شده، motion.css و motion.json.',
  'browserUse.action.validate_view.output': 'مسیرهای اسکرین‌شات به همراه مشکلات بصری و چیدمان ساختاریافته.',
  'browserUse.action.audit_layout.output': 'ایرادهای چیدمان شامل سرریز، محدوده، هم‌پوشانی و متن بریده‌شده به‌صورت audit.json.',
  'browserUse.action.audit_accessibility.output': 'مشکلات دسترس‌پذیری همراه با انتخابگرها، برچسب‌ها، نقش‌ها، فوکوس، کنتراست و اسکرین‌شات‌ها در صورت مفید بودن.',
  'browserUse.action.responsive_screenshots.output': 'اسکرین‌شات‌های موبایل ۳۹۰، تبلت ۸۳۴ و دسکتاپ ۱۴۴۰.',
  'browserUse.action.screenshot_full.output': 'اسکرین‌شات تمام‌صفحه فراتر از ناحیه دید.',
  'browserUse.action.screenshot_element.output': 'اسکرین‌شات تک‌عنصری به‌صورت پیش‌فرض با مقیاس ۲ برابر.',
  'browserUse.action.screenshot_with_grid.output': 'اسکرین‌شات با روپوش شبکه چیدمان.',
  'browserUse.action.screenshot_dark_mode.output': 'اسکرین‌شات با prefers-color-scheme: dark.',
  'browserUse.action.generate_styleguide.output': 'راهنمای سبک یک‌صفحه‌ای با رنگ‌ها، مقیاس تایپوگرافی، شعاع و سایه‌ها.',
  'browserUse.action.extract_html.output': 'HTML تمیز و خودبسنده بدون script، noscript یا ویژگی‌های رویداد درون‌خطی.',
  'browserUse.action.extract_component_inventory.output': 'الگوهای کامپوننت تکراری، انتخابگرها، تعدادها و اسکرین‌شات‌ها.',
  'browserUse.action.extract_copy.output': 'سرتیترها، CTAها، متن اصلی و توضیحات به‌صورت copy.md و copy.json.',
  'browserUse.action.extract_nav.output': 'ناوبری اصلی و پیوندهای فوتر به‌صورت sitemap.md و nav.json.',
  'browserUse.action.extract_forms.output': 'فیلدهای فرم، برچسب‌ها، راهنماهای اعتبارسنجی و کنش‌های ارسال به‌صورت forms.json.',
  'browserUse.action.run_project.output': 'URL سرور توسعه شناسایی‌شده که در تب Browser باز شده است.',
  'browserUse.action.detect_project.output': 'فریم‌ورک، مدیر بسته، دستور نصب، دستور توسعه و پورت.',
  'browserUse.action.page_info.output': 'URL، عنوان، توضیحات، تصویر OG، رنگ تم، favicon و viewport.',
  'browserUse.action.snapshot.output': 'تا ۱۲۰ عنصر تعاملی و متنی قابل‌مشاهده همراه با تگ، برچسب، href و مختصات.',
  'browserUse.action.navigate.output': 'صفحه را باز کن و page_info را برگردان.',
  'browserUse.action.click.output': 'پس از اسکرول کردن اولین عنصر منطبق به داخل دید، روی آن کلیک کن.',
  'browserUse.action.type_text.output': 'یک ورودی را پر کن و رویدادهای input و change را ارسال کن.',
  'browserUse.action.scroll.output': 'موقعیت فعلی و بیشینهٔ اسکرول.',
  'browserUse.action.extract_og_metadata.output': 'عنوان متا، توضیحات، URL متعارف، کارت‌های OG/Twitter، تصویر اجتماعی و رنگ تم.',
  'browserUse.action.terminal_run.output': 'stdout، stderr و کد خروج.',
  'browserUse.action.terminal_run_background.output': 'شناسهٔ وظیفهٔ پس‌زمینه و خروجی اخیر.',
  'browserUse.action.terminal_read.output': 'خروجی اخیر ترمینال مشترک.',
  'chat.designToolbox.title': 'جعبه‌ابزار طراحی',
  'chat.designToolbox.tooltip': 'جعبه‌ابزار طراحی',
  'chat.designToolbox.aria': 'باز کردن جعبه‌ابزار طراحی',
  'chat.designToolbox.searchPlaceholder': 'جستجوی مهارت‌ها / MCP / افزونه‌ها / رابط‌ها / فایل‌های طراحی...',
  'chat.designToolbox.searchAria': 'جستجوی منابع جعبه‌ابزار طراحی',
  'chat.designToolbox.followupSection': 'پیگیری',
  'chat.designToolbox.resourcesSection': 'منابع سراسری',
  'chat.designToolbox.selected': 'انتخاب‌شده',
  'chat.designToolbox.noResources': 'هیچ منبعی برای «{query}» پیدا نشد.',
  'chat.designToolbox.badge.video': 'ویدیو',
  'chat.designToolbox.badge.image': 'تصویر',
  'chat.designToolbox.badge.motion': 'موشن',
  'chat.designToolbox.badge.polish': 'پرداخت نهایی',
  'chat.designToolbox.action.auto-match.title': 'تطبیق گام بعدی',
  'chat.designToolbox.action.auto-match.badge': 'تطبیق',
  'chat.designToolbox.action.auto-match.description': 'ابتدا معیار سلیقه را تعریف کن، سپس مهارت‌ها، MCP، افزونه‌ها، رابط‌ها و فایل‌ها را تطبیق بده.',
  'chat.designToolbox.action.asset-search.title': 'Find images / references',
  'chat.designToolbox.action.asset-search.badge': 'Assets',
  'chat.designToolbox.action.asset-search.description': 'Search for usable images, reference screenshots, moodboards, and source candidates for the current design.',
  'chat.designToolbox.action.icon-workflow.title': 'Find / replace icons',
  'chat.designToolbox.action.icon-workflow.badge': 'Icons',
  'chat.designToolbox.action.icon-workflow.description': 'Find, generate, or swap iconography, SVGs, Lucide icons, and visual symbols with a consistent style.',
  'chat.designToolbox.action.image-replace.title': 'Replace page images',
  'chat.designToolbox.action.image-replace.badge': 'Swap',
  'chat.designToolbox.action.image-replace.description': 'Audit current imagery and replace weak hero, section, background, or card images with better assets.',
  'chat.designToolbox.action.reference-extract.title': 'Extract visual references',
  'chat.designToolbox.action.reference-extract.badge': 'Refs',
  'chat.designToolbox.action.reference-extract.description': 'Analyze a reference screenshot or site for palette, typography, layout posture, motion, and asset direction.',
  'chat.designToolbox.action.motion.title': 'افزودن انیمیشن / موشن',
  'chat.designToolbox.action.motion.badge': 'موشن',
  'chat.designToolbox.action.motion.description': 'افزودن موشن ورود، اسکرول، انتقال حالت و میکرواینتراکشن به HTML یا عنصر صفحهٔ فعلی.',
  'chat.designToolbox.action.motion-polish.title': 'پرداخت نهایی موشن',
  'chat.designToolbox.action.motion-polish.badge': 'زمان‌بندی',
  'chat.designToolbox.action.motion-polish.description': 'بررسی زمان‌بندی، easing، عملکرد و بازگشت‌های reduced-motion برای موشن موجود.',
  'chat.designToolbox.action.transition-motion.title': 'Design transitions',
  'chat.designToolbox.action.transition-motion.badge': 'Transition',
  'chat.designToolbox.action.transition-motion.description': 'Design page, scene, loading, and state transitions with restrained timing and reduced-motion fallbacks.',
  'chat.designToolbox.action.threejs-scene.title': '3D / Three.js scene',
  'chat.designToolbox.action.threejs-scene.badge': '3D',
  'chat.designToolbox.action.threejs-scene.description': 'Add or plan Three.js, Spline, Vanta, particle, WebGL, map, or deck.gl-style interactive visuals.',
  'chat.designToolbox.action.anti-ai-polish.title': 'حذف حس مصنوعی‌بودن',
  'chat.designToolbox.action.anti-ai-polish.badge': 'سلیقه',
  'chat.designToolbox.action.anti-ai-polish.description': 'حذف حس قالبی، گرادیان‌های AI، انباشت کارت‌های ارزان و متن مبهم.',
  'chat.designToolbox.action.visual-polish.title': 'پرداخت نهایی طراحی / آمادهٔ انتشار',
  'chat.designToolbox.action.visual-polish.badge': 'پرداخت نهایی',
  'chat.designToolbox.action.visual-polish.description': 'ممیزی سلسله‌مراتب بصری، تایپوگرافی، فاصله‌گذاری، رفتار واکنش‌گرا، دسترس‌پذیری و کیفیت تحویل.',
  'chat.designToolbox.action.image-gen.title': 'تولید تصاویر / مراجع بصری',
  'chat.designToolbox.action.image-gen.badge': 'تصویر',
  'chat.designToolbox.action.image-gen.description': 'تولید مراجع بخش‌ها، دارایی‌ها، آیکون‌ها، تصاویر اجتماعی یا یک موودبورد برای صفحهٔ فعلی.',
  'chat.designToolbox.action.chart-gen.title': 'Generate charts / diagrams',
  'chat.designToolbox.action.chart-gen.badge': 'Charts',
  'chat.designToolbox.action.chart-gen.description': 'Generate ECharts, React Flow, diagrams, dashboards, relationship maps, or data-visualization assets.',
  'chat.designToolbox.action.logo-gen.title': 'Generate logo / identity',
  'chat.designToolbox.action.logo-gen.badge': 'Logo',
  'chat.designToolbox.action.logo-gen.description': 'Create logo routes, wordmarks, lockups, marks, and identity-system prompts for the current brand.',
  'chat.designToolbox.action.plan-outline.title': "Generate PPT outline from idea",
  'chat.designToolbox.action.plan-outline.badge': "Plan",
  'chat.designToolbox.action.plan-outline.description': "Turn a rough idea into an editable Markdown deck outline before creating slides.",
  'chat.designToolbox.action.video-gen.title': 'تولید ویدیو / اسکریپت موشن',
  'chat.designToolbox.action.video-gen.badge': 'ویدیو',
  'chat.designToolbox.action.video-gen.description': 'تبدیل طراحی به یک ویدیوی کوتاه، استوری‌بورد Remotion / Hyperframes یا پرامپت آمادهٔ تولید.',
  'chat.designToolbox.kind.skill': 'مهارت',
  'chat.designToolbox.kind.plugin': 'افزونه',
  'chat.designToolbox.kind.mcp': 'MCP',
  'chat.designToolbox.kind.mcpTemplate': 'قالب MCP',
  'chat.designToolbox.kind.connector': 'رابط',
  'chat.designToolbox.kind.designFile': 'فایل طراحی',
  'chat.designToolbox.context.browser': 'مرورگر',
  'chat.designToolbox.context.designFiles': 'فایل‌های طراحی',
  'chat.designToolbox.context.designSystem': 'سیستم طراحی',
  'chat.designToolbox.context.folder': 'پوشه',
  'chat.designToolbox.context.terminal': 'ترمینال',
  'chat.designToolbox.context.sideChat': 'گفتگوی جانبی',
  'chat.designToolbox.context.liveArtifact': 'آرتیفکت زنده',
  'chat.designToolbox.context.file': 'فایل',
  'chat.designToolbox.prompt.contextGeneric': 'هدف فعلی: فایل HTML / فایل طراحی / عنصر وب که هم‌اکنون باز است.',
  'chat.designToolbox.prompt.contextSpecific': 'هدف فعلی: {kind} · {label}.',
  'chat.designToolbox.prompt.preserveDraft': 'نیتی که از پیش در نگارشگر وجود دارد را حفظ کن: {draft}',
  'chat.designToolbox.prompt.selectedSkill': 'مهارت انتخاب‌شده: {skill}. از آن به عنوان جریان کاری اصلی این مرحله استفاده کن.',
  'chat.designToolbox.prompt.noSkill': 'اگر هیچ مهارت خاصی مطابقت نداشت، ابتدا بهترین ترکیب را از میان مهارت‌های موجود، MCP، پلاگین‌ها، کانکتورها و فایل‌های طراحی انتخاب کنید.',
  'chat.designToolbox.prompt.autoMatchIntro': 'به‌عنوان هماهنگ‌کننده مدیر خلاقیت عمل کنید و یک گردش‌کار طراحی را تکمیل کنید:',
  'chat.designToolbox.prompt.autoMatchStep1': '۱. ابتدا مشخص کنید که «طراحی خوش‌ظاهر» چه معنایی دارد: مخاطب، هدف تجاری، حس برند، مراجع سبک، چگالی اطلاعات، استانداردهای رنگ/تایپوگرافی/حرکت/آرتیفکت، و الگوهای AI/قالبی که باید از آن‌ها پرهیز کرد.',
  'chat.designToolbox.prompt.autoMatchStep2': '۲. در فهرست کامل منابع بالا جست‌وجو و مطابقت‌یابی کنید. فقط به توصیه‌های جعبه‌ابزار طراحی اکتفا نکنید؛ در صورت مفید بودن، مهارت‌ها، MCP، پلاگین‌ها، کانکتورها و فایل‌های طراحی را با هم ترکیب کنید.',
  'chat.designToolbox.prompt.autoMatchStep3': '3. If the target or aesthetic bar is still unclear, guide me with a structured question-form, include recommended defaults, and make each finite-choice question editable with a custom answer field. If it is clear enough, execute the next step directly.',
  'chat.designToolbox.prompt.autoMatchStep4': '۴. این جریان را به این ترتیب کامل کنید: تشخیص ‏‎->‎‏ جهت‌گیری سبک ‏‎->‎‏ انتخاب منابع ‏‎->‎‏ ویرایش/تولید مشخص ‏‎->‎‏ راستی‌آزمایی. در هر مرحله توضیح دهید چرا این منابع انتخاب شدند و در گام بعد چه چیزی نیاز به تأیید دارد.',
  'chat.designToolbox.prompt.assetSearch': 'Find the best image/reference assets for the current design. Search available files, connectors, MCPs, browser captures, and generation tools. Return concrete candidates with usage notes, licensing/source caveats when relevant, and a fallback generation prompt if no usable asset exists.',
  'chat.designToolbox.prompt.iconWorkflow': 'Improve the icon system for the current design: find missing icons, replace weak icons, keep stroke/fill/radius/weight consistent, prefer existing icon libraries when available, and generate SVG/icon prompts only when a library icon is insufficient.',
  'chat.designToolbox.prompt.imageReplace': 'Audit every visible image slot in the current design, identify weak or placeholder imagery, then replace or specify better hero, section, background, card, and social images. Preserve layout and provide exact file/prompt/source choices.',
  'chat.designToolbox.prompt.referenceExtract': 'Use the current reference image/site/design file as visual input. Extract palette, type scale, layout rhythm, component posture, motion cues, and asset style, then apply those findings to the current design without copying protected brand assets verbatim.',
  'chat.designToolbox.prompt.motion': 'Add high-quality motion to the current HTML / page element: choose the most useful 1-2 entrance, scroll, state-transition, transition, Rive/Lottie-style icon motion, or GSAP/Motion micro-interaction moments. Keep it restrained, prefer transform / opacity, and include prefers-reduced-motion fallbacks.',
  'chat.designToolbox.prompt.planOutline': "Create or update a Markdown planning document for a PPT/deck outline from this idea. Do not generate the final deck yet. Include slide-by-slide titles, goals, content bullets, visual direction, required data/assets, and open questions. Save it as a `.md` file in Design Files and tell me which file to review.",
  'chat.designToolbox.prompt.motionPolish': 'زمان‌بندی، easing، کارایی و دسترس‌پذیری حرکت موجود را بررسی و اصلاح کنید. انیمیشن‌های ناگهانی، بی‌ارزش یا آسیب‌رسان به خوانایی را حذف کنید؛ در صورت نیاز از یک تایم‌لاین پالوده‌تر استفاده کنید.',
  'chat.designToolbox.prompt.transitionMotion': 'Design high-quality transitions for the current design: page/scene changes, loading bridges, state changes, and section handoffs. Use GSAP/Motion/CSS where appropriate, keep it performant, and include reduced-motion behavior.',
  'chat.designToolbox.prompt.threejsScene': 'Plan or implement a focused Three.js/WebGL visual for the current design. Consider Three.js, Spline-style scenes, Vanta backgrounds, particle systems, Mapbox/deck.gl data layers, or browser portal effects, but keep the scene useful and verify it renders.',
  'chat.designToolbox.prompt.antiAiPolish': 'یک پاس اصلاحی برای حذف حس مصنوعی هوش مصنوعی انجام دهید: چیدمان‌های قالبی، گرادیان‌ها/درخشش‌های بی‌ارزش، انباشت کارت‌های بی‌معنا و متن‌های مبهم را حذف کنید. اطلاعات را حفظ کنید و کاری کنید که حس کند یک طراح واقعی آن را تحویل داده است.',
  'chat.designToolbox.prompt.visualPolish': 'این طراحی را تا آماده‌شدن برای انتشار اصلاح کنید: سلسله‌مراتب، تایپوگرافی، فاصله‌گذاری، رفتار واکنش‌گرا، حالت‌های دکمه، حالت‌های خالی/در حال بارگذاری/خطا و دسترس‌پذیری را بررسی کنید؛ مهم‌ترین مشکلات را مستقیماً برطرف کنید.',
  'chat.designToolbox.prompt.imageGen': 'برنامه بعدی دارایی‌های بصری این طراحی را بسازید: مرجع‌های بخش‌ها، دارایی‌های hero، تصویرسازی‌ها، آیکون‌ها، تصاویر شبکه‌های اجتماعی یا یک moodboard. ابتدا تصمیم بگیرید چه نوع تصویری کم است، سپس پرامپت‌های تولید قابل‌اجرا / برنامه فایل ارائه دهید.',
  'chat.designToolbox.prompt.chartGen': 'Generate the right chart, diagram, or data-visualization for the current design. Choose between ECharts, React Flow, SVG/CSS diagrams, radar charts, relationship maps, dashboards, or deck.gl/map visualizations based on the data and user goal.',
  'chat.designToolbox.prompt.logoGen': 'Create logo and identity directions for the current brand. Produce multiple routes for wordmark, symbol, lockup, palette, usage rules, and generation prompts; make sure the result is original and usable in the current artifact.',
  'chat.designToolbox.prompt.videoGen': 'این طراحی را به‌سمت ویدئو ببرید: یک استوری‌بورد ویدئوی کوتاه، ساختار فریم HyperFrames / Remotion یا پرامپت آماده برای Sora/fal بسازید. ترجیحاً کاری کنید که محتوای HTML / صفحه موجود به‌طور طبیعی به نماها تبدیل شود.',
  'chat.designToolbox.prompt.useSkill': 'از {skill} روی طراحی فعلی استفاده کنید.',
  'chat.designToolbox.prompt.skillInstruction': 'ابتدا بهترین هدف بعدی را تعیین کنید، سپس یک پاس مشخص را تکمیل کنید. اگر به دارایی‌ها یا APIهای خارجی وابسته است، یک حالت جایگزین قابل‌اجرا ارائه دهید یا بیان کنید چه چیزی باید از سوی من فراهم شود.',
  'chat.designToolbox.prompt.selectedResource': 'منبع انتخاب‌شده: {kind} · {title} ({id}).',
  'chat.designToolbox.prompt.resourceDescription': 'توضیح منبع: {description}',
  'chat.designToolbox.prompt.pluginResource': 'از این پلاگین به‌عنوان زمینه اصلی برای جریان طراحی فعلی استفاده کنید. اگر ورودی‌ها یا GenUI را در دسترس قرار می‌دهد، در صورت نیاز مرا برای انتخاب راهنمایی کنید؛ اگر با هدف سازگار نیست، منبع سراسری بهتری انتخاب کنید و دلیل آن را توضیح دهید.',
  'chat.designToolbox.prompt.mcpResource': 'برای گام طراحی بعدی، این قابلیت MCP را ترجیح دهید. هنگامی که به دارایی‌های خارجی، ضبط وب، تولید تصویر/ویدئو یا داده نیاز است، ابتدا تصمیم بگیرید آیا می‌تواند کار را انجام دهد، سپس یک برنامه قابل‌اجرا ارائه دهید.',
  'chat.designToolbox.prompt.mcpTemplateResource': 'این MCP یک قالب قابل‌پیکربندی است. اگر مفیدترین ابزار برای این گام طراحی است، ابتدا راه‌اندازی را راهنمایی کنید؛ اگر یک جایگزین پیکربندی‌شده وجود دارد، با همان جایگزین ادامه دهید.',
  'chat.designToolbox.prompt.connectorResource': 'هنگامی که به داده واقعی، دارایی‌ها، محتوای حساب کاربری یا دسترسی به گردش‌کار خارجی نیاز است، از این کانکتور استفاده کنید. پیش از استفاده، توضیح دهید چه چیزی خوانده یا نوشته می‌شود و در صورت لزوم درخواست تأیید کنید.',
  'chat.designToolbox.prompt.fileResource': 'از این فایل طراحی به‌عنوان هدف طراحی فعلی یا دارایی مرجع استفاده کنید و گام بعدی را از روی آن تکمیل کنید. اگر فایل‌های دیگری نیاز به مقایسه دارند، جست‌وجو را در میان همه فایل‌های طراحی ادامه دهید.',
  'chat.designToolbox.prompt.resourceIndex': 'فهرست منابع سراسری: مهارت‌ها({skills})، پلاگین‌ها({plugins})، MCP({mcpEnabled} فعال / {mcpTemplates} قالب)، کانکتورها({connectors} متصل)، فایل‌های طراحی({files}).',
  'chat.designToolbox.prompt.searchableSkills': 'مهارت‌های قابل‌جست‌وجو',
  'chat.designToolbox.prompt.searchablePlugins': 'پلاگین‌های قابل‌جست‌وجو',
  'chat.designToolbox.prompt.availableMcp': 'MCP موجود',
  'chat.designToolbox.prompt.connectedConnectors': 'کانکتورهای متصل',
  'chat.designToolbox.prompt.referenceDesignFiles': 'فایل‌های طراحی مرجع',
  'chat.designToolbox.prompt.mcpTemplateName': 'قالب {name}',
  'chat.designToolbox.prompt.processRule': 'Workflow rule: define the aesthetic goal and constraints first, then search and match resources; when user choice is needed, generate a structured question-form with editable custom answers and continue after confirmation.',
  'chat.designToolbox.prompt.moreSuffix': '، +{count} مورد دیگر',
  'chat.designToolbox.prompt.compactLine': '{label}: {values}{suffix}.',
  'chat.mentionTabsAria': 'سطوح منشن',
  'chat.mentionTabAll': 'همه',
  'chat.mentionTabTabs': 'تب‌ها',
  'chat.mentionTabPlugins': 'پلاگین‌ها',
  'chat.mentionTabSkills': 'مهارت‌ها',
  'chat.mentionTabMcp': 'MCP',
  'chat.mentionTabConnectors': 'کانکتورها',
  'chat.mentionTabFiles': 'فایل‌های طراحی',
  'chat.mentionNoResults': 'هیچ نتیجه‌ای برای «{query}» یافت نشد.',
  'chat.mentionSearchPrompt': 'در فایل‌های طراحی، تب‌ها، پلاگین‌ها، مهارت‌ها، سرورهای MCP و کانکتورها جست‌وجو کنید.',
  'chat.mentionSectionTabs': 'تب‌ها',
  'chat.mentionSectionPlugins': 'پلاگین‌ها',
  'chat.mentionSectionSkills': 'مهارت‌ها',
  'chat.mentionSectionMcp': 'MCP',
  'chat.mentionSectionConnectors': 'کانکتورها',
  'chat.mentionSectionFiles': 'فایل‌های طراحی',
  'chat.mentionActiveSkill': 'فعال',
  'chat.mentionUseMcpTitle': 'استفاده از {name}',
  'chat.mentionUseConnectorTitle': 'استفاده از {name}',
  'chat.mentionPluginOfficial': 'رسمی',
  'chat.mentionPluginMine': 'پلاگین من',
  'chat.linkedFolderRemoveAria': 'حذف پوشه لینک شده {path}',
  'chat.linkedFolderNotFound': 'پوشه وجود ندارد',
  'chat.linkedFolderAlready': 'این پوشه قبلاً لینک شده است',
  'chat.linkedFolderPickError': 'انتخابگر پوشه باز نشد',
  'chat.queuedHeader': 'در صف',
  'chat.queuedToSend': 'برای ارسال',
  'chat.queuedEditQueuedTaskAria': 'ویرایش وظیفه در صف',
  'chat.queuedSave': 'ذخیره',
  'chat.queuedCancel': 'لغو',
  'chat.queuedReorder': 'برای مرتب‌سازی بکشید',
  'chat.queuedEdit': 'ویرایش',
  'chat.queuedMore': 'مورد دیگر در صف',
  'chat.queuedFollowUpFallback': 'پیگیری در صف',
  'chat.send': 'ارسال',
  'chat.stop': 'توقف',
  'chat.removeAria': 'حذف {name}',
  'chat.example1Title': 'ارائه سردبیری',
  'chat.example1Tag': 'مجله',
  'chat.example1Prompt': 'یک ارائه سردبیری ۱۰ اسلایدی برای یک استودیو طراحی که در حال جمع‌آوری یک دور سرمایه‌گذاری اولیه است — چیدمان شبکه سوئیسی، عناوین سریف بزرگ با حروف تزئینی پررنگ، شماره‌های بخش با فونت monospace، فضای منفی سخاوتمندانه، و اسلایدهای تمام خون عکس که با اسلایدهای متن‌محور در هم تنیده شده‌اند. جلد، چشم‌انداز، بازار، محصول، کشش، تیم، درخواست، تماس.',
  'chat.example2Title': 'داشبورد تحلیل SaaS',
  'chat.example2Tag': 'داده',
  'chat.example2Prompt': 'یک داشبورد تحلیل متراکم برای یک SaaS ابزار توسعه‌دهنده — نوار KPI با دلتاهای هفته به هفته، دو نمودار خط انباشته (MRR و فضاهای کاری فعال)، یک نقشه حرارتی جهانی از استفاده، یک شبکه ماندگاری کوهورت، یک جدول رهبری برترین مشتریان، و یک فید رویداد بلادرنگ. تم تاریک، اعداد جدولی monospace، تأکیدات sparkline.',
  'chat.example3Title': 'گزارش سالانه اسکرول بلند',
  'chat.example3Tag': 'سردبیری',
  'chat.example3Prompt': 'یک گزارش سالانه تعاملی برای یک سازمان غیرانتفاعی آب و هوایی — چیدمان سردبیری اسکرول بلند که بلوک‌های نقل قول بزرگ، تصویرسازی‌های داده، عکاسی، دیوار اهداکنندگان و یک فراخوان به عمل نهایی را ترکیب می‌کند.',
  'home.recommendation.eyebrow': 'پیشنهادشده برای شما',
  'home.recommendation.primaryCta': 'شروع ساخت',
  'home.recommendation.change': 'یک مورد دیگر را امتحان کنید',
  'home.recommendation.browseAll': 'همه انواع',
  'home.recommendation.defaultProjectName': 'پروژه جدید',
  'home.recommendation.startFailed': 'شروع ساخت ممکن نشد. لطفاً دوباره تلاش کنید.',
  'studio.firstArtifactHint.title': 'اولین طراحی شما آماده است',
  'studio.firstArtifactHint.body': 'ویرایش و حاشیه‌نویسی را مستقیم امتحان کنید — هر وقت راضی بودید خروجی بگیرید یا به اشتراک بگذارید.',
  'studio.firstArtifactHint.dismiss': 'متوجه شدم',
  'home.starter.product_ui_prototype.title': 'با یک نمونه‌ اولیه محصول قابل ویرایش شروع کنید',
  'home.starter.product_ui_prototype.desc': 'بر اساس هدفتان، با یک رابط قابل کلیک که می‌توانید آن را پالایش کنید شروع کنید.',
  'home.starter.product_ui_prototype.firstPrompt': 'یک نمونه اولیه محصول قابل ویرایش برای [محصول شما] با صفحه‌های کلیدی و یک جریان اصلی روشن طراحی کنید.',
  'home.starter.product_ui_component.title': 'از یک مؤلفه قابل استفاده مجدد شروع کنید',
  'home.starter.product_ui_component.desc': 'ابتدا یک مؤلفه بسازید، سپس آن را در صفحه‌های کامل ترکیب کنید.',
  'home.starter.product_ui_component.firstPrompt': 'یک مؤلفه قابل استفاده مجدد [نام مؤلفه] با حالت‌ها و گونه‌های اصلی آن طراحی کنید.',
  'home.starter.product_ui_lowfi.title': 'با یک نمونه اولیه کم‌جزئیات شروع کنید',
  'home.starter.product_ui_lowfi.desc': 'ابتدا ساختار را طرح بزنید، سپس جزئیات را بالا ببرید.',
  'home.starter.product_ui_lowfi.firstPrompt': 'یک وایرفریم کم‌جزئیات از صفحه‌های اصلی برای [محصول شما] بسازید.',
  'home.starter.marketing_landing.title': 'با یک صفحه فرود شروع کنید',
  'home.starter.marketing_landing.desc': 'کمپین خود را به یک صفحه فرود قابل انتشار تبدیل کنید.',
  'home.starter.marketing_landing.firstPrompt': 'یک صفحه فرود برای [محصول شما] با بخش هیرو، مزایای کلیدی و یک فراخوان به عمل روشن طراحی کنید.',
  'home.starter.marketing_multivariant.title': 'با چند گونه صفحه فرود شروع کنید',
  'home.starter.marketing_multivariant.desc': 'چند نسخه بسازید تا پیش از تصمیم نهایی مقایسه کنید.',
  'home.starter.marketing_multivariant.firstPrompt': '۳ گونه صفحه فرود برای [محصول شما] با پیام‌های هیرو متفاوت برای مقایسه بسازید.',
  'home.starter.internal_dashboard.title': 'با یک داشبورد داخلی شروع کنید',
  'home.starter.internal_dashboard.desc': 'از یک چیدمان داشبورد برای گردش‌کارتان شروع کنید.',
  'home.starter.internal_dashboard.firstPrompt': 'یک داشبورد داخلی طراحی کنید که [معیارهای کلیدی] را با فیلترها و یک جدول داده نمایش دهد.',
  'home.starter.internal_report.title': 'با یک گزارش شروع کنید',
  'home.starter.internal_report.desc': 'داده‌ها و فیلدهایی را که می‌خواهید ببینید توصیف کنید.',
  'home.starter.internal_report.firstPrompt': 'یک صفحه گزارش بسازید که [داده‌ها، فیلدها و معیارهای موردنظرتان را توصیف کنید] را خلاصه کند.',
  'home.starter.general_menu.title': 'با اولین پروژه‌تان شروع کنید',
  'home.starter.general_menu.desc': 'آنچه می‌خواهید را توصیف کنید و ما یک نسخه اولیه قابل ویرایش می‌سازیم.',
  'home.starter.general_menu.firstPrompt': 'یک نسخه اولیه قابل ویرایش از [آنچه می‌خواهید بسازید را توصیف کنید] بسازید.',
  'chat.example4Title': 'ویدیوی موشن محصول',
  'chat.example4Tag': 'موشن',
  'chat.example4Prompt': 'یک استوری‌بورد ویدیوی موشن ۱۵ ثانیه‌ای برای معرفی یک اپ بهره‌وری بساز: شروع جذاب، نماهای نزدیک UI، تایپوگرافی پویا، گذارهای ویژگی‌ها، پایان با لوگو و CTA. زمان‌بندی، شرح صحنه، حرکت دوربین و متن‌های روی تصویر را هم اضافه کن.',
  'preview.usePlugin': 'استفاده از افزونه',
  'preview.usePluginOnly': 'استفاده بدون پرامپت',
  'preview.usePluginOnlyDesc': 'از ساختار افزونه بدون بارگذاری پرامپت نمونه استفاده کنید',
  'preview.replicateContent': 'استفاده',
  'preview.replicateContentDesc': 'از پرامپت نمونه برای بازسازی پیش‌نمایش استفاده کنید',
  'preview.duplicateTemplate': 'Remix',
  'preview.duplicateTemplateDesc': 'این نمونه را به یک پروژه قابل ویرایش جدید Remix کنید',
  'preview.shareMenu': 'اشتراک‌گذاری',
  'preview.exportMenu': 'خروجی گرفتن',
  'preview.shareTemplateBadge': 'قالب',
  'preview.shareToX': 'X / Twitter',
  'preview.shareToReddit': 'Reddit',
  'preview.shareToFacebook': 'Facebook',
  'preview.shareToLinkedIn': 'LinkedIn',
  'preview.shareToInstagram': 'Instagram',
  'preview.shareToXiaohongshu': '小红书',
  'preview.copyTemplateLink': 'کپی لینک قالب',
  'preview.copyShareText': 'کپی متن اشتراک‌گذاری',
  'preview.shareSocialGroup': 'اشتراک‌گذاری در شبکه‌های اجتماعی',
  'preview.shareCopyGroup': 'کپی',
  'preview.shareExportGroup': 'خروجی گرفتن فایل‌ها',
  'preview.shareCopied': 'کپی شد',
  'preview.shareCopyFailed': 'کپی ناموفق بود',
  'preview.shareTextDefault': 'قالب Open Design: {title}',
  'preview.openInNewTab': 'باز کردن در تب جدید',
  'preview.exit': '⤓ خروج',
  'preview.fullscreen': '⤢ تمام صفحه',
  'preview.closeTitle': 'بستن (Esc)',
  'preview.loading': 'در حال بارگذاری {label}…',
  'preview.errorTitle': 'بارگیری این نمونه ممکن نشد.',
  'preview.errorBody': 'دریافت HTML نمونه با خطا مواجه شد. مطمئن شوید Open Design در حال اجراست و دوباره تلاش کنید.',
  'preview.retry': 'تلاش دوباره',
  'preview.unavailableTitle': 'برای {noun} پیش‌نمایش همراهی وجود ندارد.',
  'preview.unavailableBody': 'برای ساخت خروجی {kind}، پرامپت را در گفتگو اجرا کنید.',
  'preview.nounSkill': 'این مهارت',
  'preview.nounPlugin': 'این افزونه',
  'preview.nounTemplate': 'این الگو',
  'preview.showSidebar': 'نمایش {label}',
  'preview.hideSidebar': 'پنهان کردن {label}',
  'misc.savedTemplate': 'قالب ذخیره شده',
  'misc.primary': 'اصلی',
  'misc.designSystem': 'سیستم طراحی',
  'workspace.designFiles': 'فایل‌های طراحی',
  'workspace.focusMode': 'تمرکز بر فضای کاری',
  'workspace.showChat': 'نمایش گفت‌وگو',
  'workspace.closeTab': 'بستن تب',
  'workspace.deleteFileConfirm': 'آیا «{name}» از پوشه پروژه حذف شود؟',
  'workspace.deleteSelectedFilesConfirm': 'آیا {n} فایل انتخاب‌شده از پوشه پروژه حذف شوند؟',
  'workspace.deleteSelectedFilesPartial': 'حذف {n} فایل ناموفق بود.',
  'workspace.openFromDesignFiles': 'باز کردن یک فایل از',
  'workspace.designFilesLink': 'فایل‌های طراحی',
  'workspace.loadingSketch': 'در حال بارگذاری طرح…',
  'workspace.newTab': 'زبانه جدید',
  'workspace.searchFilesPlaceholder': 'Search files…',
  'workspace.openTabs': 'زبانه‌های باز',
  'workspace.openFile': 'Open a file',
  'workspace.noFilesMatch': 'No files match',
  'workspace.allFiles': 'All',
  'workspace.createNew': 'Create new',
  'workspace.tabOpen': 'Open',
  'workspace.sideChatContextBanner': 'Integrated context from the current conversation',
  'workspace.sideChatDefaultTitle': 'Side chat',
  'workspace.newTerminal': 'New Terminal',
  'workspace.newTerminalDescription': 'Open a shell in the project directory in a new tab',
  'workspace.newBrowser': 'New Browser',
  'workspace.newBrowserDescription': 'Open a built-in browser tab for reference sites and design research',
  'workspace.newSketchDescription': 'Sketch rough layouts and notes for the agent to use as design context',
  'workspace.terminalStarting': 'در حال راه‌اندازی ترمینال…',
  'workspace.terminalStartingDescription': 'در حال آماده‌سازی شل پروژه. معمولاً چند ثانیه طول می‌کشد.',
  'workspace.terminalSessionEnded': 'نشست پایان یافت',
  'workspace.terminalReconnecting': 'در حال اتصال مجدد…',
  'workspace.terminalStartFailed': 'نشست ترمینال آغاز نشد',
  'workspace.terminalRestart': 'راه‌اندازی مجدد',
  'designFiles.title': 'فایل‌های طراحی',
  'designFiles.upload': 'آپلود فایل‌ها',
  'designFiles.pasteText': 'چسباندن به عنوان فایل متنی',
  'designFiles.newSketch': 'طرح جدید',
  'designFiles.empty': 'آفرینش‌ها اینجا نمایش داده می‌شوند',
  'designFiles.refresh': 'بازنشانی',
  'designFiles.delete': 'حذف',
  'designFiles.searchPlaceholder': 'جستجوی فایل‌ها…',
  'designFiles.up': 'بالا',
  'designFiles.back': 'بازگشت',
  'designFiles.crumbs': 'پروژه',
  'designFiles.rowMenu': 'منوی ردیف',
  'designFiles.openInTab': 'باز کردن در تب',
  'designFiles.download': 'دانلود',
  'designFiles.downloadSelected': 'دانلود {n} به صورت ZIP',
  'designFiles.deleteSelected': 'حذف {n}',
  'designFiles.clearSelection': 'پاک کردن انتخاب',
  'designFiles.selectPage': 'انتخاب همه در صفحه',
  'designFiles.selectAll': 'انتخاب همه',
  'designFiles.dropTitle': '⤓ فایل‌ها را اینجا رها کنید',
  'designFiles.dropDesc': 'تصاویر، اسناد، مراجع یا پوشه‌ها — عامل از آن‌ها به عنوان زمینه استفاده خواهد کرد.',
  'designFiles.dropLabel': 'فایل‌ها را اینجا رها کنید',
  'designFiles.upload.title': 'آپلود فایل‌ها',
  'designFiles.paste.title': "Create document",
  'designFiles.upload.label': 'آپلود',
  'designFiles.paste.label': "Create document",
  'designFiles.documentTemplate.titleFallback': 'Document',
  'designFiles.documentTemplate.goalHeading': 'Goal',
  'designFiles.documentTemplate.goalBody': 'Describe what Open Design should generate, edit, or decide from this document.',
  'designFiles.documentTemplate.capabilitiesHeading': 'How to use this document',
  'designFiles.documentTemplate.capabilityMarkdown': 'Use any Markdown format: headings, tables, checklists, links, quotes, code blocks, and images.',
  'designFiles.documentTemplate.capabilityAgent': 'The Open Design agent can read, edit, and use this file as project context.',
  'designFiles.documentTemplate.capabilityImages': 'Paste images, or drag image files onto the editor; uploaded images are inserted at the cursor.',
  'designFiles.documentTemplate.scenarioHeading': 'Scenario guide',
  'designFiles.documentTemplate.scenario.prototype': 'For prototypes, outline the product goal, target users, flows, screens, modules, interaction states, responsive breakpoints, and design tokens such as color, type, spacing, radius, and motion.',
  'designFiles.documentTemplate.scenario.wireframe': 'For wireframes, describe the user flow, screen list, layout hierarchy, content blocks, low-fidelity constraints, and the questions the structure should answer before visual design.',
  'designFiles.documentTemplate.scenario.mobile': 'For mobile apps, list target platforms, screens, navigation model, gestures, native patterns, device sizes, states, and mobile design tokens.',
  'designFiles.documentTemplate.scenario.slideDeck': 'For slides, write a paginated PPT outline: one section per slide with title, purpose, key message, evidence, visual direction, speaker notes, and export needs.',
  'designFiles.documentTemplate.scenario.document': 'For documents, define audience, tone, section structure, source material, citations or data, layout expectations, and PDF/export requirements.',
  'designFiles.documentTemplate.scenario.image': 'For images, specify subject, aspect ratio, composition, visual style, brand tokens, reference files, and negative constraints.',
  'designFiles.documentTemplate.scenario.video': 'For video, draft a storyboard with scenes, timing, captions, motion, assets, audio notes, and output format.',
  'designFiles.documentTemplate.scenario.hyperframes': 'For HyperFrames, describe the HTML motion piece: scenes, timeline, captions, audio-reactive moments, transitions, and capture/export requirements.',
  'designFiles.documentTemplate.scenario.audio': 'For audio, define voice or music direction, duration, mood, script or copy, pacing, pronunciation notes, and final use.',
  'designFiles.documentTemplate.scenario.liveArtifact': 'For live artifacts, describe data sources, refresh cadence, widgets, filters, interactions, empty/loading/error states, and any alerts or automations.',
  'designFiles.documentTemplate.scenario.designSystem': 'For design systems, list brand goals, tokens, typography, color, spacing, components, assets, references, and rules to follow or avoid.',
  'designFiles.documentTemplate.scenario.default': 'Describe the audience, deliverable, required content, references, constraints, and what done should look like.',
  'designFiles.documentTemplate.nextHeading': 'Next step',
  'designFiles.documentTemplate.nextBody': 'Review and edit this document, then ask Open Design to generate, revise, or operate from it.',

  'designFiles.projectMenu': 'Project actions',
  'designFiles.createDesignSystemFromProject': 'Create design system from this project',
  'designFiles.duplicateProject': 'Duplicate project',

  'designFiles.previewOpen': 'باز کردن',
  'designFiles.previewClose': 'بستن پیش‌نمایش',
  'designFiles.modified': 'ویرایش شده {time} · {size}',
  'designFiles.weeksAgo': '{n} هفته پیش',
  'designFiles.groupBy': 'گروه‌بندی بر اساس',
  'designFiles.groupByKind': 'نوع',
  'designFiles.groupByModified': 'زمان ویرایش',
  'designFiles.filterBy': 'فیلتر بر اساس نوع',
  'designFiles.filterClear': 'پاک کردن',
  'designFiles.filterCount': '{n} نوع',
  'designFiles.expandGroup': 'باز کردن',
  'designFiles.collapseGroup': 'جمع کردن',
  'designFiles.sectionPages': 'صفحات',
  'designFiles.sectionScripts': 'اسکریپت‌ها',
  'designFiles.sectionImages': 'تصاویر',
  'designFiles.sectionSketches': 'طرح‌ها',
  'designFiles.sectionLiveArtifacts': 'مصنوعات زنده',
  'designFiles.sectionOther': 'سایر',
  'designFiles.modifiedToday': 'امروز',
  'designFiles.modifiedYesterday': 'دیروز',
  'designFiles.modifiedPrevious7Days': '۷ روز گذشته',
  'designFiles.modifiedPrevious30Days': '۳۰ روز گذشته',
  'designFiles.modifiedOlder': 'قدیمی‌تر',
  'designFiles.showMore': '+{n} بیشتر',
  'designFiles.kindHtml': 'صفحه HTML',
  'designFiles.kindImage': 'تصویر',
  'designFiles.kindSketch': 'طرح',
  'designFiles.kindText': 'متن',
  'designFiles.kindCode': 'اسکریپت',
  'designFiles.kindPdf': 'PDF',
  'designFiles.kindDocument': 'سند',
  'designFiles.kindPresentation': 'ارائه',
  'designFiles.kindSpreadsheet': 'صفحه گسترده',
  'designFiles.kindLiveArtifact': 'مصنوع زنده',
  'designFiles.kindBinary': 'باینری',
  'designFiles.kindFolder': 'پوشه',
  'designFiles.folderCount': '{n} فایل',
  'designFiles.newFolderTitle': 'پوشه جدید',
  'designFiles.newFolderLabel': 'نام پوشه',
  'designFiles.moveTitle': 'انتقال به پوشه',
  'designFiles.moveLabel': 'پوشه مقصد',
  'designFiles.moveRoot': 'ریشه پروژه',
  'designFiles.moveNewFolder': 'پوشه جدید…',
  'designFiles.move': 'انتقال',
  'designFiles.copyPath': 'کپی مسیر',
  'designFiles.copiedPath': 'مسیر کپی شد',
  'designFiles.copyLocalPath': 'کپی مسیر فایل محلی',
  'designFiles.copiedLocalPath': 'مسیر فایل محلی کپی شد',
  'designFiles.deleteFolderConfirm': 'پوشه «{name}» و تمام محتوای آن حذف شود؟',
  'designFiles.folderCreated': 'پوشه «{name}» ایجاد شد',
  'designFiles.folderDeleted': 'پوشه «{name}» حذف شد',
  'designFiles.filesMoved': '{n} مورد به {dest} منتقل شد',
  'designFiles.colName': 'نام',
  'designFiles.colKind': 'نوع',
  'designFiles.colModified': 'تغییر یافته',
  'designFiles.perPage': 'نمایش',
  'designFiles.all': 'همه',
  'designFiles.prev': 'قبلی',
  'designFiles.next': 'بعدی',
  'designFiles.jumpToPage': 'برو به صفحه',
  'designFiles.pageInfo': '{start}–{end} از {total}',
  'designFiles.sectionFolders': 'پوشه‌ها',
  'designFiles.sectionStylesheets': 'شیوه‌نامه‌ها',
  'designFiles.sectionDocuments': 'اسناد',
  'designFiles.kindStylesheet': 'شیوه‌نامه',
  'designFiles.modifiedExt': 'اصلاح‌شده {time} · {size} · {ext}',
  'designFiles.usefulInfoLabel': 'اطلاعات مفید',
  'designFiles.usefulInfoTip': 'برای باز کردن هر فایل در یک زبانه کامل، روی آن دوبار کلیک کنید.',
  'designFiles.usefulInfoTip2': 'در گفتگو @ را تایپ کنید تا یک فایل را به‌عنوان زمینه ارجاع دهید.',
  'designFiles.usefulInfoTip4': 'یک دیزاین‌سیستم انتخاب کنید تا نتیجه با سبک برندتان هماهنگ باشد.',
  'designFiles.usefulInfoTip5': 'ایده‌ای ندارید؟ قالب‌های افزونه در بخش انجمن صفحهٔ اصلی را امتحان کنید.',
  'designFiles.usefulInfoTip6': 'سؤال یا پیشنهادی دارید؟ به Discord ما بپیوندید.',
  'designFiles.usefulInfoTip7': 'از Open Design راضی هستید؟ در GitHub به ما ستاره بدهید.',
  'designFiles.usefulInfoTip8': 'برای آخرین خبرها @OpenDesignHQ را در X دنبال کنید.',
  'designFiles.usefulInfoTip9': 'تصاویر، اسناد یا حتی کل پوشه‌ها را به این پنل بکشید — عامل از آن‌ها به عنوان زمینه استفاده می‌کند.',
  'designFiles.usefulInfoTip10': 'روی «طرح جدید» کلیک کنید و یک چیدمان بکشید تا عامل بر اساس آن بسازد.',
  'designFiles.usefulInfoTip11': 'هر عنصری را در پیش‌نمایش انتخاب و نظر بدهید — عامل همان بخش را اصلاح می‌کند.',
  'designFiles.usefulInfoTip12': 'از نتیجه راضی نیستید؟ علامت‌گذاری روی پیش‌نمایش سریع‌تر از توضیح دوباره است.',
  'designFiles.usefulInfoTip13': 'هر طرح را با یک کلیک به PDF، تصویر یا HTML مستقل خروجی بگیرید.',
  'designFiles.usefulInfoTip14': 'از پروژه‌ای راضی هستید؟ آن را از منوی اشتراک‌گذاری به‌عنوان قالب ذخیره کنید.',
  'designFiles.usefulInfoTip15': 'پس از استقرار، بلافاصله کارت‌های اشتراک شبکه‌های اجتماعی بسازید.',
  'designFiles.usefulInfoTip16': 'برای دیدن پشت‌صحنه‌ها، @opendesign.ai را در Threads دنبال کنید.',
  'designFiles.usefulInfoTip17': 'برای الهام در طراحی، @opendesign.ai را در Instagram دنبال کنید.',
  'designFiles.usefulInfoTip18': 'برای آموزش‌ها و دموها، Open Design را در YouTube دنبال کنید.',
  'designFiles.usefulInfoTip19': 'برای اخبار محصول، Open Design را در LinkedIn دنبال کنید.',
  'designFiles.usefulInfoTip20': 'برای نکته‌ها و الهام، Open Design را در Xiaohongshu دنبال کنید.',
  'quickSwitcher.placeholder': 'باز کردن فایل…',
  'quickSwitcher.empty': 'هیچ فایلی در این پروژه نیست',
  'quickSwitcher.noMatches': 'بدون نتیجه',
  'quickSwitcher.navigate': 'حرکت',
  'quickSwitcher.open': 'باز کردن',
  'quickSwitcher.close': 'بستن',
  'pasteDialog.title': 'چسباندن متن',
  'pasteDialog.hint': 'در پوشه پروژه ذخیره می‌شود. هر نامی انتخاب کنید.',
  'pasteDialog.fileNameLabel': 'نام فایل',
  'pasteDialog.namePlaceholder': 'notes.txt',
  'pasteDialog.contentLabel': 'محتوا',
  'pasteDialog.contentPlaceholder': 'هر چیزی را بچسبانید…',
  'pasteDialog.save': 'ذخیره',
  'pasteDialog.cancel': 'لغو',
  'sketch.save': 'ذخیره طرح',
  'sketch.cancel': 'لغو',
  'sketch.saving': 'در حال ذخیره…',
  'sketch.saved': 'ذخیره شد',
  'sketch.tooltipMainMenu': 'منوی اصلی: ذخیره، خروجی، راهنما و تنظیمات بوم',
  'sketch.tooltipLock': "Keep the current drawing tool active for repeated use",
  'sketch.tooltipHand': "Pan the canvas without selecting objects",
  'sketch.tooltipSelection': "Select, move, resize, or edit objects on the canvas",
  'sketch.tooltipRectangle': "Draw a rectangle or card area",
  'sketch.tooltipDiamond': "Draw a diamond for decisions or branching structure",
  'sketch.tooltipEllipse': "Draw a circle or ellipse",
  'sketch.tooltipArrow': "Draw a directional connector or flow arrow",
  'sketch.tooltipLine': "Draw a straight divider or connector line",
  'sketch.tooltipFreedraw': "Draw freehand lines on the canvas",
  'sketch.tooltipText': "Add editable text to the canvas",
  'sketch.tooltipImage': "Insert an image into the canvas",
  'sketch.tooltipEraser': "Erase objects from the canvas",
  'sketch.tooltipFrame': "Create a frame to group a region of the canvas",
  'sketch.tooltipEmbeddable': "Web Embed only supports valid https:// or http:// links",
  'sketch.tooltipLaser': "Point at canvas content temporarily without changing it",
  'sketch.tooltipMoreTools': "Open additional tools such as frame, web embed, and laser pointer",
  'sketch.tooltipDirty': 'تغییرات ذخیره نشده',
  'sketch.tooltipClean': 'ذخیره شد',
  'fileViewer.empty': 'یک فایل را برای مشاهده انتخاب کنید.',
  'fileViewer.loading': 'در حال بارگذاری…',
  'fileViewer.exportPptx': 'صادرکردن به PPTX',
  'fileViewer.openInNewTab': 'باز کردن در تب جدید',
  'fileViewer.copyPath': 'کپی مسیر',
  'fileViewer.copied': 'کپی شد!',
  'fileViewer.share': 'اشتراک‌گذاری',
  'fileViewer.binaryMeta': 'باینری · {size}',
  'fileViewer.binaryNote': 'فایل باینری ({size} بایت). برای بررسی دانلود یا از دیسک باز کنید.',
  'fileViewer.pdfMeta': 'PDF · {size}',
  'fileViewer.documentMeta': 'سند',
  'fileViewer.presentationMeta': 'ارائه',
  'fileViewer.spreadsheetMeta': 'صفحه گسترده',
  'fileViewer.previewUnavailable': 'پیش‌نمایش در دسترس نیست. برای بررسی فایل را دانلود یا باز کنید.',
  'fileViewer.download': 'دانلود',
  'fileViewer.open': 'باز کردن',
  'fileViewer.imageMeta': 'تصویر · {size}',
  'fileViewer.reactMeta': 'مؤلفه React · {size}',
  'fileViewer.sketchMeta': 'طرح · {size}',
  'fileViewer.markdownStreamingMeta': 'پیش‌نمایش در حال استریم…',
  'fileViewer.markdownErrorMeta': 'پیش‌نمایش ممکن است ناقص باشد (خطای تولید).',
  'fileViewer.markdownStreamingStatus': 'در حال استریم… Markdown ناقص نمایش داده می‌شود.',
  'fileViewer.markdownErrorStatus': 'خطای تولید. آخرین محتوای در دسترس نمایش داده می‌شود.',
  'fileViewer.markdownSaving': "Saving...",
  'fileViewer.markdownSaveFailed': "Save failed",
  'fileViewer.markdownSaved': "Saved",
  'fileViewer.markdownAutoSaved': "Auto-saved · {time}",
  'fileViewer.markdownAutoSaveHint': "Auto-save on",
  'fileViewer.markdownViewMode': "Markdown view mode",
  'fileViewer.split': "Split",
  'fileViewer.markdownEditor': "Markdown editor",
  'fileViewer.markdownEditorPlaceholder': "Type notes, requirements, or instructions for this document...",
  'fileViewer.markdownPreview': "Markdown preview",
  'fileViewer.videoMeta': 'ویدئو · {size}',
  'fileViewer.audioMeta': 'صدا · {size}',
  'fileViewer.reload': 'بارگذاری مجدد',
  'fileViewer.reloadDisk': 'بارگذاری مجدد از دیسک',
  'fileViewer.copy': 'کپی',
  'fileViewer.copyTitle': 'کپی محتوای فایل',
  'fileViewer.saveDisabled': 'ذخیره (نمایشگر فقط خواندنی)',
  'fileViewer.save': 'ذخیره',
  'fileViewer.preview': 'پیش‌نمایش',
  'fileViewer.source': 'منبع',
  'fileViewer.tweaks': 'تنظیمات جزئی',
  'fileViewer.tweaksUnavailable': 'پنل تنظیمات در این مصنوع وجود ندارد',
  'fileViewer.jsxModuleTitle': 'پیش‌نمایش مستقلی وجود ندارد',
  'fileViewer.jsxModuleBody': 'این فایل یک ماژول کامپوننت است که توسط صفحه‌ای دیگر بارگذاری می‌شود.',
  'fileViewer.jsxModuleCta': 'صفحه‌ای را که آن را نمایش می‌دهد باز کنید:',
  'fileViewer.comment': 'نظر',
  'fileViewer.edit': 'ویرایش',
  'fileViewer.draw': 'رسم',
  'fileViewer.mark': 'علامت‌گذاری',
  'fileViewer.markTool': 'ابزار علامت‌گذاری',
  'fileViewer.boxSelect': 'انتخاب کادری',
  'fileViewer.textTool': 'متن',
  'fileViewer.textAnnotationRemove': 'حذف متن',
  'fileViewer.screenshot': 'اسکرین‌شات',
  'fileViewer.versions.entry': 'نسخه‌ها',
  'fileViewer.versions.title': 'نسخه‌ها',
  'fileViewer.versions.countOne': '۱ نسخه',
  'fileViewer.versions.countMany': '{count} نسخه',
  'fileViewer.versions.current': 'فعلی',
  'fileViewer.versions.sourceAi': 'AI edit',
  'fileViewer.versions.sourceManual': 'Manual edit',
  'fileViewer.versions.sourceRestore': 'Restored',
  'fileViewer.versions.restoredFrom': 'Restored from v{version}',
  'fileViewer.versions.versionLabel': 'نسخه {version}',
  'fileViewer.versions.listAria': 'نسخه‌های فایل',
  'fileViewer.versions.loading': 'در حال بارگذاری نسخه‌ها...',
  'fileViewer.versions.empty': 'هنوز نسخه‌ای وجود ندارد.',
  'fileViewer.versions.loadFailed': 'بارگذاری نسخه‌ها ممکن نشد.',
  'fileViewer.versions.previewFailed': 'پیش‌نمایش این نسخه بارگذاری نشد.',
  'fileViewer.versions.previewLoading': 'در حال بارگذاری پیش‌نمایش نسخه...',
  'fileViewer.versions.noPrompt': 'پرامپتی ثبت نشده است',
  'fileViewer.versions.noPromptBody': 'برای این نسخه پرامپتی ثبت نشده است.',
  'fileViewer.versions.promptTitle': 'پرامپت',
  'fileViewer.versions.copyPrompt': 'کپی پرامپت',
  'fileViewer.versions.fullscreen': 'پیش‌نمایش تمام‌صفحه',
  'fileViewer.versions.open': 'باز کردن پیش‌نمایش',
  'fileViewer.versions.currentHelp': 'این نسخه هم‌اکنون نسخه فعلی است.',
  'fileViewer.versions.restoreHelp': 'با تغییر، این HTML به عنوان نسخه فعلی جدید بازیابی می‌شود.',
  'fileViewer.versions.restore': 'تغییر به این نسخه',
  'fileViewer.versions.restoreConfirmTitle': 'به این نسخه تغییر می‌دهید؟',
  'fileViewer.versions.restoreConfirmCta': 'تغییر',
  'fileViewer.versions.restoring': 'در حال تغییر...',
  'fileViewer.versions.restoreFailed': 'تغییر به این نسخه ممکن نشد.',
  'fileViewer.versions.restoreSuccess': 'به این نسخه تغییر یافت.',
  'manualEdit.layers': 'لایه‌ها',
  'manualEdit.editableCount': '{count} قابل ویرایش',
  'manualEdit.hiddenBadge': 'پنهان',
  'manualEdit.title': 'ویرایشگر دستی',
  'manualEdit.fallbackTitle': 'ویرایش',
  'manualEdit.movePanel': 'جابه‌جایی پنل ویرایش',
  'manualEdit.editParams': 'ویرایش پارامترها',
  'manualEdit.closePanel': 'بستن پنل ویرایش',
  'manualEdit.selectLayer': 'یک لایه انتخاب کنید',
  'manualEdit.empty': 'روی یک عنصر در پیش‌نمایش کلیک کنید یا یک لایه انتخاب کنید.',
  'manualEdit.noEditableLayers': 'هیچ لایه قابل ویرایشی یافت نشد.',
  'manualEdit.noClass': 'بدون کلاس',
  'manualEdit.tabsAria': 'زبانه‌های ویرایش دستی',
  'manualEdit.tabContent': 'محتوا',
  'manualEdit.tabStyle': 'سبک',
  'manualEdit.tabAttributes': 'ویژگی‌ها',
  'manualEdit.tabHtml': 'Html',
  'manualEdit.tabSource': 'منبع',
  'manualEdit.attributesJson': 'JSON ویژگی‌ها',
  'manualEdit.selectedHtml': 'HTML عنصر انتخاب‌شده',
  'manualEdit.fullSource': 'منبع کامل artifact',
  'manualEdit.applyContent': 'اعمال محتوا',
  'manualEdit.applyStyle': 'اعمال سبک',
  'manualEdit.applyAttributes': 'اعمال ویژگی‌ها',
  'manualEdit.applyHtml': 'اعمال HTML',
  'manualEdit.applySource': 'اعمال منبع',
  'manualEdit.invalidAttributes': 'JSON ویژگی‌ها نامعتبر است.',
  'manualEdit.changes': 'تغییرات',
  'manualEdit.undo': 'واگرد',
  'manualEdit.redo': 'ازنو',
  'manualEdit.noChanges': 'هنوز هیچ ویرایش دستی‌ای انجام نشده است.',
  'manualEdit.imageUrl': 'URL تصویر',
  'manualEdit.altText': 'متن جایگزین',
  'manualEdit.label': 'برچسب',
  'manualEdit.text': 'متن',
  'manualEdit.href': 'Href',
  'manualEdit.textColor': 'رنگ متن',
  'manualEdit.background': 'پس‌زمینه',
  'manualEdit.fontSize': 'اندازه فونت',
  'manualEdit.weight': 'ضخامت',
  'manualEdit.align': 'تراز',
  'manualEdit.padding': 'فاصله داخلی',
  'manualEdit.margin': 'حاشیه',
  'manualEdit.radius': 'شعاع',
  'manualEdit.border': 'مرز',
  'manualEdit.width': 'عرض',
  'manualEdit.minHeight': 'حداقل ارتفاع',
  'manualEdit.deleteElement': 'حذف عنصر',
  'manualEdit.deleteElementConfirm': 'عنصر انتخاب‌شده حذف شود؟ این کار را می‌توان با واگرد لغو کرد.',
  'manualEdit.uploadImage': 'بارگذاری تصویر',
  'manualEdit.uploadingImage': 'در حال بارگذاری تصویر…',
  'manualEdit.uploadImageFailed': 'بارگذاری تصویر ممکن نشد.',
  'manualEdit.focusSlides': 'تمرکز روی اسلایدها',
  'manualEdit.showPanels': 'نمایش پنل‌ها',
  'fileViewer.zoomOut': 'کوچک‌نمایی',
  'fileViewer.zoomIn': 'بزرگ‌نمایی',
  'fileViewer.resetZoom': 'بازنشانی زوم',
  'fileViewer.viewportAria': 'درگاه دید پیش‌نمایش',
  'fileViewer.viewportDesktop': 'دسکتاپ',
  'fileViewer.viewportDesktopTitle': 'پیش‌نمایش دسکتاپ تمام‌عرض',
  'fileViewer.viewportTablet': 'تبلت',
  'fileViewer.viewportTabletTitle': 'پیش‌نمایش تبلت در ۸۲۰ × ۱۱۸۰ (مبنای پرتره مدرن)',
  'fileViewer.viewportMobile': 'موبایل',
  'fileViewer.viewportMobileTitle': 'پیش‌نمایش موبایل در ۳۹۰ × ۸۴۴',
  'fileViewer.reloadAria': 'بارگذاری مجدد',
  'fileViewer.previousSlide': 'اسلاید قبلی',
  'fileViewer.nextSlide': 'اسلاید بعدی',
  'fileViewer.slideNavAria': 'پیمایش اسلاید',
  'fileViewer.speakerNotes': 'یادداشت‌های سخنران',
  'fileViewer.speakerNotesSlide': 'اسلاید {current} / {total}',
  'fileViewer.speakerNotesEmpty': 'برای این اسلاید یادداشت سخنرانی وجود ندارد.',
  'fileViewer.speakerNotesEdit': 'ویرایش',
  'fileViewer.speakerNotesSave': 'ذخیره یادداشت‌ها',
  'fileViewer.speakerNotesSaving': 'در حال ذخیره…',
  'fileViewer.speakerNotesSaved': 'ذخیره شد',
  'fileViewer.speakerNotesSaveFailed': 'ذخیره یادداشت‌های سخنران ممکن نشد.',
  'fileViewer.speakerNotesPlaceholder': 'برای این اسلاید یادداشت سخنران اضافه کنید…',
  'fileViewer.presenterReset': 'بازنشانی',
  'fileViewer.present': 'ارائه',
  'fileViewer.presentInTab': 'در این تب',
  'fileViewer.presentFullscreen': 'تمام صفحه',
  'fileViewer.presentNewTab': 'تب جدید',
  'fileViewer.exitPresentation': 'خروج از ارائه',
  'fileViewer.shareLabel': 'اشتراک‌گذاری',
  'fileViewer.shareMenuShareLink': 'اشتراک‌گذاری',
  'fileViewer.shareMenuPublishOnline': 'انتشار آنلاین',
  'fileViewer.shareMenuDownload': 'دانلود',
  'fileViewer.shareMenuPresentation': 'ارائه',
  'fileViewer.shareMenuSourceFiles': 'فایل‌های منبع',
  'fileViewer.shareMenuSave': 'ذخیره',
  'fileViewer.copyShareLink': 'کپی لینک اشتراک‌گذاری',
  'fileViewer.openSharePage': 'باز کردن صفحه اشتراک‌گذاری',
  'fileViewer.shareLinkRequiresDeploy': 'ابتدا آنلاین منتشر کنید تا لینک دریافت شود',
  'fileViewer.shareLinkPublishGuide': 'برای فعال شدن اشتراک‌گذاری، بالا آنلاین منتشر کنید ↑',
  'fileViewer.shareAfterGenerationComplete': 'پس از پایان تولید قابل اشتراک‌گذاری است',
  'fileViewer.copyProviderLink': 'کپی لینک {provider}',
  'fileViewer.copyCloudflareLink': 'کپی لینک Cloudflare',
  'fileViewer.screenshotCopying': 'در حال کپی اسکرین‌شات...',
  'fileViewer.screenshotCopied': 'اسکرین‌شات در کلیپ‌بورد کپی شد',
  'fileViewer.screenshotClipboardDenied': 'مرورگر دسترسی به کلیپ‌بورد را مسدود کرد',
  'fileViewer.screenshotPreviewLoading': 'پیش‌نمایش هنوز در حال بارگذاری است. لحظه‌ای دیگر دوباره تلاش کنید.',
  'fileViewer.screenshotCaptureFailed': 'ثبت پیش‌نمایش ممکن نشد. لطفاً دوباره تلاش کنید.',
  'fileViewer.exportPdf': 'صادرکردن به PDF',
  'fileViewer.exportPdfAllSlides': 'صادرکردن به PDF (همه اسلایدها)',
  'fileViewer.exportPptxBusy': 'منتظر پایان نوبت فعلی باشید.',
  'fileViewer.exportPptxHint': 'یک درخواست به عامل برای تبدیل این طرح به PPTX ارسال کنید.',
  'fileViewer.exportPptxNa': 'صادرکردن PPTX اینجا در دسترس نیست.',
  'fileViewer.exportZip': 'دانلود به صورت .zip',
  'fileViewer.exportHtml': 'صادرکردن به HTML مستقل',
  'fileViewer.exportMd': 'صادرکردن به صورت Markdown',
  'fileViewer.exportImage': 'صادرکردن به صورت تصویر',
  'fileViewer.exportPptxImages': 'خروجی به‌صورت PPTX (تصاویر)',
  'fileViewer.exportPptxEditable': 'خروجی به‌صورت PPTX (قابل ویرایش)',
  'fileViewer.exportPptxEditableHint': 'Native editable shapes & text (not pixel-perfect)',
  'fileViewer.exportPptxModalSubtitle': "Choose how to export, then download.",
  'fileViewer.exportPptxScreenshot': "Screenshot PPTX",
  'fileViewer.exportPptxScreenshotHint': "One image per slide — pixel-perfect, but not editable.",
  'fileViewer.exportPptxConfirm': "Export",
  'fileViewer.exportPptxRecommended': "Recommended",
  'fileViewer.exportingProgress': 'در حال خروجی‌گرفتن…',
  'fileViewer.exportSlideProgress': 'در حال خروجی‌گرفتن اسلاید {current}/{total}…',
  'fileViewer.exportingElapsed': 'در حال خروجی‌گرفتن… {seconds}ثانیه',
  'fileViewer.exportSlideEta': 'اسلاید {current}/{total} · ~{seconds}ثانیه مانده',
  'fileViewer.exportFailed': 'خروجی‌گرفتن ناموفق بود. لطفاً دوباره تلاش کنید.',
  'fileViewer.exportDone': 'خروجی کامل شد',
  'fileViewer.exportImageFailed': 'گرفتن تصویر ناموفق بود. لطفاً دوباره تلاش کنید یا از ابزار اسکرین‌شات مرورگرتان استفاده کنید.',
  'fileViewer.exportImageModalSubtitle': 'یک قالب انتخاب کنید، سپس پیش‌نمایش فعلی را به‌صورت تصویر دانلود کنید.',
  'fileViewer.exportImageFormatLabel': 'قالب',
  'fileViewer.exportImageSaving': 'در حال ذخیره تصویر…',
  'fileViewer.exportImageSaved': 'تصویر ذخیره شد',
  'fileViewer.exportImageDownloadStarted': 'دانلود شروع شد',
  'fileViewer.exportImageDownloadDetails': 'اگر پنجره «ذخیره به‌عنوان» ظاهر نشد، {filename} را در پوشه دانلودهای مرورگر بررسی کنید.',
  'fileViewer.exportJsx': 'صادرکردن به JSX',
  'fileViewer.exportReactHtml': 'صادرکردن پیش‌نمایش به HTML',
  'fileViewer.exportStarted': 'خروجی‌گیری آغاز شد',
  'fileViewer.saveAsTemplate': 'ذخیره به عنوان قالب…',
  'fileViewer.savingTemplate': 'در حال ذخیره قالب…',
  'fileViewer.savedTemplate': 'به عنوان «{name}» ذخیره شد',
  'fileViewer.savedTemplateFail': 'ذخیره قالب ناموفق بود — دوباره امتحان کنید.',
  'fileViewer.templateNamePrompt': 'نام قالب',
  'fileViewer.templateNameDefault': 'قالب بدون عنوان',
  'fileViewer.templateDescPrompt': 'توضیح کوتاه (اختیاری — چه چیزی این قالب را مفید می‌کند؟)',
  'liveArtifact.refresh.button': 'بازخوانی',
  'liveArtifact.refresh.buttonTitle': 'این مصنوع زنده را بازخوانی کن',
  'liveArtifact.refresh.loadingTitle': 'در حال بارگذاری مصنوع زنده…',
  'liveArtifact.refresh.noSourceTitle': 'هنوز هیچ منبع بازخوانی فقط‌خواندنیِ تأییدشده‌ای موجود نیست.',
  'liveArtifact.refresh.running': 'در حال بازخوانی…',
  'liveArtifact.refresh.runningMessage': 'در حال بازخوانی داده‌ها و پیش‌نمایش. این کار ممکن است کمی طول بکشد.',
  'liveArtifact.refresh.runningAction': 'پیش‌نمایش قبلی تا موفق شدن بازخوانی قابل مشاهده می‌ماند.',
  'liveArtifact.refresh.successOne': 'بازخوانی کامل شد. داده‌ها به‌روزرسانی شدند.',
  'liveArtifact.refresh.successMany': 'بازخوانی کامل شد. داده‌ها به‌روزرسانی شدند.',
  'liveArtifact.refresh.successAction': 'پیش‌نمایش با جدیدترین داده‌های ثبت‌شده دوباره بارگذاری شد.',
  'liveArtifact.refresh.previousFailure': 'بازخوانی قبلی ناموفق بود: {message}',
  'liveArtifact.refresh.failureAction': 'تاریخچه بازخوانی را بررسی کنید، مشکل منبع یا مجوز را رفع کنید، سپس دوباره تلاش کنید.',
  'liveArtifact.refresh.networkFailure': 'درخواست بازخوانی ناموفق بود. اتصال خود را بررسی کنید و دوباره تلاش کنید.',
  'liveArtifact.refresh.genericFailure': 'بازخوانی ناموفق بود.',
  'liveArtifact.refresh.statusNever': 'قابل بازخوانی نیست',
  'liveArtifact.refresh.statusReady': 'آماده بازخوانی',
  'liveArtifact.refresh.statusSucceeded': 'به‌روز است',
  'liveArtifact.refresh.statusFailed': 'بازخوانی ناموفق بود',
  'liveArtifact.refresh.statusRunning': 'در حال بازخوانی',
  'liveArtifact.refresh.statusRunningDescription': 'یک اجرای بازخوانی هم‌اکنون در حال انجام است.',
  'liveArtifact.refresh.statusSucceededDescription': 'آخرین بازخوانی با موفقیت به پایان رسید.',
  'liveArtifact.refresh.statusFailedDescription': 'آخرین تلاش بازخوانی با موفقیت کامل نشد.',
  'liveArtifact.refresh.statusReadyDescription': 'منابع قابل بازخوانی پیکربندی شده‌اند اما هیچ اجرایی در حال انجام نیست.',
  'liveArtifact.refresh.statusNeverDescription': 'این artifact زنده هنوز منبع بازخوانی ندارد.',
  'liveArtifact.refresh.eventStarted': 'آغاز شد',
  'liveArtifact.refresh.eventSucceeded': 'موفق',
  'liveArtifact.refresh.eventFailed': 'ناموفق',
  'liveArtifact.refresh.eventStartedDetail': 'بازنشانی آغاز شد…',
  'liveArtifact.refresh.sourcesUpdatedOne': '{n} منبع به‌روزرسانی شد',
  'liveArtifact.refresh.sourcesUpdatedMany': '{n} منبع به‌روزرسانی شد',
  'liveArtifact.refresh.timelineEmpty': 'هنوز هیچ فعالیت تازه‌سازی‌ای در این نشست وجود ندارد. تازه‌سازی را اجرا کنید تا یک خط زمانی ثبت شود، یا منتظر اجراهای خودکار بمانید.',
  'liveArtifact.refresh.heroLastRefreshedLabel': 'آخرین تازه‌سازی',
  'liveArtifact.refresh.heroLastRefreshedNever': 'هرگز',
  'liveArtifact.refresh.justNow': 'همین حالا',
  'liveArtifact.refresh.factCreated': 'ایجاد شد',
  'liveArtifact.refresh.factLastUpdated': 'آخرین به‌روزرسانی',
  'liveArtifact.refresh.factUnknown': 'نامشخص',
  'liveArtifact.refresh.persistedTitle': 'تاریخچه تازه‌سازی ذخیره‌شده',
  'liveArtifact.refresh.persistedHint': 'ورودی‌های بارگذاری‌شده از refreshes.jsonl',
  'liveArtifact.refresh.persistedEmpty': 'هنوز تاریخچه تازه‌سازی ذخیره‌شده‌ای وجود ندارد.',
  'liveArtifact.refresh.persistedStatusSucceeded': 'موفق',
  'liveArtifact.refresh.persistedStatusRunning': 'در حال اجرا',
  'liveArtifact.refresh.persistedStatusFailed': 'ناموفق',
  'liveArtifact.refresh.persistedStatusCancelled': 'لغو شد',
  'liveArtifact.refresh.persistedStatusSkipped': 'رد شد',
  'liveArtifact.refresh.sessionTitle': 'فعالیت نشست',
  'liveArtifact.refresh.sessionHint': 'رویدادهای مشاهده‌شده هنگام باز بودن این برگه',
  'liveArtifact.refresh.docSourceTitle': 'منبع سند',
  'liveArtifact.refresh.docSourceHint': 'منبع پیکربندی شد',
  'liveArtifact.refresh.docSourceType': 'نوع',
  'liveArtifact.refresh.docSourceTool': 'ابزار',
  'liveArtifact.refresh.docSourceConnector': 'رابط اتصال',
  'liveArtifact.refresh.debugSummary': 'فراداده اشکال‌زدایی پیشرفته',
  'liveArtifact.refresh.debugNote': 'ممکن است شامل شناسه‌های رابط اتصال، نام فایل‌ها، فراداده منبع و مسیرهای داخلی آرتیفکت‌ها باشد.',
  'liveArtifact.viewer.tabPreview': 'پیش‌نمایش',
  'liveArtifact.viewer.tabCode': 'کد',
  'liveArtifact.viewer.tabData': 'داده‌ها',
  'liveArtifact.viewer.tabRefreshHistory': 'تاریخچهٔ تازه‌سازی',
  'liveArtifact.viewer.dataEmpty': 'کش data.json در دسترس نیست.',
  'liveArtifact.viewer.code.templateHeading': 'HTML قالب',
  'liveArtifact.viewer.code.renderedHeading': 'HTML رندرشده',
  'liveArtifact.viewer.code.templateHelp': 'قالب قابل ویرایشی که با data.json برای تولید پیش‌نمایش استفاده می‌شود.',
  'liveArtifact.viewer.code.renderedHelp': 'index.html تولیدشده‌ای که اکنون توسط پیش‌نمایش بارگذاری شده است.',
  'liveArtifact.viewer.code.variantAria': 'گونهٔ کد',
  'liveArtifact.viewer.code.variantTemplate': 'قالب',
  'liveArtifact.viewer.code.variantRendered': 'رندرشده',
  'liveArtifact.viewer.code.loading': 'در حال بارگذاری کد…',
  'liveArtifact.viewer.code.unavailable': 'کد هنوز در دسترس نیست.',
  'liveArtifact.viewer.code.empty': 'این فایل کد خالی است.',
  'fileViewer.deployToVercel': 'استقرار روی Vercel',
  'fileViewer.redeployToVercel': 'استقرار دوباره',
  'fileViewer.deployingToVercel': 'در حال استقرار روی Vercel…',
  'fileViewer.deployProviderLabel': 'ارائه‌دهنده استقرار',
  'fileViewer.vercelProvider': 'Vercel',
  'fileViewer.cloudflarePagesProvider': 'Cloudflare Pages',
  'fileViewer.deployToProvider': 'استقرار روی {provider}',
  'fileViewer.redeployToProvider': 'استقرار دوباره روی {provider}',
  'fileViewer.deployingToProvider': 'در حال استقرار روی {provider}…',
  'fileViewer.preparingPublicLink': 'در حال آماده‌سازی لینک عمومی…',
  'fileViewer.copyDeployLink': 'کپی لینک',
  'fileViewer.deployModalTitle': 'استقرار',
  'fileViewer.deployModalSubtitle': 'از حساب ارائه‌دهنده انتخاب‌شده برای استقرار این پیش‌نمایش HTML استفاده کنید.',
  'fileViewer.vercelToken': 'توکن Vercel',
  'fileViewer.vercelTokenGetLink': 'دریافت توکن Vercel',
  'fileViewer.vercelTokenPlaceholder': 'توکن Vercel خود را وارد کنید',
  'fileViewer.vercelTokenReuseHint': 'از توکن ذخیره‌شده استفاده می‌شود. برای جایگزینی، توکن جدید وارد کنید.',
  'fileViewer.vercelTokenRequired': 'ابتدا یک توکن Vercel وارد و ذخیره کنید.',
  'fileViewer.cloudflareApiToken': 'توکن API کلادفلر',
  'fileViewer.cloudflareApiTokenGetLink': 'دریافت توکن API',
  'fileViewer.cloudflareApiTokenPlaceholder': 'توکن API کلادفلر خود را وارد کنید',
  'fileViewer.cloudflareApiTokenReuseHint': 'از توکن API کلادفلر ذخیره‌شده استفاده می‌شود. برای جایگزینی، توکن جدید وارد کنید.',
  'fileViewer.cloudflareApiTokenRequired': 'ابتدا یک توکن API کلادفلر وارد و ذخیره کنید.',
  'fileViewer.cloudflareApiTokenScopeHint': 'هنگام ساخت توکن API گزینه Pages Edit را انتخاب کنید؛ دامنه‌های سفارشی به Zone Read / DNS Edit نیاز دارند.',
  'fileViewer.vercelTeamId': 'شناسه تیم',
  'fileViewer.vercelTeamSlug': 'اسلاگ تیم',
  'fileViewer.cloudflareAccountId': 'شناسه حساب',
  'fileViewer.cloudflareAccountIdHint': 'شناسه حساب را در داشبورد Cloudflare پیدا کنید.',
  'fileViewer.cloudflareAccountIdRequired': 'ابتدا Cloudflare Account ID را وارد و ذخیره کنید.',
  'fileViewer.cloudflareZoneLabel': 'دامنه',
  'fileViewer.cloudflareZonePlaceholder': 'برای بارگذاری دامنه‌ها، تنظیمات Cloudflare را ذخیره کنید',
  'fileViewer.cloudflareZoneRequired': 'ابتدا یک دامنه Cloudflare انتخاب کنید.',
  'fileViewer.cloudflareZonesLoading': 'در حال بارگذاری دامنه‌های Cloudflare…',
  'fileViewer.cloudflareZonesRefresh': 'تازه‌سازی دامنه‌ها',
  'fileViewer.cloudflareZonesLoadFailed': 'بارگذاری دامنه‌های Cloudflare ممکن نشد.',
  'fileViewer.cloudflareZonesEmpty': 'هیچ دامنه کامل فعال Cloudflare برای این حساب یافت نشد.',
  'fileViewer.cloudflareDomainPrefixLabel': 'پیشوند زیردامنه',
  'fileViewer.cloudflareDomainPrefixPlaceholder': 'demo',
  'fileViewer.cloudflareDomainPrefixInvalid': 'فقط از یک برچسب DNS استفاده کنید: حروف کوچک، اعداد و خط تیره.',
  'fileViewer.cloudflareHostnamePreview': 'پیش‌نمایش دامنه سفارشی: {hostname}',
  'fileViewer.cloudflareCustomDomainHint': 'اختیاری: یک دامنه سفارشی متصل کنید. خالی گذاشتن این فیلد همچنان یک لینک pages.dev می‌سازد.',
  'fileViewer.cloudflarePagesDevLinkLabel': 'نشانی pages.dev',
  'fileViewer.cloudflareCustomDomainLinkLabel': 'دامنه سفارشی',
  'fileViewer.optional': 'اختیاری',
  'fileViewer.vercelPreviewOnly': 'استقرارها فعلاً فقط Preview هستند.',
  'fileViewer.cloudflarePagesPreviewHint': 'Cloudflare Pages از Direct Upload استفاده می‌کند.',
  'fileViewer.savingConfig': 'در حال ذخیره…',
  'fileViewer.deployConfigSaveFailed': 'ذخیره تنظیمات Vercel ممکن نبود.',
  'fileViewer.deployFailed': 'استقرار ناموفق بود. تنظیمات Vercel را بررسی و دوباره تلاش کنید.',
  'fileViewer.deployProviderConfigSaveFailed': 'ذخیره تنظیمات {provider} ممکن نبود.',
  'fileViewer.deployProviderFailed': 'استقرار روی {provider} ناموفق بود. تنظیمات را بررسی و دوباره تلاش کنید.',
  'fileViewer.deployResultLabel': 'URL مستقرشده',
  'fileViewer.deployLinkReady': 'آماده',
  'fileViewer.deploySuccessToast': 'استقرار با موفقیت آپلود شد',
  'fileViewer.deploySuccessToastDetails': '{provider} · {url}',
  'fileViewer.deployLinkPreparingLabel': 'لینک عمومی در انتظار است',
  'fileViewer.deployLinkDelayed': 'سایت مستقر شده است. ارائه‌دهنده هنوز لینک عمومی را آماده می‌کند.',
  'fileViewer.deployLinkFailed': 'دامنه سفارشی ناموفق بود',
  'fileViewer.deployLinkProtectedLabel': 'محافظت استقرار فعال است',
  'fileViewer.deployLinkProtected': 'سایت مستقر شده، اما این لینک پیش‌نمایش نیاز به احراز هویت دارد. Deployment Protection را غیرفعال کنید یا از دامنه سفارشی استفاده کنید.',
  'fileViewer.retryLink': 'همین حالا دوباره تلاش کنید',
  'questionForm.submit': 'ارسال',
  'questionForm.skip': 'رد کردن',
  'questionForm.locked': 'پاسخ داده شده',
  'conv.switch': 'تغییر مکالمه',
  'conv.label': 'مکالمه',
  'conv.heading': 'مکالمات',
  'conv.new': '+ جدید',
  'conv.empty': 'هنوز هیچ مکالمه‌ای وجود ندارد.',
  'conv.untitled': 'مکالمه بدون عنوان',
  'conv.renameTooltip': 'برای تغییر نام دوبار کلیک کنید',
  'conv.delete': 'حذف مکالمه',
  'conv.deleteConfirm': 'آیا «{title}» حذف شود؟ این کار پیام‌های آن را حذف می‌کند.',
  'agentPicker.label': 'عامل',
  'agentPicker.modeChoose': 'انتخاب حالت اجرا',
  'agentPicker.localCli': 'CLI محلی',
  'agentPicker.daemonOff': 'daemon خاموش',
  'agentPicker.byok': 'API · BYOK',
  'agentPicker.selectAgent': 'انتخاب یک CLI عامل کد شناسایی شده',
  'agentPicker.noAgents': 'هیچ عاملی در PATH وجود ندارد',
  'agentPicker.notInstalled': 'نصب نشده',
  'agentPicker.rescan': 'اسکن مجدد PATH محلی برای عامل‌ها',
  'tool.openInTab': 'باز کردن {name} در یک تب',
  'tool.open': 'باز کردن',
  'tool.todos': 'وظایف',
  'tool.todosExpand': 'نمایش وظایف',
  'tool.todosCollapse': 'پنهان کردن وظایف',
  'tool.todosDone': 'انجام شد',
  'tool.todosDismiss': 'بستن فهرست وظایف',
  'tool.write': 'نوشتن',
  'tool.edit': 'ویرایش',
  'tool.read': 'خواندن',
  'tool.delete': 'حذف',
  'tool.bash': 'Bash',
  'tool.glob': 'Glob',
  'tool.grep': 'Grep',
  'tool.fetch': 'دریافت',
  'tool.search': 'جستجو',
  'tool.lines': '{n} خط',
  'tool.changeSingular': 'تغییر',
  'tool.changePlural': 'تغییرات',
  'tool.in': 'در {path}',
  'tool.hide': 'پنهان',
  'tool.output': 'خروجی',
  'tool.running': 'در حال اجرا…',
  'tool.error': 'خطا',
  'tool.done': 'انجام شد',
  'assistant.role': 'دستیار',
  'assistant.workingLabel': 'در حال کار',
  'assistant.doneLabel': 'انجام شد',
  'assistant.copyMarkdown': 'کپی Markdown پاسخ',
  'assistant.forkConversation': 'فورک از اینجا',
  'assistant.forkingConversation': 'در حال فورک…',
  'assistant.shareToOpenDesign': 'اشتراک‌گذاری در Open Design',
  'assistant.shareToOpenDesignBusy': 'در حال آماده‌سازی بسته…',
  'assistant.feedbackPrompt': 'بازخورد',
  'assistant.feedbackPositive': 'مفید',
  'assistant.feedbackNegative': 'غیرمفید',
  'assistant.feedbackReasonTitle': 'دلیلش را به ما بگویید',
  'assistant.feedbackReasonPositiveMatched': 'درخواست من را متوجه شد',
  'assistant.feedbackReasonPositiveVisual': 'خوب به نظر می‌رسد',
  'assistant.feedbackReasonPositiveUseful': 'ساختار کارآمد',
  'assistant.feedbackReasonPositiveEasy': 'ادامه ویرایش آسان است',
  'assistant.feedbackReasonPositiveDesignSystem': 'از سیستم طراحی پیروی کرد',
  'assistant.feedbackReasonNegativeMissed': 'درخواست من را نادیده گرفت',
  'assistant.feedbackReasonNegativeVisual': 'کیفیت بصری نیاز به بهبود دارد',
  'assistant.feedbackReasonNegativeIncomplete': 'خروجی ناقص',
  'assistant.feedbackReasonNegativeHard': 'استفاده از آن دشوار است',
  'assistant.feedbackReasonNegativeDesignSystem': 'از سیستم طراحی پیروی نکرد',
  'assistant.feedbackReasonOther': 'سایر موارد',
  'assistant.feedbackReasonPlaceholder': 'یک یادداشت کوتاه اضافه کنید...',
  'assistant.feedbackReasonSubmit': 'ارسال',
  'assistant.emptyResponseLabel': 'بدون خروجی',
  'assistant.emptyResponseMessage': 'ارائه‌دهنده درخواست را بدون بازگرداندن متن یا آرتیفکت پایان داد. مدل یا ارائه‌دهنده دیگری را امتحان کنید، سهمیه را بررسی کنید یا دوباره تلاش کنید.',
  'assistant.unfinishedLabel': 'با کار ناتمام متوقف شد',
  'assistant.unfinishedSummary': '{n} وظیفه باقی مانده',
  'assistant.unfinishedMore': '+{n} بیشتر',
  'assistant.continueRemaining': 'ادامه وظایف باقی مانده',
  'chat.resumeRunCta': 'ادامهٔ اجرا',
  'assistant.outTokens': '{n} خروجی',
  'assistant.producedFiles': 'فایل‌های این نوبت',
  'assistant.openFile': 'باز کردن',
  'assistant.downloadFile': 'دانلود',
  'nextStep.title': 'گام بعدی',
  'nextStep.more': 'بیشتر',
  'nextStep.share': 'اشتراک‌گذاری',
  'nextStep.download': 'دانلود',
  'nextStep.createDesignSystemTitle': 'Create design system',
  'nextStep.createDesignSystemBody': 'Duplicate this project into a design-system workspace and start an agent pass from all current files and references.',
  'nextStep.createDesignSystemBusy': 'Creating design system...',
  'nextStep.contribute': 'مشارکت',
  'nextStep.planGenerateTitle': "Generate from document",
  'nextStep.planGenerateBody': "Use the approved Markdown plan as the source of truth for the next design run.",
  'nextStep.planImproveTitle': "Improve document",
  'nextStep.planImproveBody': "Tighten the current plan document before generating the final artifact.",
  'nextStep.planGeneratePrompt': "Use `{file}` as the source of truth. Read the document first, preserve its decisions, then generate the final design artifact that matches it. If it is a slide outline, generate the deck; if it is a PRD/prototype plan, generate the prototype or wireframes; if it is a storyboard/creative brief, generate the matching visual/media artifact. Before generating, call out any blocking TODOs or contradictions you cannot resolve.",
  'nextStep.planImprovePrompt': "Read `{file}` and improve it in place as an editable plan document. Tighten scope, fill weak sections, add missing acceptance checks, and keep TODO/open questions where user input is still needed. Do not generate the final design artifact yet.",
  'nextStep.planImproveArtifactTitle': "Improve artifact",
  'nextStep.planImproveArtifactBody': "Keep iterating the generated artifact instead of going back to planning.",
  'nextStep.planImproveArtifactPrompt': "Improve `{artifact}` in place. Keep the existing working artifact and make the highest-impact product, visual, interaction, and content improvements. Preserve behavior that already works, then summarize changed files and any remaining risks.",
  'nextStep.planMergeTitle': "Align document and artifact",
  'nextStep.planMergeBody': "Reconcile the plan and generated artifact so they advance together.",
  'nextStep.planMergePrompt': "Read `{document}` and `{artifact}` together. Treat the document as the intent and the artifact as the current implementation. Reconcile them: update the artifact to match confirmed decisions, update the document only where it is stale, and keep explicit TODO/open questions for anything still unresolved. Preserve existing working behavior and summarize what changed in both files.",

  'nextStep.projectContinueTitle': 'Continue working',
  'nextStep.projectGenerateArtifactTitle': 'Generate artifact',
  'nextStep.designSystemAiRefineTitle': 'AI refine design system',
  'nextStep.designSystemAuditKitTitle': 'Audit tokens & kit',

  'nextStep.brandAiOptimizeTitle': 'Refine extracted design system',
  'nextStep.brandAiOptimizeBody': 'Starts an agent pass that consumes model tokens, re-extracts the source, and updates this design system in place.',
  'nextStep.brandCreateDesignTitle': 'Create with this design system',
  'nextStep.brandCreateDesignBody': 'Start a new design using the extracted colors, type, assets, and system guidance.',
  'nextStep.brandCreateDesignPrompt': 'Create a new design with the {designSystem} design system.',

  'nextStep.brandContinueExtractionTitle': 'Continue extraction',
  'nextStep.brandContinueExtractionBody': 'After the Browser tab is past any verification, read it and keep filling the saved kit.',
  'nextStep.brandContinueExtractionBusy': 'Continuing extraction...',
  'nextStep.brandContinueAiExtractionTitle': 'Continue with agent',
  'nextStep.brandContinueAiExtractionProgrammaticBody': 'Use the selected agent to extract from the saved draft if the programmatic pass still cannot finish.',
  'nextStep.brandContinueAiExtractionAiBody': 'Resume the selected agent from the current brand scaffold and finish the same design system.',
  'nextStep.brandContinueAiExtractionBusy': 'Continuing with agent...',
  'nextStep.createDesignBusy': 'در حال ایجاد طراحی...',
  'assistant.thinking': 'در حال فکر کردن',
  'assistant.thought': 'فکر کرد',
  'assistant.thoughtFor': 'تفکر برای {s} ثانیه',
  'assistant.systemReminder': 'یادآور سیستم',
  'assistant.possiblePromptInjection': 'احتمال تزریق دستور',
  'assistant.waitingFirstOutput': 'در انتظار اولین خروجی',
  'assistant.statusBootingAgent': 'راه‌اندازی عامل',
  'assistant.statusPreparing': 'در حال آماده‌سازی...',
  'assistant.statusStarting': 'در حال شروع',
  'assistant.statusRequesting': 'در حال ارسال درخواست',
  'assistant.statusThinking': 'در حال فکر کردن',
  'assistant.statusStreaming': 'در حال استریم',
  'assistant.slowHint': 'بیشتر از حد معمول طول می‌کشد. فرم معمولاً در ۵ تا ۱۰ ثانیه نمایش داده می‌شود — می‌توانید متوقف کنید و عبارت را تغییر دهید.',
  'assistant.verbEditing': 'در حال ویرایش',
  'assistant.verbWriting': 'در حال نوشتن',
  'assistant.verbReading': 'در حال خواندن',
  'assistant.verbSearching': 'در حال جستجو',
  'assistant.verbRunning': 'در حال اجرا',
  'assistant.verbTodos': 'وظایف',
  'assistant.verbFetching': 'در حال دریافت',
  'assistant.verbCalling': 'در حال فراخوانی',
  'qf.answered': 'پاسخ داده شده',
  'qf.choose': 'انتخاب کنید…',
  'qf.customLabel': 'Custom answer',
  'qf.customPlaceholder': 'Type your own answer...',
  'qf.required': 'الزامی',
  'qf.lockedSubmitted': 'پاسخ‌ها ارسال شدند — عامل از این‌ها برای بقیه جلسه استفاده می‌کند.',
  'qf.lockedPrev': 'این فرم از یک نوبت قبلی است.',
  'qf.hint': 'آنچه را که مناسب است انتخاب کنید. فیلدهای اختیاری که برایتان مهم نیست را رد کنید — عامل از پیش‌فرض‌های معقول استفاده خواهد کرد.',
  'qf.submitDefault': 'ارسال پاسخ‌ها',
  'qf.submitDisabledTitle': 'ابتدا فیلدهای الزامی را پر کنید',
  'qf.submitTitle': 'ارسال پاسخ‌ها',
  'qf.cardSelected': 'انتخاب شده',
  'qf.cardRefs': 'مراجع:',
  'qf.cardSampleText': 'روباه قهوه‌ای سریع · ۰۱۲۳',
  'questions.tabLabel': 'پرسش‌ها',
  'questions.banner': 'اشکالی ندارد چند پرسش کوتاه بپرسم؟',
  'questions.bannerAnswered': 'به پرسش‌ها پاسخ داده شد',
  'questions.continue': 'ادامه',
  'questions.generating': 'در حال تولید سؤالات…',
  'questions.skipAll': 'رد کردن همه',
  'questions.autoSkipHint': 'با پایان تایمر به‌طور خودکار ادامه می‌یابد',
  'questions.submitting': 'در حال ارسال…',
  'sketch.toolSelect': 'انتخاب (غیرفعال)',
  'sketch.toolPen': 'قلم',
  'sketch.toolText': 'متن',
  'sketch.toolRect': 'مستطیل',
  'sketch.toolArrow': 'فلش',
  'sketch.toolEraser': 'پاک‌کن',
  'sketch.color': 'رنگ',
  'sketch.strokeSize': 'اندازه خط',
  'sketch.undo': 'واگرد',
  'sketch.clear': 'پاک کردن',
  'sketch.close': 'بستن',
  'sketch.closeConfirm': 'طرح را ببندم و تغییرات ذخیره‌نشده را نادیده بگیرم؟',
  'sketch.textPrompt': 'متن:',
  'sketch.textModalTitle': 'افزودن متن',
  'critiqueTheater.userFacingName': 'هیئت داوران طراحی',
  'critiqueTheater.roleDesigner': 'طراح',
  'critiqueTheater.roleCritic': 'منتقد',
  'critiqueTheater.roleBrand': 'برند',
  'critiqueTheater.roleA11y': 'دسترس‌پذیری',
  'critiqueTheater.roleCopy': 'متن',
  'critiqueTheater.roundLabel': 'دور {n} از {m}',
  'critiqueTheater.mustFix': '{n} مورد ضروری برای رفع',
  'critiqueTheater.composite': 'ترکیبی',
  'critiqueTheater.threshold': 'آستانه',
  'critiqueTheater.consensus': 'اجماع',
  'critiqueTheater.interrupt': 'وقفه',
  'critiqueTheater.interrupting': 'در حال وقفه…',
  'critiqueTheater.interrupted': 'متوقف‌شده',
  'critiqueTheater.degradedHeading': 'پنل در این اجرا آفلاین است',
  'critiqueTheater.degradedReasonMalformed': 'خروجی پنل نامعتبر است (تجزیه‌کننده بلوک را رد کرد).',
  'critiqueTheater.degradedReasonOversize': 'خروجی پنل از بودجه امن بایت فراتر رفت.',
  'critiqueTheater.degradedReasonAdapter': 'آداپتور {adapter} از پروتکل Critique پشتیبانی نکرد.',
  'critiqueTheater.degradedReasonProtocol': 'آداپتور {adapter} نسخه‌ای از پروتکل را ارسال کرد که پشتیبانی نمی‌شود.',
  'critiqueTheater.degradedReasonMissingArtifact': 'اجرا بدون آرتیفکت نهایی به پایان رسید.',
  'critiqueTheater.replay': 'بازپخش',
  'critiqueTheater.replaySpeed': 'سرعت بازپخش',
  'critiqueTheater.readOnly': 'فقط‌خواندنی',
  'critiqueTheater.shippedSummary': 'در دور {round} منتشر شد · امتیاز ترکیبی {composite}',
  'critiqueTheater.interruptedSummary': 'در دور {round} متوقف شد · بهترین امتیاز ترکیبی {composite}',
  'critiqueTheater.shippedBadge': 'منتشرشده',
  'critiqueTheater.belowThresholdBadge': 'زیر آستانه',
  'critiqueTheater.timedOutBadge': 'زمان به پایان رسید',
  'critiqueTheater.failedHeading': 'اجرا ناموفق بود',
  'critiqueTheater.failedReasonCliExit': 'CLI ایجنت پیش از پایان کار پنل با کد غیرصفر خارج شد.',
  'critiqueTheater.failedReasonPerRoundTimeout': 'یک دور از بودجه زمانی خود فراتر رفت.',
  'critiqueTheater.failedReasonTotalTimeout': 'کل اجرا از بودجه زمانی کل خود فراتر رفت.',
  'critiqueTheater.failedReasonOrchestrator': 'خطای داخلی هماهنگ‌کننده.',
  'critiqueTheater.transcriptEmpty': 'هنوز رونوشتی برای بازپخش وجود ندارد. برای ثبت یکی، یک نقد اجرا کنید.',
  'critiqueTheater.transcriptLoading': 'در حال بارگذاری رونوشت…',
  'critiqueTheater.transcriptError': 'بارگذاری رونوشت ممکن نشد: {error}',
  'critiqueTheater.replaySpeedPaused': 'متوقف‌شده موقت',
  'critiqueTheater.replaySpeedInstant': 'آنی',
  'critiqueTheater.replaySpeedLive': 'زنده',
  'critiqueTheater.replaySpeedFast': 'سریع',
  'critiqueTheater.settingsNav': 'هیئت داوران طراحی',
  'critiqueTheater.settingsNavHint': 'بررسی طراحی پنج‌پنلی برای اجراهای شما',
  'critiqueTheater.settingsEnabledLabel': 'نمایش هیئت داوران طراحی در حین اجرای ایجنت',
  'critiqueTheater.settingsEnabledDescription': 'وقتی فعال باشد، یک بررسی پنج‌پنلی در کنار تولیدات ایجنت ظاهر می‌شود و پیش از انتشار به خروجی امتیاز می‌دهد. می‌توانید هر زمان آن را متوقف کنید.',
  'critiqueTheater.settingsEnabledProjectHint': 'برای این پروژه ذخیره شد. اجراهای جدید در این پروژه از سمت سرور از طریق هیئت داوران طراحی هدایت می‌شوند.',
  'critiqueTheater.settingsEnabledNoProjectHint': 'برای ماندگار کردن این تنظیم در سمت سرور، یک پروژه باز کنید. تا آن زمان، این فقط ترجیح درون‌مرورگر را تغییر می‌دهد.',
  'pet.title': 'حیوان خانگی',
  'pet.subtitle': 'یک همراه کوچک را به فرزندخواندگی بپذیرید که روی فضای کاری شما شناور می‌ماند.',
  'pet.navTitle': 'حیوان خانگی',
  'pet.navHint': 'فرزندخواندگی یا سفارشی‌سازی',
  'pet.tabBuiltIn': 'پیش‌فرض',
  'pet.tabBuiltInHint': 'همراهان منتخب همراه Open Design — یکی را انتخاب و فرزندخوانده کن.',
  'pet.builtInEmpty': 'حیوانات داخلی در حال حاضر در دسترس نیستند. وقتی دیمن دوباره فعال شد، تب جامعه را تازه کن.',
  'pet.tabCustom': 'سفارشی',
  'pet.tabCustomHint': 'نام، نشان، رنگ یا اسپرایت دلخواه خودت را تنظیم کن.',
  'pet.tabCommunity': 'انجمن',
  'pet.tabCommunityHint': 'حیوانات تولید‌شدهٔ Codex — یکی را پذیرش کن یا با هوش مصنوعی بساز.',
  'pet.tabsAria': 'منبع حیوان خانگی',
  'pet.adopt': 'فرزندخواندگی',
  'pet.adoptedBadge': 'فرزندخوانده',
  'pet.adoptCallout': 'یک حیوان خانگی بپذیرید',
  'pet.changePet': 'تغییر حیوان خانگی',
  'pet.wake': 'بیدار کردن',
  'pet.tuck': 'پنهان کردن',
  'pet.wakeTitle': 'بیدار کردن حیوان خانگی — نمایش لایه شناور.',
  'pet.tuckTitle': 'پنهان کردن حیوان خانگی — مخفی کردن لایه شناور.',
  'pet.settingsTitle': 'باز کردن تنظیمات حیوان خانگی',
  'pet.useCustom': 'استفاده از حیوان خانگی من',
  'pet.customTitle': 'خودتان بسازید',
  'pet.customHint': 'یک نام، نماد و رنگ تأکید انتخاب کنید — لایه به‌طور زنده به‌روزرسانی می‌شود.',
  'pet.customGreetingPlaceholder': 'سلامی از طرف حیوان خانگی شما…',
  'pet.fieldName': 'نام',
  'pet.fieldGlyph': 'نماد',
  'pet.fieldGlyphHint': 'یک ایموجی بهترین کارایی را دارد (مثلاً 🐝، 🦄، 🐢).',
  'pet.fieldGreeting': 'پیام خوش‌آمد',
  'pet.fieldAccent': 'رنگ تأکید',
  'pet.fieldAccentCustom': 'رنگ سفارشی',
  'pet.fieldAccentDefault': 'رنگ تأکید پیش‌فرض',
  'pet.overlayAria': 'همراه حیوان خانگی',
  'pet.spriteAria': '{name} — برای جابجایی بکشید، برای گفت‌وگو کلیک کنید',
  'pet.spriteTitle': 'سلام از طرف {name}! برای گفت‌وگو کلیک کنید.',
  'pet.taskSummarySingle': '{count} وظیفه ایجنت در حال اجراست.',
  'pet.taskSummaryMultiple': '{count} وظیفه ایجنت در {projects} پروژه در حال اجراست.',
  'pet.taskSummaryRecentSingle': '{count} وظیفه ایجنت اخیراً تکمیل شد.',
  'pet.taskSummaryRecentMultiple': '{count} وظیفه ایجنت اخیراً تکمیل شدند.',
  'pet.taskListAria': 'وظایف فعال ایجنت',
  'pet.taskOpenProject': 'باز کردن {project}',
  'pet.taskGroup.running': 'در حال اجرا',
  'pet.taskGroup.queued': 'در انتظار',
  'pet.taskGroup.recent': 'اخیراً تکمیل‌شده',
  'pet.idleQuote.leonardo.text': 'یادگیری هرگز ذهن را خسته نمی‌کند.',
  'pet.idleQuote.leonardo.author': 'Leonardo da Vinci',
  'pet.idleQuote.michelangelo.text': 'فرشته را در دل سنگ مرمر دیدم و تراشیدم تا آزادش کنم.',
  'pet.idleQuote.michelangelo.author': 'میکل‌آنژ',
  'pet.idleQuote.bernini.text': 'دو ابزار وجود دارد که می‌تواند به مجسمه‌ساز کمک کند: نور و سایه.',
  'pet.idleQuote.bernini.author': 'جان لورنتسو برنینی',
  'pet.idleQuote.raphael.text': 'هنگام نقاشی کردن، آدمی نمی‌اندیشد.',
  'pet.idleQuote.raphael.author': 'رافائل',
  'pet.idleQuote.caravaggio.text': 'هر اثری، فارغ از اینکه چه باشد یا چه کسی آن را کشیده باشد، چیزی جز خرت‌وپرت و سرگرمی‌های کودکانه نیست، مگر آنکه از روی زندگی واقعی ساخته و نقاشی شده باشد.',
  'pet.idleQuote.caravaggio.author': 'کاراواجو',
  'pet.idleQuote.rodin.text': 'مهم این است که برانگیخته شوی، عشق بورزی، امید داشته باشی، بلرزی و زندگی کنی.',
  'pet.idleQuote.rodin.author': 'اوگوست رودن',
  'pet.composerTitle': 'حیوانات خانگی — بیدار کردن، پنهان یا انتخاب',
  'pet.composerMenuTitle': 'حیوانات خانگی',
  'pet.composerMenuHint': 'نکته: /pet را تایپ کنید تا تغییر دهید',
  'pet.composerOpenSettings': 'مدیریت حیوانات خانگی',
  'pet.welcomeTeaserTitle': 'یک حیوان خانگی بپذیرید',
  'pet.welcomeTeaserBody': 'یک همراه کوچک که بالای فضای کاری شما شناور می‌شود.',
  'pet.welcomeTeaserCta': 'یکی انتخاب کنید',
  'pet.imageUpload': 'بارگذاری اسپرایت',
  'pet.imageReplace': 'جایگزینی اسپرایت',
  'pet.imageRemove': 'استفاده از ایموجی',
  'pet.imageHintIdle': 'PNG، JPG، WebP، GIF یا SVG. اسپرایت‌شیت؟ یک نوار افقی بارگذاری کنید و تعداد فریم را تنظیم کنید.',
  'pet.imageHintActive': 'اسپرایت شما نمایش داده می‌شود. فریم را > ۱ تنظیم کنید تا یک اسپرایت‌شیت افقی متحرک شود.',
  'pet.fieldFrames': 'فریم‌ها',
  'pet.fieldFramesHint': '۱ = ثابت. > ۱ = اسپرایت‌شیت افقی.',
  'pet.fieldFps': 'سرعت (fps)',
  'pet.fieldFpsHint': 'سرعت چرخش فریم‌ها.',
  'pet.atlasImport': 'وارد کردن اسپرایت Codex',
  'pet.atlasImportTitle': 'یک اطلس hatch-pet با ابعاد 8x9 / 192x208 (PNG یا WebP) وارد کنید.',
  'pet.atlasPickerTitle': 'یک ردیف انیمیشن انتخاب کنید',
  'pet.atlasPickerHint': 'پت‌های Codex با ۹ ردیف انیمیشن می‌آیند. به‌طور پیش‌فرض کل اطلس را نگه می‌داریم تا پت با هاور، جهت کشیدن و بیکاری طولانی ردیف عوض کند. می‌توانی به یک حلقهٔ ثابت هم محدودش کنی.',
  'pet.atlasCancel': 'حذف اطلس',
  'pet.atlasAdopt': 'قفل روی این ردیف',
  'pet.atlasAdoptFull': 'استفاده از کل اطلس (متحرک)',
  'pet.atlasAdoptFullTitle': 'همهٔ ردیف‌ها را نگه دار تا پت به هاور، جهت کشیدن و بیکاری طولانی واکنش بدهد.',
  'pet.atlasAdoptRowTitle': 'فقط ردیف برجسته‌شده را به نوار حلقه‌ای تک‌ردیفی تبدیل کن.',
  'pet.atlasActiveHint': 'اطلس متحرک فعال است — پت بر اساس تعامل تو (هاور، کشیدن، بیکاری) ردیف را عوض می‌کند.',
  'pet.atlasRow.idle': 'بی‌حرکت',
  'pet.atlasRow.running-right': 'دویدن به راست',
  'pet.atlasRow.running-left': 'دویدن به چپ',
  'pet.atlasRow.waving': 'تکان دادن دست',
  'pet.atlasRow.jumping': 'پرش',
  'pet.atlasRow.failed': 'شکست',
  'pet.atlasRow.waiting': 'انتظار',
  'pet.atlasRow.running': 'دویدن',
  'pet.atlasRow.review': 'بررسی',
  'pet.hatchTitle': 'یک پت جدید با هوش مصنوعی پرورش بده',
  'pet.hatchHint': 'از مهارت hatch-pet داخل چت برای ساخت اسپرایت‌شیت سبک Codex استفاده کنید و سپس اینجا وارد کنید.',
  'pet.hatchConcept': 'مفهوم پت (اختیاری)',
  'pet.hatchConceptPlaceholder': 'مثلاً: یک شیبا اینوی پیکسلی با ژاکتی نرم',
  'pet.hatchCopy': 'کپی پرامپت',
  'pet.hatchCopied': 'کپی شد!',
  'pet.hatchFoot': 'پس از اینکه مهارت پت شما را ذخیره کرد، اینجا برگردید و «وارد کردن اسپرایت Codex» را بزنید.',
  'pet.slashPopoverAria': 'دستورهای اسلش',
  'pet.slashPopoverTitle': 'دستورها',
  'pet.slashPopoverHint': '↑↓ پیمایش · enter انتخاب · esc بستن',
  'pet.slashPet': 'پت را روشن/خاموش کنید، انتخاب کنید یا تنظیمات را باز کنید.',
  'pet.slashPetWake': 'پت شناور را بیدار کنید.',
  'pet.slashPetTuck': 'پت را فعلاً جمع کنید.',
  'pet.slashHatch': 'با مهارت hatch-pet یک پت Codex بسازید.',
  'pet.slashHatchArg': '<مفهوم>',
  'pet.slashSearch': 'وب را با فرمان OD research جستجو کنید.',
  'pet.slashSearchArg': '<پرس‌وجو>',
  'pet.codexTitle': 'تازه‌متولدها',
  'pet.codexSubtitle': 'پت‌هایی که مهارت hatch-pet بسته‌بندی کرده اینجا ظاهر می‌شوند تا با یک کلیک پذیرفته شوند.',
  'pet.codexSubtitleWithDir': 'در حال اسکن {dir} برای بسته‌های hatch-pet.',
  'pet.codexEmpty': 'هنوز پتی متولد نشده. در چت /hatch بنویسید تا یکی بسازد.',
  'pet.codexLoading': 'در حال جستجوی پت‌های متولدشده…',
  'pet.codexRefresh': 'بازخوانی',
  'pet.codexAdopt': 'پذیرش',
  'pet.codexAdopting': 'در حال پذیرش…',
  'pet.communitySync': 'دانلود حیوانات اجتماعی',
  'pet.communitySyncing': 'در حال دانلود…',
  'pet.communitySyncTitle': 'همگام‌سازی جدیدترین حیوانات از Codex Pet Share + j20 Hatchery در ~/.codex/pets/.',
  'pet.communitySyncDone': '{wrote} حیوان جدید همگام شد (مجموع {total}).',
  'pet.communitySyncFailed': 'خطا در همگام‌سازی: {error}',
  'pet.codexBundled': 'همراه',
  'pet.codexBundledTitle': 'همراه Open Design ارائه می‌شود — نیازی به دانلود نیست.',
  'settings.notifications': 'اعلان‌ها',
  'settings.notificationsHint': 'صدا و اعلان دسکتاپ هنگام تکمیل وظیفه',
  'settings.notifyCompletionSound': 'صدای تکمیل',
  'settings.notifyCompletionSoundHint': 'پس از اتمام یک نوبت پخش می‌شود. به‌طور پیش‌فرض خاموش است.',
  'settings.notifySuccessSound': 'صدای موفقیت',
  'settings.notifyFailureSound': 'صدای خطا',
  'settings.notifyDesktop': 'اعلان دسکتاپ',
  'settings.notifyDesktopHint': 'هنگامی که پنجره فعال نیست ارسال می‌شود.',
  'settings.notifyDesktopBlocked': 'مرورگر اعلان‌ها را مسدود کرده است. در تنظیمات سایت آن‌ها را مجاز کنید.',
  'settings.notifyDesktopUnsupported': 'اعلان‌های دسکتاپ در این محیط در دسترس نیستند.',
  'settings.notifyTest': 'ارسال آزمایشی',
  'settings.notifyTestSent': 'اعلان آزمایشی ارسال شد. اگر بنری نمایش داده نشد، تنظیمات اعلان مرورگر و سیستم را بررسی کنید.',
  'settings.notifyTestFailed': 'فراخوانی اعلان ناموفق بود. تنظیمات اعلان مرورگر و سیستم را بررسی کنید.',
  'settings.notifySoundDing': 'دینگ',
  'settings.notifySoundChime': 'زنگ',
  'settings.notifySoundTwoToneUp': 'دو نوای بالارونده',
  'settings.notifySoundPluck': 'مضراب',
  'settings.notifySoundBuzz': 'وزوز',
  'settings.notifySoundTwoToneDown': 'دو نوای پایین‌رونده',
  'settings.notifySoundThud': 'تالاپ',
  'settings.skills': 'مهارت‌ها',
  'settings.skillsHint': 'مهارت‌های کاربردی که عامل می‌تواند در حین یک وظیفه فراخوانی کند',
  'settings.skillsNew': 'مهارت جدید',
  'settings.skillsEmpty': 'یک مهارت را از سمت چپ انتخاب کنید یا یکی بسازید.',
  'settings.skillsEdit': 'ویرایش',
  'settings.skillsDelete': 'حذف',
  'settings.skillsDeleteConfirm': 'تأیید حذف',
  'settings.skillsName': 'نام',
  'settings.skillsTriggers': 'محرک‌ها (با کاما یا خط جدید جدا شوند)',
  'settings.skillsDescription': 'توضیحات',
  'settings.skillsBody': 'متن SKILL.md',
  'settings.skillsCreate': 'ایجاد',
  'settings.skillsSave': 'ذخیره',
  'settings.skillsSaving': 'در حال ذخیره…',
  'settings.skillsOverrideCreate': 'ایجاد بازنویسی کاربر',
  'settings.skillsOverrideSave': 'ذخیره به‌عنوان بازنویسی کاربر',
  'settings.skillsBuiltInOverrideWarning': 'ویرایش این مهارت داخلی یک بازنویسی کاربر ایجاد می‌کند. مورد داخلی تا زمانی که بازنویسی را حذف کنید از فهرست پنهان می‌شود. ادامه می‌دهید؟',
  'settings.skillsFiles': 'فایل‌ها',
  'settings.skillsNoFiles': 'هیچ فایلی در این پوشه مهارت نیست.',
  'settings.skillsNameRequired': 'نام مهارت الزامی است.',
  'settings.skillsBodyRequired': 'محتوای مهارت الزامی است.',
  'settings.designSystems': 'سیستم‌های طراحی',
  'settings.designSystemsHint': 'سیستم‌های طراحی موجود را مرور و فعال کنید',
  'settings.designSystemsInstalled': 'نصب‌شده',
  'settings.designSystemsAdd': 'افزودن سیستم طراحی',
  'settings.designSystemsHiddenCount': '{count} مورد از گالری خانه پنهان شده',
  'settings.designSystemsShowAll': 'نمایش همه',
  'settings.designSystemsShowHidden': 'نمایش پنهان‌ها',
  'settings.designSystemsSource': 'منبع',
  'settings.designSystemsSourceLocal': 'محلی',
  'settings.designSystemsSourceGithub': 'GitHub',
  'settings.designSystemsSourceShadcn': 'shadcn',
  'settings.designSystemsShadcnReference': 'ارجاع مخزن shadcn',
  'settings.designSystemsImportShadcn': 'درون‌ریزی از shadcn',
  'settings.designSystemsStructure': 'ساختار',
  'settings.designSystemsModeHybrid': 'ترکیبی',
  'settings.designSystemsModeNormalized': 'نرمال‌شده',
  'settings.designSystemsModeVerbatim': 'بدون تغییر',
  'settings.designSystemsCraft': 'ساخت',
  'settings.designSystemsCraftColor': 'رنگ',
  'settings.designSystemsCraftAccessibility': 'دسترس‌پذیری',
  'settings.designSystemsGithubUrl': 'نشانی GitHub',
  'settings.designSystemsProjectPath': 'مسیر پروژه',
  'settings.designSystemsImportGithub': 'درون‌ریزی از GitHub',
  'settings.designSystemsImportProject': 'درون‌ریزی از پروژه',
  'settings.designSystemsImportedStatus': '{title} درون‌ریزی شد',
  'settings.designSystemsViewImported': 'مشاهده سیستم طراحی درون‌ریزی‌شده',
  'settings.designSystemsCategory': 'دسته‌بندی',
  'settings.designSystemsAllCategories': 'همه دسته‌بندی‌ها',
  'settings.designSystemsShowInHomeGallery': 'نمایش در گالری خانه',
  'settings.projectLocations': 'مکان‌های پروژه',
  'settings.projectLocationsHint': 'ریشه‌های ذخیره‌سازی فضای کاری',
  'settings.projectLocationsDescription': 'پایه‌های کاری اضافه کنید که می‌توانند چند پوشهٔ پروژهٔ Open Design را در خود داشته باشند. پروژه‌های جدید به‌صورت یک پوشه داخل پایهٔ انتخاب‌شده ذخیره می‌شوند.',
  'settings.projectLocationsSaveError': 'ذخیرهٔ مکان‌های پروژه ممکن نشد. بررسی کنید هر مسیر یک پوشهٔ قابل دسترسی باشد.',
  'settings.projectLocationsSaved': 'مکان‌های پروژه ذخیره شد.',
  'settings.projectLocationsScanError': 'اسکن مکان‌های پروژه ممکن نشد.',
  'settings.projectLocationsScanComplete': 'اسکن کامل شد: {imported} وارد شد، {existing} از قبل ثبت شده بود.',
  'settings.projectLocationsNoFolderSelected': 'پوشه‌ای انتخاب نشد.',
  'settings.projectLocationsDuplicate': 'این پایهٔ کاری قبلاً اضافه شده است.',
  'settings.projectLocationsWorkBaseMeta': 'پایهٔ کاری · پروژه‌ها اینجا به‌صورت زیرپوشه ساخته می‌شوند',
  'settings.projectLocationsAddFolder': 'افزودن پوشه…',
  'settings.projectLocationsDefaultBadge': 'مکان پیش‌فرض',
  'settings.projectLocationsMakeDefault': 'تنظیم به‌عنوان پیش‌فرض',
  'settings.projectLocationsDefaultSaved': 'مکان پیش‌فرض پروژه به‌روزرسانی شد.',
  'settings.librarySkills': 'مهارت‌ها',
  'settings.libraryDesignSystems': 'سیستم‌های طراحی',
  'settings.librarySearch': 'جستجو...',
  'settings.libraryAll': 'همه',
  'settings.libraryPreview': 'پیش‌نمایش',
  'settings.libraryPreviewClose': 'بستن',
  'settings.libraryLoading': 'در حال بارگذاری...',
  'settings.libraryNoResults': 'هیچ موردی با جستجوی شما مطابقت ندارد.',
  'settings.libraryEnabled': 'فعال',
  'settings.libraryDisabled': 'غیرفعال',
  'settings.connectorsNavHint': 'اتصال‌های سیستم‌های خارجی',
  'settings.connectorsHint': 'تنظیمات کانکتورها و ارائه‌دهندگان ابزار را برای این دستگاه مدیریت کنید.',
  'settings.connectorsComposioApiKey': 'کلید API کامپوزیو',
  'settings.connectorsSavedTitle': 'در daemon محلی ذخیره شد',
  'settings.connectorsSavedWithTail': 'ذخیره شد · ••••{tail}',
  'settings.connectorsSaved': 'ذخیره شد',
  'settings.connectorsGetApiKey': 'دریافت کلید API',
  'settings.connectorsReplaceKeyPlaceholder': 'برای جایگزینی کلید ذخیره‌شده، کلید جدید را جای‌گذاری کنید',
  'settings.connectorsApiKeyPlaceholder': 'کلید API کامپوزیو را جای‌گذاری کنید',
  'settings.connectorsClear': 'پاک کردن',
  'settings.connectorsClearConfirmTitle': 'کلید API ذخیره‌شدهٔ Composio پاک شود؟',
  'settings.connectorsClearConfirmBody': 'حذف کلید همهٔ کانکتورهای Composio متصل به این فضای کاری را قطع می‌کند. حساب‌های متصل، مجوزهای OAuth و دسترسی ابزارها همگی حذف خواهند شد.',
  'settings.connectorsClearConfirmContinue': 'ادامه',
  'settings.connectorsClearFinalTitle': 'این کار همهٔ کانکتورها را قطع می‌کند',
  'settings.connectorsClearFinalBody': 'بازگشتی وجود ندارد. پس از چسباندن کلید جدید باید هر ادغام را از ابتدا دوباره متصل کنید.',
  'settings.connectorsClearFinalConfirm': 'حذف کلید و قطع اتصال',
  'settings.connectorsClearArming': 'یک لحظه…',
  'settings.connectorsClearCancel': 'انصراف',
  'settings.connectorsSaveKey': 'ذخیره کلید',
  'settings.connectorsSaveKeyTitle': 'ارسال این کلید به daemon محلی',
  'settings.connectorsKeySaving': 'در حال ذخیره…',
  'settings.connectorsKeySaved': 'ذخیره شد ✓',
  'settings.connectorsKeyError': 'ذخیره کلید ممکن نشد. بررسی کنید daemon محلی در حال اجراست و دوباره تلاش کنید.',
  'settings.connectorsHelpSaved': 'کلید شما کاتالوگ پایین را باز می‌کند و در daemon محلی می‌ماند. برای جایگزینی، کلید جدیدی جای‌گذاری کنید یا برای حذف، پاک کنید.',
  'settings.connectorsHelpUnsaved': 'تغییرات ذخیره‌نشده — برای ذخیرهٔ این اعتبارنامه در daemon محلی و باز کردن کاتالوگ پایین، روی «ذخیره کلید» بزنید.',
  'settings.connectorsHelpEmpty': 'برای باز کردن کاتالوگ پایین، یک کلید اضافه کنید. کلیدها به‌صورت محلی در daemon ذخیره می‌شوند و هرگز از طریق متغیرهای محیطی ارسال نمی‌شوند.',
  'settings.connectorsLoadingSavedKey': 'در حال بررسی کلید ذخیره‌شده در daemon محلی…',
  'settings.autosaveSaving': 'در حال ذخیره…',
  'settings.autosaveSaved': 'همهٔ تغییرات ذخیره شد',
  'settings.autosaveError': 'تغییرات ذخیره نشد. ممکن است daemon محلی آفلاین باشد.',
  'settings.libraryToggleLabel': 'تغییر وضعیت',
  'settings.memory': 'حافظه',
  'settings.memoryHint': 'حقایق و زمینهٔ ذخیره‌شده برای گفت‌وگوهای آینده',
  'settings.customInstructionsTitle': 'قواعد سراسری',
  'settings.customInstructionsHint': 'دستورالعمل‌های ثابتی که Open Design باید در هر گفت‌وگو دنبال کند. حقایق، ترجیحات و زمینهٔ پروژه را به‌عنوان حافظه ذخیره کنید.',
  'settings.customInstructionsPlaceholder': 'مثلاً «همیشه از TypeScript استفاده کن. کامپوننت‌های تابعی را ترجیح بده. پاسخ‌ها را مختصر نگه دار.»',
  'settings.memoryDescription': 'تعیین کنید که آیا حقایق، ترجیحات و زمینهٔ پروژهٔ ذخیره‌شده در گفت‌وگوهای آینده دوباره استفاده شوند یا خیر.',
  'settings.memoryEnabled': 'فعال',
  'settings.memoryDisabled': 'غیرفعال',
  'settings.memoryEnableLabel': 'فعال‌سازی تزریق حافظه',
  'settings.memoryDisabledBanner': 'حافظه در حال حاضر خاموش است. حقایق موجود روی دیسک حفظ می‌شوند اما در گفت‌وگوهای جدید لحاظ نخواهند شد و نوبت‌های جدید چیز تازه‌ای استخراج نمی‌کنند.',
  'settings.memoryNew': 'حافظهٔ جدید',
  'settings.memoryEdit': 'ویرایش',
  'settings.memoryDelete': 'حذف',
  'settings.memoryPreview': 'پیش‌نمایش',
  'settings.memoryEmpty': 'هنوز حافظه‌ای وجود ندارد.',
  'settings.memoryEmptyHintZh': '记住: 用户偏好深色主题',
  'settings.memoryEmptyHintEn': 'حالت تیره را ترجیح می‌دهم',
  'settings.memoryName': 'مثلاً ترجیحات رابط کاربری',
  'settings.memoryDesc': 'یک جمله — این حافظه دربارهٔ چیست؟',
  'settings.memoryBody': '- قانون یک\n- قانون دو\n\nچرا: دلیل اختیاری\nزمان اعمال: محدودهٔ اختیاری',
  'settings.memoryBodyHint': 'ابتدا قوانین را به‌صورت فهرستی بنویسید، سپس خطوط اختیاری چرا و زمان اعمال را اضافه کنید. Markdown پشتیبانی می‌شود. یا روی یک نمونهٔ شروع در بالا کلیک کنید تا یک مثال کاربردی بارگذاری شود.',
  'settings.memoryStartersLabel': 'به نقطهٔ شروع نیاز دارید؟ برای پر کردن فرم کلیک کنید:',
  'settings.memoryStarterUserName': 'نقش من',
  'settings.memoryStarterUserDesc': 'من یک مهندس فرانت‌اند هستم که روی یک ابزار طراحی SaaS کار می‌کند',
  'settings.memoryStarterUserBody': '- نقش: مهندس ارشد فرانت‌اند\n- پشته: React، TypeScript، Vite\n- حوزه: ابزارهای طراحی / همکاری\n- منطقه زمانی: GMT+8 (Asia/Shanghai)\n\nزمان اعمال: هر گفتگو — مثال‌ها را حول فرانت‌اند وب تنظیم کن.',
  'settings.memoryStarterFeedbackName': 'ترجیحات رابط کاربری',
  'settings.memoryStarterFeedbackDesc': 'حالت تیره، متن بدنهٔ بزرگ، چگالی اطلاعات پایین',
  'settings.memoryStarterFeedbackBody': '- تم: به‌طور پیش‌فرض تیره\n- متن بدنه: ≥ ۱۸px\n- چگالی اطلاعات: فضای خالی را ترجیح بده، آیتم‌های کمتر در هر صفحه\n\nچرا: خستگی چشم کمتر در جلسات طولانی.\nزمان اعمال: هرگاه UI، صفحات وب یا اسلاید تولید می‌کنی.',
  'settings.memoryStarterProjectName': 'پروژهٔ فعلی',
  'settings.memoryStarterProjectDesc': 'Open Design v0.5 — ویرایشگر طراحی مبتنی بر گفتگو',
  'settings.memoryStarterProjectBody': '- هدف: عرضهٔ ویرایشگر مبتنی بر گفت‌وگو در این فصل\n- اولویت‌ها: رندر جریانی، چندرسانه‌ای محلی، آفلاین-اول\n- پشته: Next.js 16، دیمن Express، SQLite\n\nزمان اعمال: در هر گفت‌وگویی دربارهٔ این پروژه.',
  'settings.memorySaveHint': 'به‌طور خودکار ذخیره نمی‌شود — برای اعمال روی Create / Save کلیک کنید.',
  'settings.memoryIndexSaveHint': 'ویرایش‌های فهرست به‌طور خودکار ذخیره نمی‌شوند — برای اعمال روی Save index کلیک کنید.',
  'settings.memoryIndexUnsaved': 'تغییرات ذخیره‌نشده',
  'settings.memoryFlashCreated': '✓ حافظه ایجاد شد',
  'settings.memoryFlashSaved': '✓ حافظه ذخیره شد',
  'settings.memoryFlashDeleted': '✓ حافظه حذف شد',
  'settings.memoryFlashIndexSaved': '✓ فهرست ذخیره شد',
  'settings.memoryFlashPathCopied': '✓ مسیر کپی شد',
  'settings.memoryNameLabel': 'عنوان',
  'settings.memoryTypeLabel': 'نوع',
  'settings.memoryDescLabel': 'توضیحات',
  'settings.memoryBodyLabel': 'محتوا',
  'settings.memoryTypeUser': 'کاربر',
  'settings.memoryTypeFeedback': 'بازخورد',
  'settings.memoryTypeProject': 'پروژه',
  'settings.memoryTypeReference': 'مرجع',
  'settings.memoryIndex': 'MEMORY.md (فهرست)',
  'settings.memoryIndexSave': 'ذخیرهٔ فهرست',
  'settings.memoryIndexReset': 'بازنشانی',
  'settings.memoryToastChanged': 'حافظه به‌روزرسانی شد',
  'settings.memoryToastClickHint': 'مشاهده',
  'settings.memoryAll': 'همه',
  'settings.memoryExtractions': 'تاریخچهٔ استخراج',
  'settings.memoryExtractionsHint': 'ابتدا Regex اجرا می‌شود و LLM در پس‌زمینه اجرا می‌شود.',
  'settings.memoryExtractionsEmpty': 'هنوز استخراجی وجود ندارد. نوبت بعدی گفت‌وگو این فهرست را پر خواهد کرد.',
  'settings.memoryExtractionsRefresh': 'تازه‌سازی',
  'settings.memoryExtractionsRefreshing': 'در حال به‌روزرسانی…',
  'settings.memoryExtractionPhaseRunning': 'در حال اجرا…',
  'settings.memoryExtractionPhaseSuccess': 'موفق',
  'settings.memoryExtractionPhaseSkipped': 'رد شده',
  'settings.memoryExtractionPhaseFailed': 'ناموفق',
  'settings.memoryExtractionSkipNoProvider': 'هیچ API key برای استخراج حافظه با LLM پیکربندی نشده است.',
  'settings.memoryExtractionSkipDisabled': 'حافظه غیرفعال است.',
  'settings.memoryExtractionSkipEmpty': 'پیام کاربر خالی است — چیزی برای استخراج وجود ندارد.',
  'settings.memoryExtractionSkipNoMatch': 'هیچ الگوی regex در این نوبت مطابقت نداشت.',
  'settings.memoryExtractionKindHeuristic': 'عبارت باقاعده',
  'settings.memoryExtractionKindLlm': 'LLM',
  'settings.memoryExtractionProviderEnv': 'env',
  'settings.memoryExtractionProviderMediaConfig': 'تنظیمات رسانه',
  'settings.memoryExtractionProviderOverride': 'تنظیمات حافظه',
  'settings.memoryExtractionProposed': 'پیشنهادشده',
  'settings.memoryExtractionWritten': 'نوشته‌شده',
  'settings.memoryExtractionDuration': 'in',
  'settings.memoryExtractionDelete': 'حذف',
  'settings.memoryExtractionsClear': 'پاک کردن',
  'settings.memoryExtractionsClearTitle': 'پاک کردن همه تاریخچه استخراج',
  'settings.memoryExtractionsClearConfirm': 'همه تاریخچه استخراج پاک شود؟ این کار قابل بازگشت نیست.',
  'settings.memoryNoProviderBannerTitle': 'استخراج حافظه با LLM در حال اجرا نیست',
  'settings.memoryNoProviderBannerBody': 'هیچ API key برای استخراج‌کننده حافظه یافت نشد. برای فعال‌سازی استخراج مبتنی بر LLM، یک OpenAI key در بخش ارائه‌دهندگان رسانه اضافه کنید یا ANTHROPIC_API_KEY / OPENAI_API_KEY را در محیط تنظیم کنید. استخراج اکتشافی با regex همچنان فعال است.',
  'settings.libraryInstall': 'نصب',
  'settings.libraryInstallGithub': 'GitHub',
  'settings.libraryInstallLocal': 'مسیر محلی',
  'settings.libraryInstallUrl': 'https://github.com/owner/repo',
  'settings.libraryInstallPath': '/path/to/skill-folder',
  'settings.libraryInstallButton': 'نصب',
  'settings.libraryUninstall': 'حذف',
  'settings.libraryBuiltIn': 'داخلی',
  'settings.libraryInstalled': 'نصب شده',
  'notify.successTitle': 'وظیفه تکمیل شد',
  'notify.failureTitle': 'وظیفه ناموفق بود',
  'notify.successBody': 'یک نوبت به پایان رسید.',
  'notify.failureBody': 'وظیفه با خطا پایان یافت.',
  'updater.available': 'به‌روزرسانی موجود است',
  'updater.availableBody': 'Open Design {version} موجود است. پیش از باز شدن نصب‌کننده دانلود می‌شود.',
  'updater.checking': 'در حال بررسی به‌روزرسانی‌ها',
  'updater.download': 'دانلود به‌روزرسانی',
  'updater.downloading': 'در حال دانلود به‌روزرسانی',
  'updater.downloadingPercent': 'در حال دانلود به‌روزرسانی {percent}%',
  'updater.done': 'انجام شد',
  'updater.failed': 'به‌روزرسانی ناموفق بود',
  'updater.installerOpenBody': 'نصب‌کننده باز است. Open Design در حال بسته شدن است تا بتوانید به‌روزرسانی را کامل کنید.',
  'updater.installerOpened': 'نصب‌کننده باز شد',
  'updater.later': 'بعداً',
  "updater.allowSilentUpdates": "اجازه به‌روزرسانی بی‌صدا",
  'updater.openFailedFallback': 'نصب‌کننده باز نشد.',
  'updater.installRestart': 'Install and restart',
  'updater.installingRestart': 'Installing and restarting...',
  'updater.openInstaller': 'نصب به‌روزرسانی',
  'updater.opening': 'در حال باز کردن نصب‌کننده...',
  'updater.payloadReadyGeneric': 'A new Open Design update is ready. Open Design will close and restart automatically.',
  'updater.payloadReadyVersion': 'Open Design {version} is ready. Open Design will close and restart automatically.',
  'updater.quitButton': 'بستن Open Design',
  'updater.quitFailedBody': 'نصب‌کننده باز است، اما Open Design بسته نشد. پیش از جایگزینی برنامه، Open Design را ببندید.',
  'updater.quitFailedTitle': 'امکان بستن نیست',
  'updater.quitting': 'در حال بستن...',
  'updater.ready': 'به‌روزرسانی آماده است',
  'updater.readyGeneric': 'نسخه جدید آماده است. Open Design بسته می‌شود و نصب‌کننده را باز می‌کند.',
  'updater.readyVersion': 'Open Design {version} آماده است. Open Design بسته می‌شود و نصب‌کننده را باز می‌کند.',
  'updater.upToDate': 'شما هم‌اکنون آخرین نسخه را دارید.',
  'whatsNew.cta': 'تازه‌ها را ببینید',
  'whatsNew.dismissAria': 'بستن تازه‌ها',
  'newsletter.label': 'Newsletter (optional)',
  'newsletter.placeholder': 'you@studio.com',
  'settings.memoryModelInlineLabel': 'Memory model',
  'settings.memoryModelInlineSameAsChat': 'Same as chat',
  'settings.memoryModelInlineSameAsChatWithModel': 'Same as chat ({model})',
  'settings.memoryModelInlineSameAsChatWithProvider': 'Same as chat ({provider})',
  'settings.memoryModelInlineHintCli': 'Optional. The memory extractor uses an env-var or media-providers API key on this provider; pinning a model here just overrides the auto-pick.',
  'settings.memoryModelInlineHintCliConstrained': 'Optional. Memory will call {provider}; needs an env-var or media-providers API key for that provider, or pick a model below to override.',
  'settings.memoryModelInlineHintByok': 'Optional. Reuses your chat API key on the same provider — picking a different (usually cheaper) model only changes the request body.',
  'settings.memoryModelInlineFlashSaved': 'Saved',
  'settings.memoryModelInlineFlashCleared': 'Cleared',
  'settings.orbit.eyebrow': 'اتوماسیون',
  'settings.orbit.title': 'Orbit',
  'settings.orbit.navHint': 'خلاصهٔ روزانهٔ کانکتورها',
  'settings.orbit.lede': 'فعالیت کانکتورها را طبق زمان‌بندی جمع‌آوری کن و نتیجه را به‌صورت یک live artifact قابل تازه‌سازی منتشر کن.',
  'settings.orbit.statusOnTitle': 'اجرای روزانهٔ زمان‌بندی‌شده روشن است',
  'settings.orbit.statusOffTitle': 'اجرای روزانهٔ زمان‌بندی‌شده خاموش است',
  'settings.orbit.statusActive': 'فعال',
  'settings.orbit.statusOff': 'خاموش',
  'settings.orbit.runTitle': 'یک اجرای Orbit را شروع کن و گفت‌وگوی زنده را باز کن',
  'settings.orbit.running': 'در حال اجرا…',
  'settings.orbit.runOpen': 'همین حالا اجرا کن',
  'settings.orbit.dailySummaryTitle': 'خلاصهٔ روزانه',
  'settings.orbit.dailySummarySub': 'روزی یک‌بار در زمان محلی زمان‌بندی‌شده اجرا می‌شود.',
  'settings.orbit.on': 'روشن',
  'settings.orbit.off': 'خاموش',
  'settings.orbit.runTimeTitle': 'زمان اجرا',
  'settings.orbit.runTimeSub': 'پیش‌فرض 08:00. برای اعمال در زمان‌بندی daemon ذخیره کنید.',
  'settings.orbit.runTimeAria': 'زمان اجرای روزانهٔ Orbit',
  'settings.orbit.nextRun': 'اجرای بعدی',
  'settings.orbit.nextRunScheduledAfterSave': 'پس از ذخیره زمان‌بندی می‌شود',
  'settings.orbit.schedule': 'زمان‌بندی',
  'settings.orbit.pausedManualOnly': 'متوقف — فقط اجرای دستی',
  'settings.orbit.templateTitle': 'قالب prompt',
  'settings.orbit.templateMissing': 'قالب {id} نصب نشده است.',
  'settings.orbit.templateMissingOption': '{id} (موجود نیست)',
  'settings.orbit.templateMissingInstall': 'برای هدایت prompt یک skill مربوط به Orbit نصب کنید.',
  'settings.orbit.templateMissingPickAnother': 'از فهرست، قالب دیگری انتخاب کنید.',
  'settings.orbit.templateResetTitle': 'بازنشانی به {id}',
  'settings.orbit.templateReset': 'بازنشانی',
  'settings.orbit.templateHelp': 'Orbit را با یک skill هدایت کنید — prompt نمونهٔ قالب انتخاب‌شده در هر اجرای Orbit وارد می‌شود تا خلاصه‌ها شکل همان قالب را دنبال کنند.',
  'settings.orbit.templateAria': 'قالب prompt مربوط به Orbit',
  'settings.orbit.templatesLoading': 'در حال بارگذاری قالب‌ها…',
  'settings.orbit.templatesOptgroup': 'قالب‌های skills مربوط به Orbit',
  'settings.orbit.lastRun': 'آخرین اجرا',
  'settings.orbit.triggerManual': 'دستی',
  'settings.orbit.triggerScheduled': 'زمان‌بندی‌شده',
  'settings.orbit.meterAria': '{succeeded} موفق، {skipped} رد شده، {failed} ناموفق از {checked} بررسی‌شده',
  'settings.orbit.countChecked': 'بررسی‌شده',
  'settings.orbit.countSucceeded': 'موفق',
  'settings.orbit.countSkipped': 'رد شده',
  'settings.orbit.countFailed': 'ناموفق',
  'settings.orbit.runError': 'اجرای Orbit ممکن نبود. مطمئن شوید daemon محلی در حال اجراست و کانکتورها پیکربندی شده‌اند.',
  'settings.orbit.gateAriaLabel': 'برای استفاده از Orbit به اتصال‌دهنده نیاز است',
  'settings.orbit.gateEyebrow': 'پیکربندی لازم است',
  'settings.orbit.gateTitle': 'یک ابزار را متصل کنید تا Orbit کار کند',
  'settings.orbit.gateBody': 'Orbit فعالیت اتصال‌دهنده‌های شما را خلاصه می‌کند. هنوز چیزی متصل نکرده‌اید — حداقل یک یکپارچه‌سازی اضافه کنید تا Orbit چیزی برای گزارش داشته باشد.',
  'settings.orbit.gateBodyNoKey': 'Orbit فعالیت اتصال‌دهنده‌ها را خلاصه می‌کند و اتصال‌دهنده‌ها از طریق Composio اجرا می‌شوند. یک کلید API از Composio در بخش اتصال‌دهنده‌ها اضافه کنید تا کاتالوگ باز شود و اولین یکپارچه‌سازی خود را انتخاب کنید.',
  'settings.orbit.gateAction': 'باز کردن اتصال‌دهنده‌ها',
  'settings.orbit.gateActionNoKey': 'پیکربندی Composio',
  'settings.orbit.gateLoading': 'در حال بررسی اتصال‌دهنده‌ها…',
  'settings.orbit.controlsLockedBadge': 'قفل شده',
  'settings.orbit.controlsLockedHint': 'برای باز کردن زمان‌بندی و قالب Orbit یک ابزار را متصل کنید.',
  'settings.orbit.artifactKickerLive': 'اثر زنده',
  'settings.orbit.artifactKickerLegacy': 'خلاصهٔ قدیمی',
  'settings.orbit.artifactTitle': 'خلاصهٔ روزانهٔ فعالیت Orbit',
  'settings.orbit.artifactMetaLive': 'artifact HTML قابل تازه‌سازی که از فعالیت کانکتورها ساخته شده است.',
  'settings.orbit.artifactMetaLegacy': 'پیش از فعال شدن پشتیبانی live artifact تولید شده — برای انتشار یکی، Orbit را دوباره اجرا کنید.',
  'settings.orbit.copyMarkdownTitle': 'کپی خلاصهٔ Markdown در کلیپ‌بورد',
  'settings.orbit.copied': 'کپی شد',
  'settings.orbit.copy': 'کپی',
  'settings.orbit.openArtifact': 'باز کردن artifact',
  'settings.orbit.sourceMarkdown': 'Markdown منبع',
  'settings.memoryModelInlineHintByokNeutral': 'حافظه از مدلی جدا از چت استفاده می‌کند. به‌طور پیش‌فرض از مدل چت شما استفاده می‌کند.',
  'settings.memoryTypeProfile': 'نمایه',
  'settings.memoryTypeRule': 'قانون',
  'settings.memoryTabMemories': 'خاطرات',
  'settings.memoryTabMemoriesCaption': 'مشاهده و مدیریت حافظهٔ ذخیره‌شده',
  'settings.memoryTabHow': 'نحوهٔ کار',
  'settings.memoryTabHowCaption': 'دو حلقه و کنترل‌های آن‌ها',
  'settings.memoryAddDisclosure': 'افزودن یا وارد کردن خاطرات',
  'settings.memoryAddDisclosureHint': 'نمایه، ورود دستی یا برنامه‌های متصل',
  'settings.memoryProfileTab': 'نمایهٔ کاری',
  'settings.memoryProfileTabCaption': 'اینکه چه کسی هستید و پیش‌فرض‌هایتان چیست',
  'settings.memoryProfileTitle': 'نمایهٔ کاری شما',
  'settings.memoryProfileHint': 'چند حقیقت دربارهٔ شما و پیش‌فرض‌هایتان. حافظه این موارد را پیش از هر کار تزریق می‌کند تا agent از یک درخواست کوتاه منظور شما را دریابد.',
  'settings.memoryProfileName': 'نمایهٔ کاری',
  'settings.memoryProfileDescription': 'نقش، شرکت، حوزه، مخاطب، سلیقه و پیش‌فرض‌هایی که دستیار باید دوباره استفاده کند.',
  'settings.memoryProfileSave': 'ذخیرهٔ نمایه',
  'settings.memoryProfileSaving': 'در حال ذخیره…',
  'settings.memoryProfileSaved': 'نمایه ذخیره شد',
  'settings.memoryProfileRole': 'نقش',
  'settings.memoryProfileRolePlaceholder': 'مثلاً Founder، طراح، PM',
  'settings.memoryProfileCompany': 'شرکت / تیم',
  'settings.memoryProfileCompanyPlaceholder': 'مثلاً Acme، تیم رشد',
  'settings.memoryProfileDomain': 'حوزه',
  'settings.memoryProfileDomainPlaceholder': 'مثلاً B2B SaaS، fintech، devtools',
  'settings.memoryProfileAudience': 'مخاطب اصلی',
  'settings.memoryProfileAudiencePlaceholder': 'مثلاً مدیران، مهندسان، کاربران نهایی',
  'settings.memoryProfileAesthetic': 'زیبایی‌شناسی / سلیقه',
  'settings.memoryProfileAestheticPlaceholder': 'مثلاً تمیز و editorial، پس‌زمینه‌های روشن، فضای خالی فراوان',
  'settings.memoryProfileDeliverables': 'خروجی‌های پیش‌فرض',
  'settings.memoryProfileDeliverablesPlaceholder': 'مثلاً landing pages، اسلاید، one-pager',
  'settings.memoryProfileLocale': 'منطقه / زبان',
  'settings.memoryProfileLocalePlaceholder': 'مثلاً English (US)، چینی ساده‌شده',
  'settings.memoryProfileGoals': 'اهداف فعلی',
  'settings.memoryProfileGoalsPlaceholder': 'مثلاً عرضهٔ صفحهٔ قیمت‌گذاری جدید، افزایش نرخ تبدیل در مسیر آزمایشی',
  'settings.memoryHooksTitle': 'قلاب‌های حافظه',
  'settings.memoryHooksHint': 'انتخاب کنید کدام بخش‌های حافظه به‌صورت خودکار اجرا شوند. کلید اصلی بالا همهٔ آن‌ها را خاموش می‌کند.',
  'settings.memoryHooksProfileLabel': 'استفاده از نمایهٔ من',
  'settings.memoryHooksProfileDesc': 'نمایهٔ کاری شما را در هر کار تزریق می‌کند.',
  'settings.memoryHooksRewriteLabel': 'بازنویسی درخواست‌های کوتاه',
  'settings.memoryHooksRewriteDesc': 'PRE: یک درخواست کوتاه را به یک شرح کار کامل گسترش می‌دهد.',
  'settings.memoryHooksVerifyLabel': 'تأیید خودکار خروجی',
  'settings.memoryHooksVerifyDesc': 'POST: نتیجه را در برابر قوانین شما بررسی می‌کند و سپس کارنامه را نشان می‌دهد.',
  'settings.memoryHooksExtractionLabel': 'یادگیری از گفت‌وگوها',
  'settings.memoryHooksExtractionDesc': 'حقایق و ترجیحات مفید را از نوبت‌های گفت‌وگو ثبت می‌کند.',
  'artifact.odCardTaskBriefChip': 'حافظه اعمال شد · مشاهدهٔ شرح',
  'artifact.odCardScorecardTitle': 'بررسی خودکار',
  'artifact.odCardScorecardStatusPass': 'قبول شد',
  'artifact.odCardScorecardStatusPartial': 'جزئی',
  'artifact.odCardScorecardStatusFail': 'نیازمند کار',
  'artifact.odCardRuleKicker': 'قانون پیشنهادی',
  'artifact.odCardRuleNameLabel': 'نام',
  'artifact.odCardRuleDescriptionLabel': 'توضیحات',
  'artifact.odCardRuleAssertionLabel': 'باید برقرار باشد',
  'artifact.odCardRuleCheckLabel': 'نحوهٔ بررسی',
  'artifact.odCardRuleRationaleLabel': 'چرا',
  'artifact.odCardRuleKeep': 'نگه‌داشتن',
  'artifact.odCardRuleEdit': 'ویرایش',
  'artifact.odCardRuleDone': 'انجام شد',
  'artifact.odCardRuleDiscard': 'دور انداختن',
  'artifact.odCardRuleSaving': 'در حال ذخیره…',
  'artifact.odCardRuleSaved': '«{name}» به‌عنوان یک قانون ذخیره شد',
  'artifact.odCardRuleError': 'ذخیرهٔ قانون ممکن نشد. دوباره تلاش کنید.',
  'artifact.odCardBrandAssistDone': 'Browser assist confirmed',
  'artifact.odCardBrandAssistKicker': 'Browser assist needed: {reason}',
  'artifact.odCardBrandAssistBody': 'Open Browser and clear any human check. Then click More, choose Download Page, wait for the saved snapshot success, and use the left Next Step card to continue extraction.',
  'artifact.odCardBrandAssistError': 'Could not start browser assist. Try again.',
  'artifact.odCardBrandAssistWorking': 'Starting...',
  'artifact.odCardBrandAssistConfirm': 'Open browser assist',
  'diagnostics.exportTitle': 'صادر کردن تشخیص',
  'diagnostics.exportButton': 'صادر کردن تشخیص',
  'diagnostics.exportHint': 'گزارش‌های اخیر برنامه و اطلاعات دستگاه را در یک فایل zip بسته‌بندی می‌کند تا برای تیم ارسال شود.',
  'diagnostics.exporting': 'در حال صادر کردن…',
  'diagnostics.exportSuccess': 'تشخیص در {path} ذخیره شد',
  'diagnostics.exportFailed': 'صادر کردن تشخیص ناموفق بود: {message}',
  'automations.eyebrow': 'جلسات زمان‌بندی‌شده Agent',
  'automations.title': 'خودکارسازی‌ها',
  'automations.lede': 'مکالمات تکرارشونده را برای کار پروژه، خلاصه‌های Orbit و آرتیفکت‌های زنده برنامه‌ریزی کنید.',
  'automations.summaryAria': 'خلاصه خودکارسازی',
  'automations.metricActive': 'فعال',
  'automations.metricPaused': 'متوقف‌شده',
  'automations.metricTemplates': 'قالب‌ها',
  'automations.newAutomation': 'خودکارسازی جدید',
  'automations.yourAutomations': 'خودکارسازی‌های شما',
  'automations.loading': 'در حال بارگذاری',
  'automations.emptyTitle': 'هنوز خودکارسازی‌ای وجود ندارد',
  'automations.emptyBody': 'یکی را از روی قالب بسازید یا با یک زمان‌بندی خالی شروع کنید.',
  'automations.targetNewEachRun': 'پروژه جدید در هر اجرا',
  'automations.targetCreateEachRun': 'پروژه جدید در هر اجرا',
  'automations.lastRun': 'آخرین اجرا {time}',
  'automations.openResult': 'باز کردن نتیجه',
  'automations.run': 'اجرا',
  'automations.runNowTitle': 'اکنون اجرا کن و مکالمه را باز کن',
  'automations.history': 'تاریخچه',
  'automations.hideHistory': 'پنهان کردن تاریخچه',
  'automations.edit': 'ویرایش',
  'automations.pause': 'توقف',
  'automations.resume': 'ازسرگیری',
  'automations.deleteAria': 'حذف خودکارسازی',
  'automations.deleteTitle': 'حذف این خودکارسازی',
  'automations.deleteConfirm': 'این خودکارسازی حذف شود؟ اجراهای گذشته و پروژه‌های آن‌ها حفظ می‌شوند.',
  'automations.proposalsTitle': 'پیشنهادهای تکامل',
  'automations.proposalsSub': 'خروجی خودکارسازی را پیش از آن‌که حافظه، مهارت‌ها یا سیستم‌های طراحی را تغییر دهد بررسی کنید.',
  'automations.proposalsPending': '{n} در انتظار',
  'automations.apply': 'اعمال',
  'automations.reject': 'رد کردن',
  'automations.proposalsDismissReason': 'در خودکارسازی‌ها نادیده گرفته شد',
  'automations.templatesTitle': 'قالب‌ها',
  'automations.templatesSub': 'Orbit و آرتیفکت‌های زنده قالب‌هایی درون همان جریان خودکارسازی هستند.',
  'automations.templatesCount': '{filtered} از {total}',
  'automations.templateFiltersAria': 'فیلترهای قالب',
  'automations.templatesEmptyTitle': 'هنوز قالبی در این دسته وجود ندارد.',
  'automations.templatesEmptyBody': 'فیلتر دیگری را امتحان کنید، یا از یک خودکارسازی خالی شروع کنید.',
  'automations.useTemplate': 'استفاده از قالب',
  'automations.runHistoryLoading': 'در حال بارگذاری تاریخچه اجرا...',
  'automations.runHistoryEmpty': 'هنوز اجرایی وجود ندارد.',
  'automations.runHistoryTitle': 'تاریخچه اجرا',
  'automations.runHistoryLatest': '۱۰ مورد اخیر',
  'automations.crystallize': 'تثبیت',
  'automations.crystallizing': 'در حال تثبیت',
  'automations.crystallizeTitle': 'تهیه پیش‌نویس پیشنهادهای مهارت و حافظه از این اجرا',
  'automations.crystallizeFailed': 'Crystallize failed: {error}',
  'automations.crystallizePartialSuccess': 'Crystallize created proposals, but Automations could not refresh the proposal list. Review the visible proposals or try refreshing.',
  'automations.crystallizeRefreshFailed': 'Crystallize finished, but Automations could not refresh proposals. Try refreshing before running it again.',
  'automations.crystallizeNoProposals': 'Crystallize finished, but no proposals were returned. Try refreshing or check the run details.',
  'automations.openConversation': 'باز کردن مکالمه',
  'automations.runHistoryAria': 'تاریخچه اجرای خودکارسازی',
  'automations.proposalsAria': 'پیشنهادهای تکامل خودکارسازی',
  'automations.templatesAria': 'قالب‌های خودکارسازی',
  'automations.runInProgress': 'در حال انجام',
  'automations.promptPlaceholder': 'فعالیت دیروز GitHub و Linear را دریافت کن و خلاصه‌ای از تغییرات ارائه بده.',
  'automations.scheduleStatusPaused': 'متوقف‌شده',
  'automations.nextRunManualOnly': 'فقط دستی',
  'automations.nextRunScheduled': 'زمان‌بندی‌شده',
  'automations.nextRunAt': 'بعدی {time}',
  'automations.statusSucceeded': 'موفق',
  'automations.statusFailed': 'ناموفق',
  'automations.statusRunning': 'در حال اجرا',
  'automations.statusQueued': 'در صف',
  'automations.statusCanceled': 'لغو شد',
  'automations.kindOrbit': 'Orbit',
  'automations.kindLiveArtifact': 'آرتیفکت زنده',
  'automations.kindAutomation': 'خودکارسازی',
  'automations.proposalTargetMemory': 'حافظه',
  'automations.proposalTargetDesignSystem': 'سیستم طراحی',
  'automations.proposalTargetSkill': 'مهارت',
  'automations.proposalTargetTemplate': 'قالب خودکارسازی',
  'automations.proposalActionCreate': 'ایجاد',
  'automations.proposalActionUpdate': 'به‌روزرسانی',
  'automations.proposalActionMerge': 'ادغام',
  'automations.proposalActionMove': 'انتقال',
  'automations.proposalActionDelete': 'حذف',
  'automations.proposalActionPromote': 'ارتقا',
  'automations.filterAll': 'همه',
  'automations.filterOrbit': 'Orbit',
  'automations.filterLiveArtifacts': 'آرتیفکت‌های زنده',
  'automations.filterMemory': 'حافظه',
  'automations.filterDesignSystems': 'سیستم‌های طراحی',
  'automations.filterSkills': 'مهارت‌ها',
  'automations.filterConnectors': 'کانکتورها',
  'automations.filterCompression': 'فشرده‌سازی',
  'automations.filterRelease': 'انتشار',
  'automations.filterQuality': 'کیفیت',
  'automations.tpl.memoryRefresh.title': 'به‌روزرسانی حافظه پروژه بر اساس کارهای اخیر.',
  'automations.tpl.memoryRefresh.desc': 'تصمیم‌ها، ترجیحات و بازخوردهای تکراری را به به‌روزرسانی‌های حافظه قابل‌استفاده‌مجدد تبدیل می‌کند.',
  'automations.tpl.designSystemRefresh.title': 'به‌روزرسانی سیستم‌های طراحی بر اساس آرتیفکت‌های منتشرشده.',
  'automations.tpl.designSystemRefresh.desc': 'توکن‌ها، کامپوننت‌ها و قواعد قابل‌استفاده‌مجدد را در کارهای طراحی اخیر پیدا می‌کند.',
  'automations.tpl.liveArtifactRegistry.title': 'بررسی آرتیفکت‌های زنده و به‌روزرسانی نسخه‌های قدیمی.',
  'automations.tpl.liveArtifactRegistry.desc': 'داشبوردها، گزارش‌ها و پیش‌نمایش‌های پایدار را به‌جای تکثیرشان، به‌روز نگه می‌دارد.',
  'automations.tpl.orbitDashboard.title': 'ساخت داشبورد فعالیت کانکتورها.',
  'automations.tpl.orbitDashboard.desc': 'کانکتورهای انتخاب‌شده را در یک داشبورد زنده به سبک Orbit گردآوری می‌کند.',
  'automations.tpl.releaseNotes.title': 'تهیه پیش‌نویس یادداشت‌های انتشار از کارهای طراحی منتشرشده.',
  'automations.tpl.releaseNotes.desc': 'PRهای ادغام‌شده، آرتیفکت‌ها و تغییرات مرتبط با محصول را به یادداشت‌های انتشار پیوند می‌دهد.',
  'automations.tpl.qualityRegressionWatch.title': 'پایش پسرفت‌های طراحی و پیاده‌سازی.',
  'automations.tpl.qualityRegressionWatch.desc': 'تغییرات اخیر را با معیارها، ردیابی‌ها و مراجع پذیرفته‌شده مقایسه می‌کند.',
  'automations.tpl.orbitDaily.title': 'خلاصه روزانه کانکتورها.',
  'automations.tpl.orbitDaily.desc': 'خلاصه فعالیت کانکتورها را طبق زمان‌بندی به‌روز می‌کند.',
  'automations.tpl.liveStatusBoard.title': 'تازه نگه داشتن یک آرتیفکت وضعیت زنده.',
  'automations.tpl.liveStatusBoard.desc': 'به‌جای ساختن گزارش جدید در هر اجرا، یک آرتیفکت پایدار را به‌روز می‌کند.',
  'dsManager.areaAria': 'بخش سیستم‌های طراحی',
  'dsManager.tabDesignSystem': 'سیستم طراحی',
  'dsManager.tabTemplate': 'قالب',
  'dsManager.sourceAria': 'منبع سیستم طراحی',
  'dsManager.templateSourceAria': 'منبع قالب',
  'dsManager.yourSystems': 'سیستم‌های شما',
  'dsManager.officialPresets': 'پیش‌تنظیم‌های رسمی',
  'dsManager.enterprise': 'سازمانی',
  'dsManager.yourTemplates': 'قالب‌های شما',
  'dsManager.yourSystemsAria': 'سیستم‌های طراحی شما',
  'dsManager.eyebrowDesignSystems': 'سیستم‌های طراحی',
  'dsManager.yourSystemsHeading': 'سیستم‌های شما',
  'dsManager.filterAria': 'فیلتر سیستم‌های طراحی',
  'dsManager.filterAll': 'همه',
  'dsManager.filterPublished': 'منتشرشده',
  'dsManager.filterDraft': 'پیش‌نویس',
  'dsManager.createTitle': 'ساخت سیستم طراحی جدید',
  'dsManager.createBody': 'برند، محصول، کد، دارایی‌ها و مراجع طراحی خود را به Open Design بیاموزید.',
  'dsManager.createAction': 'ساختن',
  'dsManager.emptyMine': 'هنوز سیستم طراحی‌ای وجود ندارد. یکی را از روی بافت واقعی محصول بسازید، پیش‌نویس را بررسی کنید، سپس آن را برای پروژه‌های آینده منتشر کنید.',
  'dsManager.badgeDefault': 'پیش‌فرض',
  'dsManager.rowMetaUpdated': 'شما · به‌روزرسانی {date}',
  'dsManager.edit': 'ویرایش',
  'dsManager.openSystem': 'باز کردن',
  'dsManager.editWithAgent': 'ویرایش با Agent',
  'dsManager.downloadTitle': 'دانلود سیستم طراحی (.zip + SKILLS.md)',
  'dsManager.downloadAria': 'دانلود {title} به‌صورت .zip',
  'dsManager.downloadFailed': 'دانلود سیستم طراحی ممکن نشد. دوباره تلاش کنید.',
  'dsManager.deleteConfirm': '«{title}» حذف شود؟ این کار پیش‌نویس سیستم طراحی را از این دستگاه حذف می‌کند.',
  'dsManager.makeDefault': 'تنظیم به‌عنوان پیش‌فرض',
  'dsManager.statusPublished': 'منتشرشده',
  'dsManager.statusDraft': 'پیش‌نویس',
  'dsManager.openSystemAria': 'باز کردن {title}',
  'dsManager.deleteSystemAria': 'حذف {title}',
  'dsManager.presetsAria': 'پیش‌تنظیم‌های رسمی سیستم طراحی',
  'dsManager.eyebrowLibrary': 'کتابخانه',
  'dsManager.eyebrowTemplates': 'قالب‌ها',
  'dsManager.yourTemplatesAria': 'قالب‌های شما',
  'dsManager.emptyTemplates': 'هنوز قالبی وجود ندارد. پس از فعال شدن انتشار قالب، می‌توانید از طریق اشتراک‌گذاری یکی را از هر پروژه تولیدشده بسازید.',
  'dsManager.templateDescFallback': 'ساخته‌شده از یک پروژه',
  'dsManager.comingSoonBadge': 'به‌زودی',
  'dsManager.enterpriseDsTitle': 'سیستم‌های طراحی سازمانی',
  'dsManager.enterpriseDsBody': 'سیستم‌های طراحی مشترک تیمی و کتابخانه‌های برند مدیریت‌شده به‌زودی ارائه می‌شوند.',
  'dsManager.enterpriseTplTitle': 'قالب‌های سازمانی',
  'dsManager.enterpriseTplBody': 'قالب‌های تأییدشده تیمی و انتشار در سطح سازمان به‌زودی ارائه می‌شوند.',
  'settings.instructionsTitle': 'دستورالعمل‌ها / قواعد',
  'settings.instructionsSubtitle': 'رفتار ثابتی که دستیار باید از آن پیروی کند',
  'settings.instructionsNavSub': 'رفتار ثابت دستیار',
  'settings.customInstructionsDesc': 'دستورالعمل‌های ثابتی که Open Design در هر گفت‌وگو از آن‌ها پیروی می‌کند. این‌ها حافظه ذخیره‌شده نیستند؛ برای واقعیت‌ها، ترجیحات و بافت پروژه از حافظه استفاده کنید.',
  'mcpClient.forwardedToLabel': 'ارسال‌شده به:',
  'mcpClient.notForwardedToLabel': 'ارسال‌نشده به:',
  'mcpClient.forwardedAcpNote': 'آداپتورهای ACP که با stdio علامت‌گذاری شده‌اند فقط سرورهای MCP از نوع stdio را از این فهرست دریافت می‌کنند؛ ورودی‌های HTTP و SSE هنگام راه‌اندازی حذف می‌شوند.',
  'mcpClient.notForwardedNote': 'برای آن Agentها، سرورهای MCP را در فایل پیکربندی خودِ Agent تنظیم کنید (مثلاً ~/.codex/config.toml، ~/.gemini/settings.json)؛ سرورهای زیر در آن‌جا بی‌سروصدا بلااستفاده می‌مانند.',

  // Brands library + extraction
  'brand.libraryTitle': 'کیت برند',
  'brand.librarySubtitle': 'Teach Open Design your brand kits — extract one from a website, then apply it in any chat.',
  'brand.newBrand': 'New Brand Kit',
  'brand.searchPlaceholder': 'Search your brand kits…',
  'brand.empty': 'No brand kits yet. Extract one from a website to get started.',
  'brand.colorsCount': '{count} colors',
  'brand.extracting': 'Extracting…',
  'brand.failed': 'Extraction failed',
  'brand.needsInput': 'Needs input',
  'brand.needsInputHint': 'Extraction paused — open the project to finish verification or answer the question.',
  'brand.appliedToChat': 'Using {name}',
  'brand.previewEmpty': 'Select a brand to preview',
  'brand.viewDetails': 'View details',
  'newBrand.title': 'New Brand',
  'newBrand.subtitle': 'یک وب‌سایت را بچسبانید یا برندی را در پایین انتخاب کنید تا رنگ‌ها، فونت‌ها و لوگوی آن را استخراج کنیم.',
  'newBrand.urlLabel': 'Brand website',
  'newBrand.urlPlaceholder': 'yourcompany.com',
  'newBrand.extract': 'Extract brand',
  'newBrand.cancel': 'Cancel',
  'newBrand.close': 'Close',
  'newBrand.stage1': 'Fetching the site & measuring its design',
  'newBrand.stage2': 'Building a brand preview',
  'newBrand.stage3': 'Deriving & registering the design system',
  'newBrand.measured': '{colors} colors · {fonts} fonts · {logos} logos',
  'newBrand.done': 'Brand ready',
  'brandDetail.identity': 'Identity',
  'brandDetail.designLanguage': 'Design Language',
  'brandDetail.colors': 'Colors',
  'brandDetail.fonts': 'Fonts',
  'brandDetail.tone': 'Tone',
  'brandDetail.aesthetic': 'Aesthetic',
  'brandDetail.tagline': 'Tagline',
  'brandDetail.voice': 'Voice',
  'brandDetail.useInChat': 'Use in new chat',
  'brandDetail.delete': 'Delete brand',
  'brandDetail.back': 'کیت برند',
  'brandDetail.refining': 'Refining this brand…',
  'brandDetail.notFound': 'Brand not found.',
  'brandDetail.logo': 'Logo',
  'brandDetail.typography': 'Typography',
  'brandDetail.palette': 'Palette',
  'brandDetail.voiceTone': 'Voice & tone',
  'brandDetail.imageryLayout': 'Imagery & layout',
  'brandDetail.images': 'Images',
  'brandDetail.designSystem': 'Design system',
  'brandDetail.brandAssets': 'Brand assets',
  'brandDetail.openProject': 'Open project',
  'brandDetail.themeLight': 'Light',
  'brandDetail.themeDark': 'Dark',
  'brandDetail.subjects': 'Subjects',
  'brandDetail.treatment': 'Treatment',
  'brandDetail.useLabel': 'Use',
  'brandDetail.avoidLabel': 'Avoid',
  'brandDetail.layoutPosture': 'Layout posture',
  'brandDetail.deleteConfirm': 'Delete "{name}"? This removes the brand and its design system.',
  'brandDetail.viewMore': 'Show all {count}',
  'brandDetail.viewLess': 'Show less',
  'settings.resetOnboarding': 'Reset onboarding',
  'settings.resetOnboardingDesc': 'Replay the first-run setup, including brand extraction.',
  'settings.resetOnboardingButton': 'Reset',
  'onboarding.brandTitle': 'Extract your brand kit',
  'onboarding.brandSubtitle': 'Paste a website and we\'ll turn its brand signals into a reusable brand kit for future work.',
  'onboarding.brandSkip': 'Skip for now',
  'onboarding.brandDone': 'Brand kit extracted',
  'onboarding.buildTitle': 'یک‌بار بسازید، همه‌جا استفاده کنید',
  'onboarding.buildBody': 'Open Design برند شما را به یک سیستم طراحی قابل‌استفاده‌ی مجدد تبدیل می‌کند و هر چیزی را که می‌سازید هماهنگ و وفادار به برند نگه می‌دارد.',
  'onboarding.buildBenefitMemoryTitle': 'One brand memory',
  'onboarding.buildBenefitMemoryBody': 'Colors, type, spacing, components, and voice become a DESIGN.md your agents can reuse.',
  'onboarding.buildBenefitAlignedTitle': 'Every output stays aligned',
  'onboarding.buildBenefitAlignedBody': 'Prototype, slide, PDF, dashboard, and marketing work all pull from the same rules.',
  'onboarding.buildBenefitSourcesTitle': 'Start from what you have',
  'onboarding.buildBenefitSourcesBody': 'Use a GitHub repo, website, existing DESIGN.md, screenshots, fonts, or Figma files.',
  'onboarding.buildPreviewLabel': 'Brand system',
  'onboarding.buildStart': 'ساخت سیستم طراحی',
  'onboarding.buildHome': 'رفتن به خانه',
  'dsCreate.referenceLabel': 'Copy from existing design system',
  'dsCreate.referenceLoading': 'Loading DESIGN.md...',
  'dsCreate.referenceLoadFailed': 'Could not load that design system.',
  'dsCreate.heroShowGuideAria': 'Show design system guide',
  'dsCreate.heroHideGuideAria': 'Hide design system guide',
  'dsCreate.heroShowGuideTitle': 'Show guide',
  'dsCreate.heroHideGuideTitle': 'Hide guide',
  'dsCreate.heroGuide': 'Guide',
  'dsCreate.missingSourceError': 'Add a website, DESIGN.md, description, file, Figma source, or notes to create a design system.',
  'dsCreate.continueToGeneration': 'Continue to generation',
  'dsCreate.embeddedTitle': 'Generate from your material',
  'dsCreate.embeddedBody': 'Start with a website or brand reference, then add any source files you already have.',
  'dsCreate.sourceSectionTitle': 'Extract from GitHub, websites, or source material',
  'dsCreate.sourceSectionBody': 'Start with a GitHub repo, website, DESIGN.md, or files that show your style. Open Design first creates a usable system quickly, then AI can refine it inside the project.',
  'dsCreate.githubWebsiteLabel': 'GitHub or website',
  'dsCreate.add': 'Add',
  'dsCreate.startFromBrand': 'Start from a brand',
  'dsCreate.brandPickerSubtitle': 'Search hundreds of brands — pick one and we\'ll add its site as a style reference.',
  'dsCreate.brandPickerQuickPicks': 'Popular brands — click to add',
  'dsCreate.addedSourceLinks': 'Added source links',
  'dsCreate.openSourceLabel': 'Open {label}',
  'dsCreate.removeSourceLabel': 'Remove {label}',
  'dsCreate.addFiles': 'Add files',
  'dsCreate.describeBrand': 'Describe brand',
  'dsCreate.optional': 'optional',
  'dsCreate.describeBrandHelp': 'Brand voice, intro and product context. Used in the fast pass and AI refinement.',
  'dsCreate.companyPlaceholder': 'e.g. Mission Impastabowl: fast-casual pasta restaurant with kiosk, mobile app and website',
  'dsCreate.pasteDesignMd': 'Paste DESIGN.md',
  'dsCreate.pasteDesignMdHelp': 'Paste a DESIGN.md to create directly from tokens, rationale and component guidance.',
  'dsCreate.reference': 'Reference',
  'dsCreate.designMdViewMode': 'DESIGN.md view mode',
  'dsCreate.advancedToggle': 'Advanced — repo, local code, Figma',
  'dsCreate.githubRepo': 'GitHub repo',
  'dsCreate.localCodeLabel': 'Link local code',
  'dsCreate.localCodeHelper': 'Use a folder or selected files from this computer.',
  'dsCreate.localCodePrompt': 'Drag a folder here or browse',
  'dsCreate.uploadFigLabel': 'Upload .fig',
  'dsCreate.uploadFigHelper': 'Decoded on your machine into real tokens, components & assets — no Figma account.',
  'dsCreate.uploadFigPrompt': 'Drop .fig here or browse',
  'dsCreate.figmaUrl': 'Figma URL',
  'dsCreate.figmaPlaceholder': 'https://figma.com/design/… or /file/…',
  'dsCreate.addedFigmaUrls': 'Added Figma URLs',
  'dsCreate.savedFigmaHelp': 'Saved as a Figma design source. The agent uses it as the canonical reference; export a .fig above for a full offline decode.',
  'dsCreate.notes': 'Notes',
  'dsCreate.notesPlaceholder': 'e.g. We use a warm, earthy color palette with rounded corners. Our brand voice is playful but professional...',
  'dsCreate.back': 'Back',
  'dsCreate.generate': 'Generate',
  'dsCreate.libraryPickerTitle': 'Select from library',
  'dsCreate.libraryPickerConfirm': 'Add to assets',
  'dsCreate.designMdPreviewKicker': 'DESIGN SYSTEM',
  'dsCreate.designMdPreviewTitle': 'DESIGN.md preview',
  'dsCreate.componentKit': 'component kit',
  'dsCreate.defaultTheme': 'default theme',
  'dsCreate.componentKitTitle': '{name} — component kit',
  'dsCreate.designMdGeneratedDescription': 'Generated from pasted DESIGN.md tokens, rationale and component guidance.',
  'dsCreate.previewButtons': 'Buttons',
  'dsCreate.previewButtonsHelp': 'Five types across three sizes.',
  'dsCreate.buttonPrimary': 'Primary',
  'dsCreate.buttonDashed': 'Dashed',
  'dsCreate.buttonText': 'Text',
  'dsCreate.buttonLink': 'Link',
  'dsCreate.sizeSmall': 'Small',
  'dsCreate.sizeMedium': 'Medium',
  'dsCreate.sizeLarge': 'Large',
  'dsCreate.previewTypeScale': 'Type scale',
  'dsCreate.extractedTokens': 'Extracted DESIGN.md tokens',
  'brandPicker.heading': 'از برندی که دوست دارید شروع کنید',
  'brandPicker.subtext': 'روی هر برند کلیک کنید تا کیت آن مستقیماً از وب‌سایتش استخراج شود.',
  'brandPicker.quickPicksLabel': 'برندهای محبوب — برای استخراج کلیک کنید',
  'brandPicker.searchPlaceholder': 'جستجوی برندها…',
  'brandPicker.allCategories': 'همه',
  'brandPicker.extractAction': 'استخراج',
  'brandPicker.showMore': 'نمایش بیشتر',
  'brandPicker.opening': 'در حال شروع استخراج — در حال باز کردن {brand}…',
  'ds.kitVisualize': 'نمایش',
  'ds.kitEdit': 'ویرایش',
  'ds.kitSource': 'منبع',
  'ds.saveDesignMd': 'ذخیره DESIGN.md',
  'ds.saving': 'در حال ذخیره…',
  'ds.copyDesignMd': 'کپی DESIGN.md',
  'ds.editDesignMd': 'ویرایش DESIGN.md',
  'ds.openDesignMd': 'باز کردن DESIGN.md',
  'ds.copyDesignMdModule': 'کپی بخش {module}',
  'ds.editDesignMdModule': 'ویرایش بخش {module}',
  'ds.openDesignMdModule': 'باز کردن بخش {module}',
  'ds.uploadMd': 'بارگذاری MD',
  'ds.uploadFont': 'افزودن فایل فونت',
  'ds.pasteImage': 'چسباندن تصویر',
  'ds.refresh': 'تازه‌سازی',
  'ds.download': 'دانلود',
  'ds.importFolder': 'وارد کردن پوشه',
  'ds.reset': 'بازنشانی',
  'ds.editingDesignMdHint': 'ویرایش این Markdown ماژول‌های رندرشده کیت را به‌روزرسانی می‌کند.',
  'ds.editingModuleHint': 'فقط ماژول {module} ویرایش می‌شود.',
  'ds.manualEditModuleHint': 'Edit {module} here. Hover this section to reveal controls.',
  'ds.saveModule': 'ذخیره ماژول',
  'ds.uploadLogo': 'بارگذاری لوگو',
  'ds.uploadImage': 'بارگذاری تصویر',
  'ds.uploading': 'در حال بارگذاری…',
  'ds.moduleEmptyLogo': 'هنوز لوگویی نیست',
  'ds.moduleEmptyFonts': 'هیچ فونتی ثبت نشده است.',
  'ds.actionDone': 'انجام شد',
  'ds.actionFailed': 'مشکلی پیش آمد. دوباره تلاش کنید.',
  'ds.uploadDone': 'بارگذاری شد',
  'ds.uploadFailed': 'بارگذاری ناموفق بود. دوباره تلاش کنید.',
  'ds.deleteLogo': 'حذف لوگو',
  'ds.deleteImage': 'حذف {caption}',
  'ds.deleteProjectConfirm': '«{title}» حذف شود؟ این کار این سیستم طراحی و پروژه آن را برای همیشه از این دستگاه حذف می‌کند.',
  'ds.deleteProjectAction': 'حذف {title}',
  'ds.editColor': 'ویرایش {name}',
  'ds.colorLabel': 'رنگ',
  'ds.hexLabel': 'Hex',
  'ds.hexValueLabel': 'مقدار Hex',
  'ds.saveColor': 'ذخیره رنگ',
  'ds.invalidHexColor': 'یک رنگ Hex معتبر وارد کنید، مانند #FF6A3D.',
  'ds.colorSaveFailed': 'ذخیره این رنگ ممکن نشد.',
  'ds.colorResetFailed': 'بازنشانی این رنگ ممکن نشد.',
  'ds.designMdSectionLabel': 'بخش {module} در DESIGN.md',
  'ds.kitErrorTitle': 'این نما با مشکلی مواجه شد.',
  'ds.kitErrorRetry': 'بارگذاری مجدد',
  'ds.shortcutsLabel': 'میان‌برهای صفحه‌کلید',
  'ds.shortcutsHint': 'میان‌برها: E ویرایش · C کپی · U بارگذاری · R تازه‌سازی · ⌫ حذف لوگو',
  'ds.moduleEmptyImages': 'هنوز تصویری نیست',
  'ds.noOriginalColor': 'No original color is available for this swatch.',
  'ds.manifestReadFailed': 'Unable to read _ds_manifest.json.',
  'ds.reviewCollapseSection': 'Collapse {title}',
  'ds.reviewExpandSection': 'Expand {title}',
  'ds.reviewNeedsReview': 'Needs review',
  'ds.reviewLooksGood': 'Looks good',
  'ds.reviewActionsLabel': '{title} review',
  'ds.reviewNeedsWorkEllipsis': 'Needs work...',
  'ds.reviewEditFile': 'Edit {file}',
  'ds.reviewFeedbackLabel': 'Tell the agent what to change',
  'ds.reviewFeedbackPlaceholder': 'e.g. tighten spacing in {title}, regenerate this preview...',
  'ds.reviewChangedAfterFeedback': 'This section changed after your feedback. Review it again before publishing.',
  'ds.reviewChangedDuringRun': 'This section changed during the latest run. Review it before publishing.',
  'ds.reviewLastFeedback': 'Last feedback',
  'ds.previewGenerating': 'Generating preview...',
  'ds.creatingProjectTitle': 'Creating your design system...',
  'ds.creatingProjectSubtitle': 'Keep this tab open. You can come back in a few minutes.',
  'ds.generationProgressLabel': 'Design system generation progress {progress}%',
  'ds.publishRepoRequiredTitle': 'Finish importing your GitHub repo before you can publish.',
  'ds.publishDesignSystem': 'Publish design system',
  'ds.unpublishDesignSystem': 'Unpublish design system',
  'ds.published': 'Published',
  'ds.publish': 'Publish',
  'ds.extractionRunningTitle': 'Extracting design system',
  'ds.extractionCompleteTitle': 'Extraction complete',
  'ds.extractionRunningBody': 'Open Design is updating this system in place.',
  'ds.extractionCompleteBody': 'All extracted modules are shown below; empty sections are intentionally blank.',
  'ds.publishCardPublished': 'Your team\'s new projects can use this design system as context by default.',
  'ds.publishCardDraft': 'Your design system is ready, but your feedback will improve it. Publish it when it is ready to use in future projects.',
  'ds.useSystemTitle': 'Use this system',
  'ds.useSystemBody': 'Start a new design that inherits this system\'s colors, type, and components - kept on-brand automatically.',
  'ds.createNewDesign': 'Create new design',
  'ds.openSourceContext': 'Open source context',
  'ds.manifestNeedsAttention': 'Design manifest needs attention',
  'ds.openManifest': 'Open manifest',
  'ds.workspacePreparing': 'Preparing the design system workspace.',
  'ds.workspaceLoadingLabel': 'Design system workspace is loading',
  'ds.sectionQueued': 'Queued',
  'ds.sectionReviewUpdatedFiles': 'Updated files need review',
  'ds.reviewNeedsWork': 'Needs work',
  'ds.sectionRequiredFileMissing': 'Required file missing: {file}',
  'ds.sectionNoFilesYet': 'No files yet',
  'ds.generationSourceTitle': 'Source context',
  'ds.generationSourceDetail': 'Reading linked source context and repository evidence.',
  'ds.generationGuidanceTitle': 'Brand guidance',
  'ds.generationGuidanceDetail': 'Writing DESIGN.md guidance and voice.',
  'ds.generationTokensTitle': 'Design tokens',
  'ds.generationTokensDetail': 'Extracting colors, type, and spacing tokens.',
  'ds.generationPreviewsTitle': 'Preview cards',
  'ds.generationPreviewsDetail': 'Rendering reviewable preview cards.',
  'ds.generationUiKitTitle': 'UI kit',
  'ds.generationUiKitDetail': 'Creating reusable components and patterns.',
  'ds.generationAssetsTitle': 'Brand assets',
  'ds.generationAssetsDetail': 'Collecting logos, fonts, images, and icons.',
  'ds.phaseQueuedTypography': 'Typography queued',
  'ds.phaseQueuedTokens': 'Tokens queued',
  'ds.phaseQueuedSpacing': 'Spacing queued',
  'ds.phaseQueuedUiKit': 'UI kit queued',
  'ds.phaseQueuedAssets': 'Assets queued',
  'ds.phaseReadingTypography': 'Reading typography',
  'ds.phaseReadingTokens': 'Reading tokens',
  'ds.phaseReadingSpacing': 'Reading spacing',
  'ds.phaseReadingUiKit': 'Reading UI kit',
  'ds.phaseReadingAssets': 'Reading assets',
  'ds.phaseWritingTypography': 'Writing typography',
  'ds.phaseWritingTokens': 'Writing tokens',
  'ds.phaseWritingSpacing': 'Writing spacing',
  'ds.phaseBuildingUiKit': 'Building UI kit',
  'ds.phaseUpdatingAssets': 'Updating assets',
  'ds.phaseNeedsAttention': 'Needs attention',
  'ds.phaseUpdated': 'Updated',
  'ds.sectionActivityFromTodo': '{phase}: {todo}',
  'ds.sectionActivityReadFiles': 'Read {files}',
  'ds.sectionActivityPhaseFiles': '{phase}: {files}',
  'ds.sectionRunningReadingContext': 'Reading context for {title}.',
  'ds.sectionRunningNow': '{phase} now.',
  'ds.reviewLastReviewed': 'Last reviewed {time}',
  'ds.agentFeedbackQueued': 'Agent feedback queued',
  'ds.agentFeedbackSent': 'Agent feedback sent',
  'ds.agentFeedbackSentAt': 'Agent feedback sent {time}',
  'ds.agentFeedbackFailedWithError': 'Agent feedback failed: {error}',
  'ds.agentFeedbackFailed': 'Agent feedback failed',
  'ds.agentFeedbackUnknown': 'Agent feedback status unknown',
  'ds.repoConnectBannerTitle': 'Connect your repo to pull aspects of your design system',
  'ds.repoConnectCardTitle': 'Connect your repo',
  'ds.repoConnectPendingBody': 'Checking your GitHub connection...',
  'ds.repoConnectPendingButton': 'Checking GitHub...',
  'ds.repoConnectedTitle': 'GitHub is connected',
  'ds.repoConnectedBody': 'Re-import this repo to pull its files into your design system.',
  'ds.repoImportButton': 'Import repo',
  'ds.repoConnectBannerBody': 'Connect GitHub so Open Design can read your repository and pull colors, type, and components into this design system.',
  'ds.repoConnectCardBody': 'Pull colors, type, and components from your repository into this design system.',
  'ds.repoConnectButton': 'Connect GitHub',
  'newproj.startFromLabel': 'شروع از',
  'newproj.startBlank': 'خالی',
  'newproj.startBlankHint': 'شروع از صفر',
  'workspace.pages': 'صفحه‌ها',
  'workspace.allProjectFiles': 'همه فایل‌های پروژه',
  'workspace.newBlankPage': 'صفحه خالی جدید',
  'workspace.noPagesYet': 'هنوز صفحه‌ای وجود ندارد',
  'workspace.pageCreateFailed': 'ایجاد صفحه ممکن نشد.',
  'workspace.pageCreatorTitle': 'ایجاد صفحه',
  'workspace.pageCreatorSearch': 'جستجوی قالب‌ها',
  'workspace.pageCreatorCategoryAll': 'همه سناریوها',
  'workspace.pageCreatorEmpty': 'هیچ نوع صفحه‌ای با جستجوی شما مطابقت ندارد.',
  'workspace.pageCreatorPreview': 'پیش‌نمایش',
  'workspace.pageCreatorUse': 'استفاده',
  'fileViewer.presentInTabDeckHint': 'یادداشت‌های سخنران در پنجره بازشو',
  'fileViewer.presentEscHint': 'برای خروج Esc را فشار دهید',
  'fileViewer.presenterPause': 'توقف',
  'fileViewer.presenterResume': 'ادامه',
  'fileViewer.presenterPrevious': 'قبلی',
  'fileViewer.presenterNext': 'بعدی',
  'questions.uploadingFiles': 'در حال بارگذاری فایل‌ها…',
  'questions.uploadNeedsProject': 'بارگذاری فایل به یک پروژه فعال نیاز دارد.',
  'questions.uploadPartialFailed': '{uploaded} فایل بارگذاری شد، اما {failed} ناموفق بود.',
  'questions.uploadFailed': 'بارگذاری {failed} فایل ناموفق بود.',
};
